/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _init = __webpack_require__(1);
	
	var _init2 = _interopRequireDefault(_init);
	
	var _modal = __webpack_require__(37);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _header = __webpack_require__(38);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _founder = __webpack_require__(39);
	
	var _founder2 = _interopRequireDefault(_founder);
	
	var _card = __webpack_require__(40);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _donate = __webpack_require__(41);
	
	var _donate2 = _interopRequireDefault(_donate);
	
	var _products = __webpack_require__(42);
	
	var _products2 = _interopRequireDefault(_products);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _init2.default)();
	(0, _modal2.default)();
	(0, _header2.default)();
	(0, _founder2.default)();
	(0, _card2.default)();
	(0, _donate2.default)();
	(0, _products2.default)();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = init;
	
	var _links = __webpack_require__(2);
	
	var _links2 = _interopRequireDefault(_links);
	
	var _tracking = __webpack_require__(4);
	
	var _tracking2 = _interopRequireDefault(_tracking);
	
	var _scroller = __webpack_require__(5);
	
	var _scroller2 = _interopRequireDefault(_scroller);
	
	var _toggler = __webpack_require__(7);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	var _selector = __webpack_require__(11);
	
	var _selector2 = _interopRequireDefault(_selector);
	
	var _tracker = __webpack_require__(12);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _autosize = __webpack_require__(13);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _floatLabel = __webpack_require__(19);
	
	var _floatLabel2 = _interopRequireDefault(_floatLabel);
	
	var _validator = __webpack_require__(20);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _recaptcha = __webpack_require__(22);
	
	var _recaptcha2 = _interopRequireDefault(_recaptcha);
	
	var _lightbox = __webpack_require__(23);
	
	var _lightbox2 = _interopRequireDefault(_lightbox);
	
	var _playOnHover = __webpack_require__(25);
	
	var _playOnHover2 = _interopRequireDefault(_playOnHover);
	
	var _swiper = __webpack_require__(26);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _map = __webpack_require__(27);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _fade = __webpack_require__(28);
	
	var _fade2 = _interopRequireDefault(_fade);
	
	var _lazyLoad = __webpack_require__(30);
	
	var _lazyLoad2 = _interopRequireDefault(_lazyLoad);
	
	var _parallax = __webpack_require__(32);
	
	var _parallax2 = _interopRequireDefault(_parallax);
	
	var _reveal = __webpack_require__(33);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	var _sticky = __webpack_require__(35);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _inspectScroll = __webpack_require__(36);
	
	var _inspectScroll2 = _interopRequireDefault(_inspectScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function init() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    (0, _links2.default)(context);
	    (0, _tracking2.default)(context);
	    (0, _scroller2.default)(context);
	    (0, _toggler2.default)(context);
	    (0, _selector2.default)(context);
	    (0, _tracker2.default)(context);
	    (0, _autosize2.default)(context);
	    (0, _floatLabel2.default)(context);
	    (0, _validator2.default)(context);
	    (0, _recaptcha2.default)(context);
	    (0, _lightbox2.default)(context);
	    (0, _playOnHover2.default)(context);
	    (0, _swiper2.default)(context);
	    (0, _map2.default)(context);
	    (0, _fade2.default)(context);
	    (0, _lazyLoad2.default)(context);
	    (0, _parallax2.default)(context);
	    (0, _reveal2.default)(context);
	    (0, _sticky2.default)(context);
	    (0, _inspectScroll2.default)(context);
	}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = linksEnhancement;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assetExtensions = 'png jpg jpeg gif doc docx xls xlsx pdf ppt pptx'.split(' ');
	
	/**
	 * Improves the functionality of links depending on their URL's.
	 *
	 * @param context
	 */
	function linksEnhancement() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('a').each(function () {
	        var $a = (0, _jquery2.default)(this);
	        var href = String($a.attr('href'));
	
	        // Checks to make sure there are no `sw-*` properties on the element
	        var cleanLink = Array.from(this.attributes).reduce(function (acc, a) {
	            return acc && !/^sw-/.test(a.name);
	        }, true);
	
	        if (cleanLink) {
	
	            // Animates scroll for anchor links
	            if (href.startsWith('#')) {
	                $a.attr('sw-scroller', JSON.stringify({ to: href }));
	            }
	
	            // Forces new window clicks for asset files
	            var lowerHref = href.toLowerCase();
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = assetExtensions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var ext = _step.value;
	
	                    if (lowerHref.endsWith('.' + ext)) {
	                        $a.attr('target', '_blank');
	                        break;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	        }
	    });
	
	    // Force no focusing on links just clicked. This ensures no focus outline shows up after clicking.
	    $context.find('a, button').on('click', function () {
	        (0, _jquery2.default)(this).trigger('blur');
	    });
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = trackingEnhancement;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Enables automatic tracking on links and forms.
	 *
	 * @param context
	 */
	function trackingEnhancement() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
	
		var trackingElements = [{ selector: 'a[href^="mailto:"]', label: "Email click" }, { selector: 'a[href^="tel:"]', label: "Phone click" }];
	
		trackingElements.forEach(function (_ref) {
			var selector = _ref.selector,
			    label = _ref.label;
	
			$context.find(selector).attr('sw-tracker', JSON.stringify({ label: label }));
		});
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = scrollerDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $body = (0, _jquery2.default)('html, body');
	var docEl = document.documentElement;
	
	var breakable = true;
	var breakTimeout = null;
	var bound = false;
	
	/**
	 * Scrolls to a point on the page when an element is clicked.
	 *
	 * Scrolls to top: <button sw-scroller="top">Top</button>
	 * Scrolls to bottom: <button sw-scroller="bottom">Bottom</button>
	 * Scrolls to element by ID: <button sw-scroller="#element">Element</button>
	 *
	 * @param context
	 */
	function scrollerDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('[sw-scroller]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-scroller');
	        var settings = (0, _parse.directiveSettings)(json, {
	            to: 'top',
	            selector: null,
	            speed: 500
	        }, 'to');
	
	        $element.on('click', function (e) {
	            e.preventDefault();
	
	            clearInterval(breakTimeout);
	            breakable = false;
	            breakTimeout = setTimeout(function () {
	                return breakable = true;
	            }, 100);
	
	            var top = 0;
	            switch (settings.to) {
	                case 'top':
	                    top = 0;break;
	                case 'bottom':
	                    top = docEl.scrollHeight - docEl.clientHeight;break;
	                case 'element':
	                    top = (0, _jquery2.default)(settings.selector).offset().top;break;
	                default:
	                    top = (0, _jquery2.default)(settings.to).offset().top;
	            }
	
	            $body.animate({ scrollTop: Math.min(top, docEl.scrollHeight - docEl.clientHeight) }, { duration: settings.speed });
	        });
	    });
	
	    if (!bound) {
	        bound = true;
	        $body.bind('scroll mousedown DOMMouseScroll mousewheel keyup touchstart', function (e) {
	            if (breakable && e.which > 0) {
	                switch (e.type) {
	                    case 'mousedown':
	                    case 'mousewheel':
	                    case 'touchstart':
	                        $body.stop();break;
	                }
	            }
	        });
	    }
	}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.directiveSettings = directiveSettings;
	/**
	 * Parses the JSON from a directive.
	 *
	 * @param data
	 * @param defaults
	 * @param targetProperty
	 */
	function directiveSettings(data) {
	    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var targetProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var settings = Object.assign({}, defaults);
	
	    if (data) {
	        var parsedData = void 0;
	
	        try {
	            parsedData = JSON.parse(data);
	        } catch (e) {
	            parsedData = data;
	        }
	
	        if (parsedData instanceof Object && !Array.isArray(parsedData)) {
	            Object.assign(settings, parsedData);
	        } else if (targetProperty) {
	            settings[targetProperty] = parsedData;
	        } else {
	            console.error("Error parsing settings: \"" + data + "\"");
	        }
	    }
	
	    return settings;
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = togglerDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _toggler = __webpack_require__(8);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Toggles the visual display of an element on the page.
	 * Contains action directives for interacting with a toggler element:
	 *  - toggler-open
	 *  - toggler-close
	 *  - toggler-toggle
	 *  - toggler-select
	 *
	 * @param context
	 */
	function togglerDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('[sw-toggler]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-toggler');
	        var settings = (0, _parse.directiveSettings)(json, {
	            open: true,
	            transition: false
	        }, 'open');
	
	        var toggler = new _toggler2.default(this, settings);
	
	        $element.data('toggler', toggler);
	    });
	
	    var _arr = ['open', 'close', 'toggle'];
	
	    var _loop = function _loop() {
	        var action = _arr[_i];
	
	        $context.find('[sw-toggler-' + action + ']').each(function () {
	            var $element = (0, _jquery2.default)(this);
	            var json = $element.attr('sw-toggler-' + action);
	            var settings = (0, _parse.directiveSettings)(json, {
	                target: null,
	                on: 'click',
	                prevent: true
	            }, 'target');
	
	            $element.on(settings.on, function (e) {
	                var $target = settings.target ? (0, _jquery2.default)(settings.target) : $element.closest('[sw-toggler]');
	                var toggler = $target.data('toggler');
	
	                if (toggler) {
	                    toggler[action]();
	                }
	
	                if (settings.prevent) {
	                    e.preventDefault();
	                }
	            });
	        });
	    };
	
	    for (var _i = 0; _i < _arr.length; _i++) {
	        _loop();
	    }
	
	    /**
	     * Controls togglers with a <select> field
	     * Should be used with the selector directive for best usability
	     */
	    $context.find('select[sw-toggler-select]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	
	        var $options = $element.find('option');
	        var values = $options.toArray().map(function (el) {
	            return (0, _jquery2.default)(el).prop('value');
	        });
	        var togglers = values.map(function (v) {
	            return (0, _jquery2.default)(v).data('toggler');
	        });
	
	        togglers.forEach(function (toggler) {
	            if (toggler) {
	                var index = togglers.indexOf(toggler);
	                var value = values[index];
	
	                toggler.on('open', function () {
	                    return $element.val(value);
	                });
	            }
	        });
	
	        $element.on('change', function () {
	            var value = $element.val();
	            var index = values.indexOf(value);
	            var toggler = togglers[index];
	
	            toggler.open();
	        });
	    });
	
	    $context.find('[sw-toggler-class]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-toggler-class');
	        var settings = (0, _parse.directiveSettings)(json, {
	            target: null,
	            openClass: 'is-open',
	            closedClass: 'is-closed'
	        }, 'target');
	
	        var $target = settings.target ? (0, _jquery2.default)(settings.target) : $element.closest('[sw-toggler]');
	        var toggler = $target.data('toggler');
	
	        if (toggler) {
	            var updateClasses = function updateClasses() {
	                $element.removeClass(toggler.isOpen ? settings.closedClass : settings.openClass);
	                $element.addClass(toggler.isOpen ? settings.openClass : settings.closedClass);
	            };
	
	            toggler.on('toggle', updateClasses);
	            updateClasses();
	        }
	    });
	}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.transitionTypes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _emitter = __webpack_require__(9);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _drawing = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Map of transition types.
	 */
	var transitionTypes = exports.transitionTypes = {
	
	    css: {
	        init: function init(toggler) {
	            toggler.$element[0].addEventListener('transitionend', function (e) {
	                if (e.target === toggler.$element[0]) {
	                    toggler.transitionEnd();
	                }
	            });
	        }
	    },
	
	    height: {
	        init: function init(toggler) {
	            toggler.$element.css('display', toggler.isOpen ? '' : 'none');
	        },
	        start: function start(toggler) {
	            if (toggler.isOpen) {
	                toggler.$element.slideDown(300, function () {
	                    return toggler.transitionEnd();
	                });
	            } else {
	                toggler.$element.slideUp(300, function () {
	                    return toggler.transitionEnd();
	                });
	            }
	        },
	        skip: function skip(toggler) {
	            toggler.$element.css('display', toggler.isOpen ? '' : 'none');
	        }
	    }
	};
	
	/**
	 * Toggler class for toggling the visual state of an element.
	 */
	
	var Toggler = function (_Emitter) {
	    _inherits(Toggler, _Emitter);
	
	    /**
	     *
	     * @param element
	     * @param settings
	     */
	    function Toggler(element) {
	        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        _classCallCheck(this, Toggler);
	
	        var _this = _possibleConstructorReturn(this, (Toggler.__proto__ || Object.getPrototypeOf(Toggler)).call(this));
	
	        _this.$element = (0, _jquery2.default)(element);
	        _this.isOpen = typeof settings.open === 'boolean' ? settings.open : true;
	        _this.transition = settings.transition in transitionTypes ? settings.transition : false;
	
	        _this.transitionInit();
	        return _this;
	    }
	
	    /**
	     *
	     * @param isOpen
	     * @param transition
	     */
	
	
	    _createClass(Toggler, [{
	        key: 'toggle',
	        value: function toggle(isOpen, transition) {
	            isOpen = typeof isOpen === 'boolean' ? isOpen : !this.isOpen;
	            transition = typeof transition === 'boolean' ? transition : true;
	
	            if (this.isOpen !== isOpen) {
	                this.isOpen = isOpen;
	
	                if (this.transition && transition) {
	
	                    this.transitionStart();
	                } else {
	
	                    this.$element.removeClass('is-before-opening is-opening is-before-closing is-closing').toggleClass('is-open', this.isOpen).toggleClass('is-closed', !this.isOpen);
	
	                    this.transitionSkip();
	                }
	
	                this.trigger('toggle');
	                this.trigger(this.isOpen ? 'open' : 'close');
	            }
	        }
	
	        /**
	         *
	         * @param transition
	         */
	
	    }, {
	        key: 'open',
	        value: function open(transition) {
	            this.toggle(true, transition);
	        }
	
	        /**
	         *
	         * @param transition
	         */
	
	    }, {
	        key: 'close',
	        value: function close(transition) {
	            this.toggle(false, transition);
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionInit',
	        value: function transitionInit() {
	            this.$element.removeClass('is-before-opening is-opening is-before-closing is-closing').toggleClass('is-open', this.isOpen).toggleClass('is-closed', !this.isOpen);
	
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.init) {
	                transitionType.init(this);
	            }
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionStart',
	        value: function transitionStart() {
	
	            if (this.isOpen) {
	
	                if (this.$element.hasClass('is-before-closing')) {
	
	                    this.$element.removeClass('is-before-closing').addClass('is-open');
	                } else if (this.$element.hasClass('is-closing')) {
	
	                    this.$element.removeClass('is-before-closing is-closing').addClass('is-opening');
	                } else {
	
	                    this.$element.removeClass('is-closed').addClass('is-before-opening');
	
	                    (0, _drawing.redraw)(this.$element);
	
	                    this.$element.removeClass('is-before-opening').addClass('is-opening');
	                }
	            } else {
	
	                if (this.$element.hasClass('is-before-opening')) {
	
	                    this.$element.removeClass('is-before-opening').addClass('is-closed');
	                } else if (this.$element.hasClass('is-opening')) {
	
	                    this.$element.removeClass('is-opening').addClass('is-closing');
	                } else {
	
	                    this.$element.removeClass('is-open').addClass('is-before-closing');
	
	                    (0, _drawing.redraw)(this.$element);
	
	                    this.$element.removeClass('is-before-closing').addClass('is-closing');
	                }
	            }
	
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.start) {
	                transitionType.start(this);
	            }
	
	            this.trigger('transitionStart');
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionEnd',
	        value: function transitionEnd() {
	            if (this.isOpen) {
	
	                this.$element.removeClass('is-opening').addClass('is-open');
	            } else {
	
	                this.$element.removeClass('is-closing').addClass('is-closed');
	            }
	
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.end) {
	                transitionType.end(this);
	            }
	
	            this.trigger('transitionEnd');
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionSkip',
	        value: function transitionSkip() {
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.skip) {
	                transitionType.skip(this);
	            }
	        }
	    }]);
	
	    return Toggler;
	}(_emitter2.default);
	
	exports.default = Toggler;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Emitter = function () {
	    function Emitter() {
	        _classCallCheck(this, Emitter);
	
	        this.events = {};
	    }
	
	    _createClass(Emitter, [{
	        key: "on",
	        value: function on(type, callback) {
	            if (!(type in this.events)) {
	                this.events[type] = [];
	            }
	            this.events[type].push(callback);
	        }
	    }, {
	        key: "off",
	        value: function off(type) {
	            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            if (callback && type in this.events) {
	                var newList = [];
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = this.events[type][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var cb = _step.value;
	
	                        if (cb !== callback) {
	                            newList.push(cb);
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                this.events[type] = newList;
	            } else {
	                delete this.events[type];
	            }
	        }
	    }, {
	        key: "trigger",
	        value: function trigger(type) {
	            var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            if (type in this.events) {
	                event.type = type;
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = this.events[type][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        var cb = _step2.value;
	
	                        cb.call(this, event);
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	            }
	        }
	    }]);
	
	    return Emitter;
	}();
	
	exports.default = Emitter;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.frame = frame;
	exports.unframe = unframe;
	exports.redraw = redraw;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Requests an animation frame.
	 *
	 * @param callback
	 * @returns {*}
	 */
	function frame(callback) {
	    if (typeof requestAnimationFrame === 'undefined') {
	        return setTimeout(callback, 0);
	    }
	    return requestAnimationFrame(callback);
	}
	
	/**
	 * Cancels a frame request.
	 *
	 * @param id
	 */
	function unframe(id) {
	    if (typeof cancelAnimationFrame === 'undefined') {
	        return clearTimeout(id);
	    }
	    return cancelAnimationFrame(id);
	}
	
	/**
	 * Triggers a layout reflow for a specific element.
	 *
	 * @param element
	 */
	function redraw(element) {
	    if (element instanceof _jquery2.default) {
	        element = element[0];
	    }
	    // Accessing this property triggers a layout reflow
	    element.offsetWidth;
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = selectorDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function selectorDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
	
		$context.find('[sw-selector]').each(function () {
			var $element = (0, _jquery2.default)(this);
			var json = $element.attr('sw-selector');
			var settings = (0, _parse.directiveSettings)(json, {
				selector: '> [sw-toggler]'
			}, 'selector');
	
			var $togglers = $element.find(settings.selector);
			var togglers = Array.from($togglers).map(function (el) {
				return (0, _jquery2.default)(el).data('toggler');
			});
	
			var selectToggler = function selectToggler(toggler) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = togglers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var otherToggler = _step.value;
	
						if (otherToggler !== toggler) {
							otherToggler.close();
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			};
	
			togglers.forEach(function (toggler) {
				return toggler.on('open', function () {
					return selectToggler(toggler);
				});
			});
		});
	}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = trackerDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param type
	 * @param action
	 * @param label
	 * @param timeout
	 * @returns {*}
	 */
	function trackEvent() {
		var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'lead';
		var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'click';
		var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
		var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
	
		var promises = [];
	
		// Google Analytics
		if (typeof ga === 'function') {
	
			promises.push(new Promise(function (resolve, reject) {
	
				ga('send', {
					hitType: 'event',
					eventCategory: type,
					eventAction: action,
					eventLabel: label,
					hitCallback: function hitCallback() {
						return resolve();
					}
				});
	
				setTimeout(function () {
					return reject();
				}, timeout);
			}));
		}
	
		// Facebook Pixel
		if (typeof fqb === 'function') {
	
			promises.push(new Promise(function (resolve, reject) {
	
				fbq('track', 'Lead');
				resolve();
	
				// Facebook Pixel has no callback...
				// setTimeout(() => reject(), timeout);
			}));
		}
	
		return Promise.all(promises);
	}
	
	/**
	 *
	 * @param context
	 */
	function trackerDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
	
		$context.find('[sw-tracker]').each(function () {
			var _this = this;
	
			var $element = (0, _jquery2.default)(this);
			var json = $element.attr('sw-tracker');
			var settings = (0, _parse.directiveSettings)(json, {
				on: 'auto',
				type: 'lead',
				label: '',
				timeout: 1000
			}, 'label');
	
			if (settings.on === 'auto') {
				if ($element.is('form')) {
					settings.on = 'submit';
				} else {
					settings.on = 'click';
				}
			}
	
			$element.on(settings.on + '.tracker', function (e) {
				e.preventDefault();
				e.stopImmediatePropagation();
	
				var trigger = function trigger() {
					$element.off('.tracker');
					$element.trigger(settings.on);
	
					if (settings.on === 'click' && $element.is('a[href]')) {
						_this.click();
					}
				};
	
				trackEvent(settings.type, settings.on, settings.label, settings.timeout).then(trigger).catch(trigger);
			});
		});
	}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = autosizeDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _autosize = __webpack_require__(14);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _iframeResizer = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Enhances textarea fields by automatically expanding it's height to fit it's contents.
	 *
	 * @see https://github.com/jackmoore/autosize
	 * @param context
	 */
	function autosizeDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    (0, _autosize2.default)($context.find('textarea[sw-autosize]'));
	
	    $context.find('iframe[sw-autosize]').each(function () {
	        (0, _iframeResizer.iframeResizer)({ checkOrigin: false }, this);
	    });
	}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Autosize 3.0.21
		license: MIT
		http://www.jacklmoore.com/autosize
	*/
	(function (global, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
			factory(exports, module);
		} else {
			var mod = {
				exports: {}
			};
			factory(mod.exports, mod);
			global.autosize = mod.exports;
		}
	})(this, function (exports, module) {
		'use strict';
	
		var map = typeof Map === "function" ? new Map() : (function () {
			var keys = [];
			var values = [];
	
			return {
				has: function has(key) {
					return keys.indexOf(key) > -1;
				},
				get: function get(key) {
					return values[keys.indexOf(key)];
				},
				set: function set(key, value) {
					if (keys.indexOf(key) === -1) {
						keys.push(key);
						values.push(value);
					}
				},
				'delete': function _delete(key) {
					var index = keys.indexOf(key);
					if (index > -1) {
						keys.splice(index, 1);
						values.splice(index, 1);
					}
				}
			};
		})();
	
		var createEvent = function createEvent(name) {
			return new Event(name, { bubbles: true });
		};
		try {
			new Event('test');
		} catch (e) {
			// IE does not support `new Event()`
			createEvent = function (name) {
				var evt = document.createEvent('Event');
				evt.initEvent(name, true, false);
				return evt;
			};
		}
	
		function assign(ta) {
			if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;
	
			var heightOffset = null;
			var clientWidth = ta.clientWidth;
			var cachedHeight = null;
	
			function init() {
				var style = window.getComputedStyle(ta, null);
	
				if (style.resize === 'vertical') {
					ta.style.resize = 'none';
				} else if (style.resize === 'both') {
					ta.style.resize = 'horizontal';
				}
	
				if (style.boxSizing === 'content-box') {
					heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
				} else {
					heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
				}
				// Fix when a textarea is not on document body and heightOffset is Not a Number
				if (isNaN(heightOffset)) {
					heightOffset = 0;
				}
	
				update();
			}
	
			function changeOverflow(value) {
				{
					// Chrome/Safari-specific fix:
					// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
					// made available by removing the scrollbar. The following forces the necessary text reflow.
					var width = ta.style.width;
					ta.style.width = '0px';
					// Force reflow:
					/* jshint ignore:start */
					ta.offsetWidth;
					/* jshint ignore:end */
					ta.style.width = width;
				}
	
				ta.style.overflowY = value;
			}
	
			function getParentOverflows(el) {
				var arr = [];
	
				while (el && el.parentNode && el.parentNode instanceof Element) {
					if (el.parentNode.scrollTop) {
						arr.push({
							node: el.parentNode,
							scrollTop: el.parentNode.scrollTop
						});
					}
					el = el.parentNode;
				}
	
				return arr;
			}
	
			function resize() {
				var originalHeight = ta.style.height;
				var overflows = getParentOverflows(ta);
				var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)
	
				ta.style.height = 'auto';
	
				var endHeight = ta.scrollHeight + heightOffset;
	
				if (ta.scrollHeight === 0) {
					// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
					ta.style.height = originalHeight;
					return;
				}
	
				ta.style.height = endHeight + 'px';
	
				// used to check if an update is actually necessary on window.resize
				clientWidth = ta.clientWidth;
	
				// prevents scroll-position jumping
				overflows.forEach(function (el) {
					el.node.scrollTop = el.scrollTop;
				});
	
				if (docTop) {
					document.documentElement.scrollTop = docTop;
				}
			}
	
			function update() {
				resize();
	
				var styleHeight = Math.round(parseFloat(ta.style.height));
				var computed = window.getComputedStyle(ta, null);
	
				// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
				var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;
	
				// The actual height not matching the style height (set via the resize method) indicates that
				// the max-height has been exceeded, in which case the overflow should be allowed.
				if (actualHeight !== styleHeight) {
					if (computed.overflowY === 'hidden') {
						changeOverflow('scroll');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				} else {
					// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
					if (computed.overflowY !== 'hidden') {
						changeOverflow('hidden');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				}
	
				if (cachedHeight !== actualHeight) {
					cachedHeight = actualHeight;
					var evt = createEvent('autosize:resized');
					try {
						ta.dispatchEvent(evt);
					} catch (err) {
						// Firefox will throw an error on dispatchEvent for a detached element
						// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
					}
				}
			}
	
			var pageResize = function pageResize() {
				if (ta.clientWidth !== clientWidth) {
					update();
				}
			};
	
			var destroy = (function (style) {
				window.removeEventListener('resize', pageResize, false);
				ta.removeEventListener('input', update, false);
				ta.removeEventListener('keyup', update, false);
				ta.removeEventListener('autosize:destroy', destroy, false);
				ta.removeEventListener('autosize:update', update, false);
	
				Object.keys(style).forEach(function (key) {
					ta.style[key] = style[key];
				});
	
				map['delete'](ta);
			}).bind(ta, {
				height: ta.style.height,
				resize: ta.style.resize,
				overflowY: ta.style.overflowY,
				overflowX: ta.style.overflowX,
				wordWrap: ta.style.wordWrap
			});
	
			ta.addEventListener('autosize:destroy', destroy, false);
	
			// IE9 does not fire onpropertychange or oninput for deletions,
			// so binding to onkeyup to catch most of those events.
			// There is no way that I know of to detect something like 'cut' in IE9.
			if ('onpropertychange' in ta && 'oninput' in ta) {
				ta.addEventListener('keyup', update, false);
			}
	
			window.addEventListener('resize', pageResize, false);
			ta.addEventListener('input', update, false);
			ta.addEventListener('autosize:update', update, false);
			ta.style.overflowX = 'hidden';
			ta.style.wordWrap = 'break-word';
	
			map.set(ta, {
				destroy: destroy,
				update: update
			});
	
			init();
		}
	
		function destroy(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.destroy();
			}
		}
	
		function update(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.update();
			}
		}
	
		var autosize = null;
	
		// Do nothing in Node.js environment and IE8 (or lower)
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
			autosize = function (el) {
				return el;
			};
			autosize.destroy = function (el) {
				return el;
			};
			autosize.update = function (el) {
				return el;
			};
		} else {
			autosize = function (el, options) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], function (x) {
						return assign(x, options);
					});
				}
				return el;
			};
			autosize.destroy = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], destroy);
				}
				return el;
			};
			autosize.update = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], update);
				}
				return el;
			};
		}
	
		module.exports = autosize;
	});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = __webpack_require__(16)


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	exports.iframeResizer = __webpack_require__(17);
	exports.iframeResizerContentWindow = __webpack_require__(18);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * File: iframeResizer.js
	 * Desc: Force iframes to size to content.
	 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
	 * Doc: https://github.com/davidjbradshaw/iframe-resizer
	 * Author: David J. Bradshaw - dave@bradshaw.net
	 * Contributor: Jure Mav - jure.mav@gmail.com
	 * Contributor: Reed Dadoune - reed@dadoune.com
	 */
	
	(function(undefined) {
	  'use strict';
	
	  if (typeof window === 'undefined') return; // don't run for server side render
	
	  var count = 0,
	    logEnabled = false,
	    hiddenCheckEnabled = false,
	    msgHeader = 'message',
	    msgHeaderLen = msgHeader.length,
	    msgId = '[iFrameSizer]', //Must match iframe msg ID
	    msgIdLen = msgId.length,
	    pagePosition = null,
	    requestAnimationFrame = window.requestAnimationFrame,
	    resetRequiredMethods = {
	      max: 1,
	      scroll: 1,
	      bodyScroll: 1,
	      documentElementScroll: 1
	    },
	    settings = {},
	    timer = null,
	    logId = 'Host Page',
	    defaults = {
	      autoResize: true,
	      bodyBackground: null,
	      bodyMargin: null,
	      bodyMarginV1: 8,
	      bodyPadding: null,
	      checkOrigin: true,
	      inPageLinks: false,
	      enablePublicMethods: true,
	      heightCalculationMethod: 'bodyOffset',
	      id: 'iFrameResizer',
	      interval: 32,
	      log: false,
	      maxHeight: Infinity,
	      maxWidth: Infinity,
	      minHeight: 0,
	      minWidth: 0,
	      resizeFrom: 'parent',
	      scrolling: false,
	      sizeHeight: true,
	      sizeWidth: false,
	      warningTimeout: 5000,
	      tolerance: 0,
	      widthCalculationMethod: 'scroll',
	      closedCallback: function() {},
	      initCallback: function() {},
	      messageCallback: function() {
	        warn('MessageCallback function not defined');
	      },
	      resizedCallback: function() {},
	      scrollCallback: function() {
	        return true;
	      }
	    };
	
	  function getMutationObserver() {
	    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	  }
	
	  function addEventListener(obj, evt, func) {
	    /* istanbul ignore else */ // Not testable in PhantonJS
	    if ('addEventListener' in window) {
	      obj.addEventListener(evt, func, false);
	    } else if ('attachEvent' in window) {
	      //IE
	      obj.attachEvent('on' + evt, func);
	    }
	  }
	
	  function removeEventListener(el, evt, func) {
	    /* istanbul ignore else */ // Not testable in phantonJS
	    if ('removeEventListener' in window) {
	      el.removeEventListener(evt, func, false);
	    } else if ('detachEvent' in window) {
	      //IE
	      el.detachEvent('on' + evt, func);
	    }
	  }
	
	  function setupRequestAnimationFrame() {
	    var vendors = ['moz', 'webkit', 'o', 'ms'],
	      x;
	
	    // Remove vendor prefixing if prefixed and break early if not
	    for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
	      requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	    }
	
	    if (!requestAnimationFrame) {
	      log('setup', 'RequestAnimationFrame not supported');
	    }
	  }
	
	  function getMyID(iframeId) {
	    var retStr = 'Host page: ' + iframeId;
	
	    if (window.top !== window.self) {
	      if (window.parentIFrame && window.parentIFrame.getId) {
	        retStr = window.parentIFrame.getId() + ': ' + iframeId;
	      } else {
	        retStr = 'Nested host page: ' + iframeId;
	      }
	    }
	
	    return retStr;
	  }
	
	  function formatLogHeader(iframeId) {
	    return msgId + '[' + getMyID(iframeId) + ']';
	  }
	
	  function isLogEnabled(iframeId) {
	    return settings[iframeId] ? settings[iframeId].log : logEnabled;
	  }
	
	  function log(iframeId, msg) {
	    output('log', iframeId, msg, isLogEnabled(iframeId));
	  }
	
	  function info(iframeId, msg) {
	    output('info', iframeId, msg, isLogEnabled(iframeId));
	  }
	
	  function warn(iframeId, msg) {
	    output('warn', iframeId, msg, true);
	  }
	
	  function output(type, iframeId, msg, enabled) {
	    if (true === enabled && 'object' === typeof window.console) {
	      console[type](formatLogHeader(iframeId), msg);
	    }
	  }
	
	  function iFrameListener(event) {
	    function resizeIFrame() {
	      function resize() {
	        setSize(messageData);
	        setPagePosition(iframeId);
	        callback('resizedCallback', messageData);
	      }
	
	      ensureInRange('Height');
	      ensureInRange('Width');
	
	      syncResize(resize, messageData, 'init');
	    }
	
	    function processMsg() {
	      var data = msg.substr(msgIdLen).split(':');
	
	      return {
	        iframe: settings[data[0]] && settings[data[0]].iframe,
	        id: data[0],
	        height: data[1],
	        width: data[2],
	        type: data[3]
	      };
	    }
	
	    function ensureInRange(Dimension) {
	      var max = Number(settings[iframeId]['max' + Dimension]),
	        min = Number(settings[iframeId]['min' + Dimension]),
	        dimension = Dimension.toLowerCase(),
	        size = Number(messageData[dimension]);
	
	      log(
	        iframeId,
	        'Checking ' + dimension + ' is in range ' + min + '-' + max
	      );
	
	      if (size < min) {
	        size = min;
	        log(iframeId, 'Set ' + dimension + ' to min value');
	      }
	
	      if (size > max) {
	        size = max;
	        log(iframeId, 'Set ' + dimension + ' to max value');
	      }
	
	      messageData[dimension] = '' + size;
	    }
	
	    function isMessageFromIFrame() {
	      function checkAllowedOrigin() {
	        function checkList() {
	          var i = 0,
	            retCode = false;
	
	          log(
	            iframeId,
	            'Checking connection is from allowed list of origins: ' +
	              checkOrigin
	          );
	
	          for (; i < checkOrigin.length; i++) {
	            if (checkOrigin[i] === origin) {
	              retCode = true;
	              break;
	            }
	          }
	          return retCode;
	        }
	
	        function checkSingle() {
	          var remoteHost = settings[iframeId] && settings[iframeId].remoteHost;
	          log(iframeId, 'Checking connection is from: ' + remoteHost);
	          return origin === remoteHost;
	        }
	
	        return checkOrigin.constructor === Array ? checkList() : checkSingle();
	      }
	
	      var origin = event.origin,
	        checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;
	
	      if (checkOrigin && '' + origin !== 'null' && !checkAllowedOrigin()) {
	        throw new Error(
	          'Unexpected message received from: ' +
	            origin +
	            ' for ' +
	            messageData.iframe.id +
	            '. Message was: ' +
	            event.data +
	            '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
	        );
	      }
	
	      return true;
	    }
	
	    function isMessageForUs() {
	      return (
	        msgId === ('' + msg).substr(0, msgIdLen) &&
	        msg.substr(msgIdLen).split(':')[0] in settings
	      ); //''+Protects against non-string msg
	    }
	
	    function isMessageFromMetaParent() {
	      //Test if this message is from a parent above us. This is an ugly test, however, updating
	      //the message format would break backwards compatibity.
	      var retCode = messageData.type in { true: 1, false: 1, undefined: 1 };
	
	      if (retCode) {
	        log(iframeId, 'Ignoring init message from meta parent page');
	      }
	
	      return retCode;
	    }
	
	    function getMsgBody(offset) {
	      return msg.substr(msg.indexOf(':') + msgHeaderLen + offset);
	    }
	
	    function forwardMsgFromIFrame(msgBody) {
	      log(
	        iframeId,
	        'MessageCallback passed: {iframe: ' +
	          messageData.iframe.id +
	          ', message: ' +
	          msgBody +
	          '}'
	      );
	      callback('messageCallback', {
	        iframe: messageData.iframe,
	        message: JSON.parse(msgBody)
	      });
	      log(iframeId, '--');
	    }
	
	    function getPageInfo() {
	      var bodyPosition = document.body.getBoundingClientRect(),
	        iFramePosition = messageData.iframe.getBoundingClientRect();
	
	      return JSON.stringify({
	        iframeHeight: iFramePosition.height,
	        iframeWidth: iFramePosition.width,
	        clientHeight: Math.max(
	          document.documentElement.clientHeight,
	          window.innerHeight || 0
	        ),
	        clientWidth: Math.max(
	          document.documentElement.clientWidth,
	          window.innerWidth || 0
	        ),
	        offsetTop: parseInt(iFramePosition.top - bodyPosition.top, 10),
	        offsetLeft: parseInt(iFramePosition.left - bodyPosition.left, 10),
	        scrollTop: window.pageYOffset,
	        scrollLeft: window.pageXOffset
	      });
	    }
	
	    function sendPageInfoToIframe(iframe, iframeId) {
	      function debouncedTrigger() {
	        trigger(
	          'Send Page Info',
	          'pageInfo:' + getPageInfo(),
	          iframe,
	          iframeId
	        );
	      }
	      debounceFrameEvents(debouncedTrigger, 32, iframeId);
	    }
	
	    function startPageInfoMonitor() {
	      function setListener(type, func) {
	        function sendPageInfo() {
	          if (settings[id]) {
	            sendPageInfoToIframe(settings[id].iframe, id);
	          } else {
	            stop();
	          }
	        }
	
	        ['scroll', 'resize'].forEach(function(evt) {
	          log(id, type + evt + ' listener for sendPageInfo');
	          func(window, evt, sendPageInfo);
	        });
	      }
	
	      function stop() {
	        setListener('Remove ', removeEventListener);
	      }
	
	      function start() {
	        setListener('Add ', addEventListener);
	      }
	
	      var id = iframeId; //Create locally scoped copy of iFrame ID
	
	      start();
	
	      if (settings[id]) {
	        settings[id].stopPageInfo = stop;
	      }
	    }
	
	    function stopPageInfoMonitor() {
	      if (settings[iframeId] && settings[iframeId].stopPageInfo) {
	        settings[iframeId].stopPageInfo();
	        delete settings[iframeId].stopPageInfo;
	      }
	    }
	
	    function checkIFrameExists() {
	      var retBool = true;
	
	      if (null === messageData.iframe) {
	        warn(iframeId, 'IFrame (' + messageData.id + ') not found');
	        retBool = false;
	      }
	      return retBool;
	    }
	
	    function getElementPosition(target) {
	      var iFramePosition = target.getBoundingClientRect();
	
	      getPagePosition(iframeId);
	
	      return {
	        x: Math.floor(Number(iFramePosition.left) + Number(pagePosition.x)),
	        y: Math.floor(Number(iFramePosition.top) + Number(pagePosition.y))
	      };
	    }
	
	    function scrollRequestFromChild(addOffset) {
	      /* istanbul ignore next */ //Not testable in Karma
	      function reposition() {
	        pagePosition = newPosition;
	        scrollTo();
	        log(iframeId, '--');
	      }
	
	      function calcOffset() {
	        return {
	          x: Number(messageData.width) + offset.x,
	          y: Number(messageData.height) + offset.y
	        };
	      }
	
	      function scrollParent() {
	        if (window.parentIFrame) {
	          window.parentIFrame['scrollTo' + (addOffset ? 'Offset' : '')](
	            newPosition.x,
	            newPosition.y
	          );
	        } else {
	          warn(
	            iframeId,
	            'Unable to scroll to requested position, window.parentIFrame not found'
	          );
	        }
	      }
	
	      var offset = addOffset
	          ? getElementPosition(messageData.iframe)
	          : { x: 0, y: 0 },
	        newPosition = calcOffset();
	
	      log(
	        iframeId,
	        'Reposition requested from iFrame (offset x:' +
	          offset.x +
	          ' y:' +
	          offset.y +
	          ')'
	      );
	
	      if (window.top !== window.self) {
	        scrollParent();
	      } else {
	        reposition();
	      }
	    }
	
	    function scrollTo() {
	      if (false !== callback('scrollCallback', pagePosition)) {
	        setPagePosition(iframeId);
	      } else {
	        unsetPagePosition();
	      }
	    }
	
	    function findTarget(location) {
	      function jumpToTarget() {
	        var jumpPosition = getElementPosition(target);
	
	        log(
	          iframeId,
	          'Moving to in page link (#' +
	            hash +
	            ') at x: ' +
	            jumpPosition.x +
	            ' y: ' +
	            jumpPosition.y
	        );
	        pagePosition = {
	          x: jumpPosition.x,
	          y: jumpPosition.y
	        };
	
	        scrollTo();
	        log(iframeId, '--');
	      }
	
	      function jumpToParent() {
	        if (window.parentIFrame) {
	          window.parentIFrame.moveToAnchor(hash);
	        } else {
	          log(
	            iframeId,
	            'In page link #' +
	              hash +
	              ' not found and window.parentIFrame not found'
	          );
	        }
	      }
	
	      var hash = location.split('#')[1] || '',
	        hashData = decodeURIComponent(hash),
	        target =
	          document.getElementById(hashData) ||
	          document.getElementsByName(hashData)[0];
	
	      if (target) {
	        jumpToTarget();
	      } else if (window.top !== window.self) {
	        jumpToParent();
	      } else {
	        log(iframeId, 'In page link #' + hash + ' not found');
	      }
	    }
	
	    function callback(funcName, val) {
	      return chkCallback(iframeId, funcName, val);
	    }
	
	    function actionMsg() {
	      if (settings[iframeId] && settings[iframeId].firstRun) firstRun();
	
	      switch (messageData.type) {
	        case 'close':
	          if (settings[iframeId].closeRequestCallback)
	            chkCallback(
	              iframeId,
	              'closeRequestCallback',
	              settings[iframeId].iframe
	            );
	          else closeIFrame(messageData.iframe);
	          break;
	        case 'message':
	          forwardMsgFromIFrame(getMsgBody(6));
	          break;
	        case 'scrollTo':
	          scrollRequestFromChild(false);
	          break;
	        case 'scrollToOffset':
	          scrollRequestFromChild(true);
	          break;
	        case 'pageInfo':
	          sendPageInfoToIframe(
	            settings[iframeId] && settings[iframeId].iframe,
	            iframeId
	          );
	          startPageInfoMonitor();
	          break;
	        case 'pageInfoStop':
	          stopPageInfoMonitor();
	          break;
	        case 'inPageLink':
	          findTarget(getMsgBody(9));
	          break;
	        case 'reset':
	          resetIFrame(messageData);
	          break;
	        case 'init':
	          resizeIFrame();
	          callback('initCallback', messageData.iframe);
	          break;
	        default:
	          resizeIFrame();
	      }
	    }
	
	    function hasSettings(iframeId) {
	      var retBool = true;
	
	      if (!settings[iframeId]) {
	        retBool = false;
	        warn(
	          messageData.type +
	            ' No settings for ' +
	            iframeId +
	            '. Message was: ' +
	            msg
	        );
	      }
	
	      return retBool;
	    }
	
	    function iFrameReadyMsgReceived() {
	      for (var iframeId in settings) {
	        trigger(
	          'iFrame requested init',
	          createOutgoingMsg(iframeId),
	          document.getElementById(iframeId),
	          iframeId
	        );
	      }
	    }
	
	    function firstRun() {
	      if (settings[iframeId]) {
	        settings[iframeId].firstRun = false;
	      }
	    }
	
	    function clearWarningTimeout() {
	      if (settings[iframeId]) {
	        clearTimeout(settings[iframeId].msgTimeout);
	        settings[iframeId].warningTimeout = 0;
	      }
	    }
	
	    var msg = event.data,
	      messageData = {},
	      iframeId = null;
	
	    if ('[iFrameResizerChild]Ready' === msg) {
	      iFrameReadyMsgReceived();
	    } else if (isMessageForUs()) {
	      messageData = processMsg();
	      iframeId = logId = messageData.id;
	      if (settings[iframeId]) {
	        settings[iframeId].loaded = true;
	      }
	
	      if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
	        log(iframeId, 'Received: ' + msg);
	
	        if (checkIFrameExists() && isMessageFromIFrame()) {
	          actionMsg();
	        }
	      }
	    } else {
	      info(iframeId, 'Ignored: ' + msg);
	    }
	  }
	
	  function chkCallback(iframeId, funcName, val) {
	    var func = null,
	      retVal = null;
	
	    if (settings[iframeId]) {
	      func = settings[iframeId][funcName];
	
	      if ('function' === typeof func) {
	        retVal = func(val);
	      } else {
	        throw new TypeError(
	          funcName + ' on iFrame[' + iframeId + '] is not a function'
	        );
	      }
	    }
	
	    return retVal;
	  }
	
	  function removeIframeListeners(iframe) {
	    var iframeId = iframe.id;
	    delete settings[iframeId];
	  }
	
	  function closeIFrame(iframe) {
	    var iframeId = iframe.id;
	    log(iframeId, 'Removing iFrame: ' + iframeId);
	
	    try {
	      // Catch race condition error with React
	      if (iframe.parentNode) {
	        iframe.parentNode.removeChild(iframe);
	      }
	    } catch (e) {}
	
	    chkCallback(iframeId, 'closedCallback', iframeId);
	    log(iframeId, '--');
	    removeIframeListeners(iframe);
	  }
	
	  function getPagePosition(iframeId) {
	    if (null === pagePosition) {
	      pagePosition = {
	        x:
	          window.pageXOffset !== undefined
	            ? window.pageXOffset
	            : document.documentElement.scrollLeft,
	        y:
	          window.pageYOffset !== undefined
	            ? window.pageYOffset
	            : document.documentElement.scrollTop
	      };
	      log(
	        iframeId,
	        'Get page position: ' + pagePosition.x + ',' + pagePosition.y
	      );
	    }
	  }
	
	  function setPagePosition(iframeId) {
	    if (null !== pagePosition) {
	      window.scrollTo(pagePosition.x, pagePosition.y);
	      log(
	        iframeId,
	        'Set page position: ' + pagePosition.x + ',' + pagePosition.y
	      );
	      unsetPagePosition();
	    }
	  }
	
	  function unsetPagePosition() {
	    pagePosition = null;
	  }
	
	  function resetIFrame(messageData) {
	    function reset() {
	      setSize(messageData);
	      trigger('reset', 'reset', messageData.iframe, messageData.id);
	    }
	
	    log(
	      messageData.id,
	      'Size reset requested by ' +
	        ('init' === messageData.type ? 'host page' : 'iFrame')
	    );
	    getPagePosition(messageData.id);
	    syncResize(reset, messageData, 'reset');
	  }
	
	  function setSize(messageData) {
	    function setDimension(dimension) {
	      if (!messageData.id) {
	        log('undefined', 'messageData id not set');
	        return;
	      }
	      messageData.iframe.style[dimension] = messageData[dimension] + 'px';
	      log(
	        messageData.id,
	        'IFrame (' +
	          iframeId +
	          ') ' +
	          dimension +
	          ' set to ' +
	          messageData[dimension] +
	          'px'
	      );
	    }
	
	    function chkZero(dimension) {
	      //FireFox sets dimension of hidden iFrames to zero.
	      //So if we detect that set up an event to check for
	      //when iFrame becomes visible.
	
	      /* istanbul ignore next */ //Not testable in PhantomJS
	      if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
	        hiddenCheckEnabled = true;
	        log(iframeId, 'Hidden iFrame detected, creating visibility listener');
	        fixHiddenIFrames();
	      }
	    }
	
	    function processDimension(dimension) {
	      setDimension(dimension);
	      chkZero(dimension);
	    }
	
	    var iframeId = messageData.iframe.id;
	
	    if (settings[iframeId]) {
	      if (settings[iframeId].sizeHeight) {
	        processDimension('height');
	      }
	      if (settings[iframeId].sizeWidth) {
	        processDimension('width');
	      }
	    }
	  }
	
	  function syncResize(func, messageData, doNotSync) {
	    /* istanbul ignore if */ //Not testable in PhantomJS
	    if (doNotSync !== messageData.type && requestAnimationFrame) {
	      log(messageData.id, 'Requesting animation frame');
	      requestAnimationFrame(func);
	    } else {
	      func();
	    }
	  }
	
	  function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
	    function postMessageToIFrame() {
	      var target = settings[id] && settings[id].targetOrigin;
	      log(
	        id,
	        '[' +
	          calleeMsg +
	          '] Sending msg to iframe[' +
	          id +
	          '] (' +
	          msg +
	          ') targetOrigin: ' +
	          target
	      );
	      iframe.contentWindow.postMessage(msgId + msg, target);
	    }
	
	    function iFrameNotFound() {
	      warn(id, '[' + calleeMsg + '] IFrame(' + id + ') not found');
	    }
	
	    function chkAndSend() {
	      if (
	        iframe &&
	        'contentWindow' in iframe &&
	        null !== iframe.contentWindow
	      ) {
	        //Null test for PhantomJS
	        postMessageToIFrame();
	      } else {
	        iFrameNotFound();
	      }
	    }
	
	    function warnOnNoResponse() {
	      function warning() {
	        if (settings[id] && !settings[id].loaded && !errorShown) {
	          errorShown = true;
	          warn(
	            id,
	            'IFrame has not responded within ' +
	              settings[id].warningTimeout / 1000 +
	              ' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.'
	          );
	        }
	      }
	
	      if (
	        !!noResponseWarning &&
	        settings[id] &&
	        !!settings[id].warningTimeout
	      ) {
	        settings[id].msgTimeout = setTimeout(
	          warning,
	          settings[id].warningTimeout
	        );
	      }
	    }
	
	    var errorShown = false;
	
	    id = id || iframe.id;
	
	    if (settings[id]) {
	      chkAndSend();
	      warnOnNoResponse();
	    }
	  }
	
	  function createOutgoingMsg(iframeId) {
	    return (
	      iframeId +
	      ':' +
	      settings[iframeId].bodyMarginV1 +
	      ':' +
	      settings[iframeId].sizeWidth +
	      ':' +
	      settings[iframeId].log +
	      ':' +
	      settings[iframeId].interval +
	      ':' +
	      settings[iframeId].enablePublicMethods +
	      ':' +
	      settings[iframeId].autoResize +
	      ':' +
	      settings[iframeId].bodyMargin +
	      ':' +
	      settings[iframeId].heightCalculationMethod +
	      ':' +
	      settings[iframeId].bodyBackground +
	      ':' +
	      settings[iframeId].bodyPadding +
	      ':' +
	      settings[iframeId].tolerance +
	      ':' +
	      settings[iframeId].inPageLinks +
	      ':' +
	      settings[iframeId].resizeFrom +
	      ':' +
	      settings[iframeId].widthCalculationMethod
	    );
	  }
	
	  function setupIFrame(iframe, options) {
	    function setLimits() {
	      function addStyle(style) {
	        if (
	          Infinity !== settings[iframeId][style] &&
	          0 !== settings[iframeId][style]
	        ) {
	          iframe.style[style] = settings[iframeId][style] + 'px';
	          log(
	            iframeId,
	            'Set ' + style + ' = ' + settings[iframeId][style] + 'px'
	          );
	        }
	      }
	
	      function chkMinMax(dimension) {
	        if (
	          settings[iframeId]['min' + dimension] >
	          settings[iframeId]['max' + dimension]
	        ) {
	          throw new Error(
	            'Value for min' +
	              dimension +
	              ' can not be greater than max' +
	              dimension
	          );
	        }
	      }
	
	      chkMinMax('Height');
	      chkMinMax('Width');
	
	      addStyle('maxHeight');
	      addStyle('minHeight');
	      addStyle('maxWidth');
	      addStyle('minWidth');
	    }
	
	    function newId() {
	      var id = (options && options.id) || defaults.id + count++;
	      if (null !== document.getElementById(id)) {
	        id = id + count++;
	      }
	      return id;
	    }
	
	    function ensureHasId(iframeId) {
	      logId = iframeId;
	      if ('' === iframeId) {
	        iframe.id = iframeId = newId();
	        logEnabled = (options || {}).log;
	        logId = iframeId;
	        log(
	          iframeId,
	          'Added missing iframe ID: ' + iframeId + ' (' + iframe.src + ')'
	        );
	      }
	
	      return iframeId;
	    }
	
	    function setScrolling() {
	      log(
	        iframeId,
	        'IFrame scrolling ' +
	          (settings[iframeId] && settings[iframeId].scrolling
	            ? 'enabled'
	            : 'disabled') +
	          ' for ' +
	          iframeId
	      );
	      iframe.style.overflow =
	        false === (settings[iframeId] && settings[iframeId].scrolling)
	          ? 'hidden'
	          : 'auto';
	      switch (settings[iframeId] && settings[iframeId].scrolling) {
	        case 'omit':
	          break;
	        case true:
	          iframe.scrolling = 'yes';
	          break;
	        case false:
	          iframe.scrolling = 'no';
	          break;
	        default:
	          iframe.scrolling = settings[iframeId]
	            ? settings[iframeId].scrolling
	            : 'no';
	      }
	    }
	
	    //The V1 iFrame script expects an int, where as in V2 expects a CSS
	    //string value such as '1px 3em', so if we have an int for V2, set V1=V2
	    //and then convert V2 to a string PX value.
	    function setupBodyMarginValues() {
	      if (
	        'number' ===
	          typeof (settings[iframeId] && settings[iframeId].bodyMargin) ||
	        '0' === (settings[iframeId] && settings[iframeId].bodyMargin)
	      ) {
	        settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
	        settings[iframeId].bodyMargin =
	          '' + settings[iframeId].bodyMargin + 'px';
	      }
	    }
	
	    function checkReset() {
	      // Reduce scope of firstRun to function, because IE8's JS execution
	      // context stack is borked and this value gets externally
	      // changed midway through running this function!!!
	      var firstRun = settings[iframeId] && settings[iframeId].firstRun,
	        resetRequertMethod =
	          settings[iframeId] &&
	          settings[iframeId].heightCalculationMethod in resetRequiredMethods;
	
	      if (!firstRun && resetRequertMethod) {
	        resetIFrame({ iframe: iframe, height: 0, width: 0, type: 'init' });
	      }
	    }
	
	    function setupIFrameObject() {
	      if (Function.prototype.bind && settings[iframeId]) {
	        //Ignore unpolyfilled IE8.
	        settings[iframeId].iframe.iFrameResizer = {
	          close: closeIFrame.bind(null, settings[iframeId].iframe),
	
	          removeListeners: removeIframeListeners.bind(
	            null,
	            settings[iframeId].iframe
	          ),
	
	          resize: trigger.bind(
	            null,
	            'Window resize',
	            'resize',
	            settings[iframeId].iframe
	          ),
	
	          moveToAnchor: function(anchor) {
	            trigger(
	              'Move to anchor',
	              'moveToAnchor:' + anchor,
	              settings[iframeId].iframe,
	              iframeId
	            );
	          },
	
	          sendMessage: function(message) {
	            message = JSON.stringify(message);
	            trigger(
	              'Send Message',
	              'message:' + message,
	              settings[iframeId].iframe,
	              iframeId
	            );
	          }
	        };
	      }
	    }
	
	    //We have to call trigger twice, as we can not be sure if all
	    //iframes have completed loading when this code runs. The
	    //event listener also catches the page changing in the iFrame.
	    function init(msg) {
	      function iFrameLoaded() {
	        trigger('iFrame.onload', msg, iframe, undefined, true);
	        checkReset();
	      }
	
	      function createDestroyObserver(MutationObserver) {
	        if (!iframe.parentNode) {
	          return;
	        }
	
	        var destroyObserver = new MutationObserver(function (mutations) {
	          mutations.forEach(function (mutation) {
	            var removedNodes = Array.prototype.slice.call(mutation.removedNodes); // Transform NodeList into an Array
	            removedNodes.forEach(function (removedNode) {
	              if (removedNode === iframe) {
	                closeIFrame(iframe);
	              }
	            });
	          });
	        });
	        destroyObserver.observe(iframe.parentNode, {
	          childList: true
	        });
	      }
	
	      var MutationObserver = getMutationObserver();
	      if (MutationObserver) {
	        createDestroyObserver(MutationObserver);
	      }
	
	      addEventListener(iframe, 'load', iFrameLoaded);
	      trigger('init', msg, iframe, undefined, true);
	    }
	
	    function checkOptions(options) {
	      if ('object' !== typeof options) {
	        throw new TypeError('Options is not an object');
	      }
	    }
	
	    function copyOptions(options) {
	      for (var option in defaults) {
	        if (defaults.hasOwnProperty(option)) {
	          settings[iframeId][option] = options.hasOwnProperty(option)
	            ? options[option]
	            : defaults[option];
	        }
	      }
	    }
	
	    function getTargetOrigin(remoteHost) {
	      return '' === remoteHost || 'file://' === remoteHost ? '*' : remoteHost;
	    }
	
	    function processOptions(options) {
	      options = options || {};
	      settings[iframeId] = {
	        firstRun: true,
	        iframe: iframe,
	        remoteHost: iframe.src
	          .split('/')
	          .slice(0, 3)
	          .join('/')
	      };
	
	      checkOptions(options);
	      copyOptions(options);
	
	      if (settings[iframeId]) {
	        settings[iframeId].targetOrigin =
	          true === settings[iframeId].checkOrigin
	            ? getTargetOrigin(settings[iframeId].remoteHost)
	            : '*';
	      }
	    }
	
	    function beenHere() {
	      return iframeId in settings && 'iFrameResizer' in iframe;
	    }
	
	    var iframeId = ensureHasId(iframe.id);
	
	    if (!beenHere()) {
	      processOptions(options);
	      setScrolling();
	      setLimits();
	      setupBodyMarginValues();
	      init(createOutgoingMsg(iframeId));
	      setupIFrameObject();
	    } else {
	      warn(iframeId, 'Ignored iFrame, already setup.');
	    }
	  }
	
	  function debouce(fn, time) {
	    if (null === timer) {
	      timer = setTimeout(function() {
	        timer = null;
	        fn();
	      }, time);
	    }
	  }
	
	  var frameTimer = {};
	  function debounceFrameEvents(fn, time, frameId) {
	    if (!frameTimer[frameId]) {
	      frameTimer[frameId] = setTimeout(function() {
	        frameTimer[frameId] = null;
	        fn();
	      }, time);
	    }
	  } //Not testable in PhantomJS
	
	  /* istanbul ignore next */ function fixHiddenIFrames() {
	    function checkIFrames() {
	      function checkIFrame(settingId) {
	        function chkDimension(dimension) {
	          return (
	            '0px' ===
	            (settings[settingId] && settings[settingId].iframe.style[dimension])
	          );
	        }
	
	        function isVisible(el) {
	          return null !== el.offsetParent;
	        }
	
	        if (
	          settings[settingId] &&
	          isVisible(settings[settingId].iframe) &&
	          (chkDimension('height') || chkDimension('width'))
	        ) {
	          trigger(
	            'Visibility change',
	            'resize',
	            settings[settingId].iframe,
	            settingId
	          );
	        }
	      }
	
	      for (var settingId in settings) {
	        checkIFrame(settingId);
	      }
	    }
	
	    function mutationObserved(mutations) {
	      log(
	        'window',
	        'Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type
	      );
	      debouce(checkIFrames, 16);
	    }
	
	    function createMutationObserver() {
	      var target = document.querySelector('body'),
	        config = {
	          attributes: true,
	          attributeOldValue: false,
	          characterData: true,
	          characterDataOldValue: false,
	          childList: true,
	          subtree: true
	        },
	        observer = new MutationObserver(mutationObserved);
	
	      observer.observe(target, config);
	    }
	
	    var MutationObserver = getMutationObserver();
	    if (MutationObserver) {
	      createMutationObserver();
	    }
	  }
	
	  function resizeIFrames(event) {
	    function resize() {
	      sendTriggerMsg('Window ' + event, 'resize');
	    }
	
	    log('window', 'Trigger event: ' + event);
	    debouce(resize, 16);
	  } //Not testable in PhantomJS
	
	  /* istanbul ignore next */ function tabVisible() {
	    function resize() {
	      sendTriggerMsg('Tab Visable', 'resize');
	    }
	
	    if ('hidden' !== document.visibilityState) {
	      log('document', 'Trigger event: Visiblity change');
	      debouce(resize, 16);
	    }
	  }
	
	  function sendTriggerMsg(eventName, event) {
	    function isIFrameResizeEnabled(iframeId) {
	      return (
	        settings[iframeId] &&
	        'parent' === settings[iframeId].resizeFrom &&
	        settings[iframeId].autoResize &&
	        !settings[iframeId].firstRun
	      );
	    }
	
	    for (var iframeId in settings) {
	      if (isIFrameResizeEnabled(iframeId)) {
	        trigger(eventName, event, document.getElementById(iframeId), iframeId);
	      }
	    }
	  }
	
	  function setupEventListeners() {
	    addEventListener(window, 'message', iFrameListener);
	
	    addEventListener(window, 'resize', function() {
	      resizeIFrames('resize');
	    });
	
	    addEventListener(document, 'visibilitychange', tabVisible);
	    addEventListener(document, '-webkit-visibilitychange', tabVisible); //Andriod 4.4
	    addEventListener(window, 'focusin', function() {
	      resizeIFrames('focus');
	    }); //IE8-9
	    addEventListener(window, 'focus', function() {
	      resizeIFrames('focus');
	    });
	  }
	
	  function factory() {
	    function init(options, element) {
	      function chkType() {
	        if (!element.tagName) {
	          throw new TypeError('Object is not a valid DOM element');
	        } else if ('IFRAME' !== element.tagName.toUpperCase()) {
	          throw new TypeError(
	            'Expected <IFRAME> tag, found <' + element.tagName + '>'
	          );
	        }
	      }
	
	      if (element) {
	        chkType();
	        setupIFrame(element, options);
	        iFrames.push(element);
	      }
	    }
	
	    function warnDeprecatedOptions(options) {
	      if (options && options.enablePublicMethods) {
	        warn(
	          'enablePublicMethods option has been removed, public methods are now always available in the iFrame'
	        );
	      }
	    }
	
	    var iFrames;
	
	    setupRequestAnimationFrame();
	    setupEventListeners();
	
	    return function iFrameResizeF(options, target) {
	      iFrames = []; //Only return iFrames past in on this call
	
	      warnDeprecatedOptions(options);
	
	      switch (typeof target) {
	        case 'undefined':
	        case 'string':
	          Array.prototype.forEach.call(
	            document.querySelectorAll(target || 'iframe'),
	            init.bind(undefined, options)
	          );
	          break;
	        case 'object':
	          init(options, target);
	          break;
	        default:
	          throw new TypeError('Unexpected data type (' + typeof target + ')');
	      }
	
	      return iFrames;
	    };
	  }
	
	  function createJQueryPublicMethod($) {
	    if (!$.fn) {
	      info('', 'Unable to bind to jQuery, it is not fully loaded.');
	    } else if (!$.fn.iFrameResize) {
	      $.fn.iFrameResize = function $iFrameResizeF(options) {
	        function init(index, element) {
	          setupIFrame(element, options);
	        }
	
	        return this.filter('iframe')
	          .each(init)
	          .end();
	      };
	    }
	  }
	
	  if (window.jQuery) {
	    createJQueryPublicMethod(window.jQuery);
	  }
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && typeof module.exports === 'object') {
	    //Node for browserfy
	    module.exports = factory();
	  }
	  window.iFrameResize = window.iFrameResize || factory();
	})();


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	/*
	 * File: iframeResizer.contentWindow.js
	 * Desc: Include this file in any page being loaded into an iframe
	 *       to force the iframe to resize to the content size.
	 * Requires: iframeResizer.js on host page.
	 * Doc: https://github.com/davidjbradshaw/iframe-resizer
	 * Author: David J. Bradshaw - dave@bradshaw.net
	 * Contributor: Jure Mav - jure.mav@gmail.com
	 * Contributor: Ian Caunce - ian@hallnet.co.uk
	 */
	
	(function(undefined) {
	  'use strict';
	
	  if (typeof window === 'undefined') return; // don't run for server side render
	
	  var autoResize = true,
	    base = 10,
	    bodyBackground = '',
	    bodyMargin = 0,
	    bodyMarginStr = '',
	    bodyObserver = null,
	    bodyPadding = '',
	    calculateWidth = false,
	    doubleEventList = { resize: 1, click: 1 },
	    eventCancelTimer = 128,
	    firstRun = true,
	    height = 1,
	    heightCalcModeDefault = 'bodyOffset',
	    heightCalcMode = heightCalcModeDefault,
	    initLock = true,
	    initMsg = '',
	    inPageLinks = {},
	    interval = 32,
	    intervalTimer = null,
	    logging = false,
	    msgID = '[iFrameSizer]', //Must match host page msg ID
	    msgIdLen = msgID.length,
	    myID = '',
	    observer = null,
	    resetRequiredMethods = {
	      max: 1,
	      min: 1,
	      bodyScroll: 1,
	      documentElementScroll: 1
	    },
	    resizeFrom = 'child',
	    sendPermit = true,
	    target = window.parent,
	    targetOriginDefault = '*',
	    tolerance = 0,
	    triggerLocked = false,
	    triggerLockedTimer = null,
	    throttledTimer = 16,
	    width = 1,
	    widthCalcModeDefault = 'scroll',
	    widthCalcMode = widthCalcModeDefault,
	    win = window,
	    messageCallback = function() {
	      warn('MessageCallback function not defined');
	    },
	    readyCallback = function() {},
	    pageInfoCallback = function() {},
	    customCalcMethods = {
	      height: function() {
	        warn('Custom height calculation function not defined');
	        return document.documentElement.offsetHeight;
	      },
	      width: function() {
	        warn('Custom width calculation function not defined');
	        return document.body.scrollWidth;
	      }
	    },
	    eventHandlersByName = {},
	    passiveSupported = false,
	    onceSupported = false;
	
	  function noop() {}
	
	  try {
	    var options = Object.create(
	      {},
	      {
	        passive: {
	          get: function() {
	            passiveSupported = true;
	          }
	        },
	        once: {
	          get: function() {
	            onceSupported = true;
	          }
	        }
	      }
	    );
	    window.addEventListener('test', noop, options);
	    window.removeEventListener('test', noop, options);
	  } catch (e) {
	    /* */
	  }
	
	  function addEventListener(el, evt, func, options) {
	    /* istanbul ignore else */ // Not testable in phantomJS
	    if ('addEventListener' in window) {
	      el.addEventListener(evt, func, passiveSupported ? options || {} : false);
	    } else if ('attachEvent' in window) {
	      //IE
	      el.attachEvent('on' + evt, func);
	    }
	  }
	
	  function removeEventListener(el, evt, func) {
	    /* istanbul ignore else */ // Not testable in phantomJS
	    if ('removeEventListener' in window) {
	      el.removeEventListener(evt, func, false);
	    } else if ('detachEvent' in window) {
	      //IE
	      el.detachEvent('on' + evt, func);
	    }
	  }
	
	  function capitalizeFirstLetter(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }
	
	  //Based on underscore.js
	  function throttle(func) {
	    var context,
	      args,
	      result,
	      timeout = null,
	      previous = 0,
	      later = function() {
	        previous = getNow();
	        timeout = null;
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = args = null;
	        }
	      };
	
	    return function() {
	      var now = getNow();
	
	      if (!previous) {
	        previous = now;
	      }
	
	      var remaining = throttledTimer - (now - previous);
	
	      context = this;
	      args = arguments;
	
	      if (remaining <= 0 || remaining > throttledTimer) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	
	        previous = now;
	        result = func.apply(context, args);
	
	        if (!timeout) {
	          context = args = null;
	        }
	      } else if (!timeout) {
	        timeout = setTimeout(later, remaining);
	      }
	
	      return result;
	    };
	  }
	
	  var getNow =
	    Date.now ||
	    function() {
	      /* istanbul ignore next */ // Not testable in PhantonJS
	      return new Date().getTime();
	    };
	
	  function formatLogMsg(msg) {
	    return msgID + '[' + myID + ']' + ' ' + msg;
	  }
	
	  function log(msg) {
	    if (logging && 'object' === typeof window.console) {
	      console.log(formatLogMsg(msg));
	    }
	  }
	
	  function warn(msg) {
	    if ('object' === typeof window.console) {
	      console.warn(formatLogMsg(msg));
	    }
	  }
	
	  function init() {
	    readDataFromParent();
	    log('Initialising iFrame (' + location.href + ')');
	    readDataFromPage();
	    setMargin();
	    setBodyStyle('background', bodyBackground);
	    setBodyStyle('padding', bodyPadding);
	    injectClearFixIntoBodyElement();
	    checkHeightMode();
	    checkWidthMode();
	    stopInfiniteResizingOfIFrame();
	    setupPublicMethods();
	    startEventListeners();
	    inPageLinks = setupInPageLinks();
	    sendSize('init', 'Init message from host page');
	    readyCallback();
	  }
	
	  function readDataFromParent() {
	    function strBool(str) {
	      return 'true' === str ? true : false;
	    }
	
	    var data = initMsg.substr(msgIdLen).split(':');
	
	    myID = data[0];
	    bodyMargin = undefined !== data[1] ? Number(data[1]) : bodyMargin; //For V1 compatibility
	    calculateWidth = undefined !== data[2] ? strBool(data[2]) : calculateWidth;
	    logging = undefined !== data[3] ? strBool(data[3]) : logging;
	    interval = undefined !== data[4] ? Number(data[4]) : interval;
	    autoResize = undefined !== data[6] ? strBool(data[6]) : autoResize;
	    bodyMarginStr = data[7];
	    heightCalcMode = undefined !== data[8] ? data[8] : heightCalcMode;
	    bodyBackground = data[9];
	    bodyPadding = data[10];
	    tolerance = undefined !== data[11] ? Number(data[11]) : tolerance;
	    inPageLinks.enable = undefined !== data[12] ? strBool(data[12]) : false;
	    resizeFrom = undefined !== data[13] ? data[13] : resizeFrom;
	    widthCalcMode = undefined !== data[14] ? data[14] : widthCalcMode;
	  }
	
	  function readDataFromPage() {
	    function readData() {
	      var data = window.iFrameResizer;
	
	      log('Reading data from page: ' + JSON.stringify(data));
	
	      messageCallback =
	        'messageCallback' in data ? data.messageCallback : messageCallback;
	      readyCallback =
	        'readyCallback' in data ? data.readyCallback : readyCallback;
	      targetOriginDefault =
	        'targetOrigin' in data ? data.targetOrigin : targetOriginDefault;
	      heightCalcMode =
	        'heightCalculationMethod' in data
	          ? data.heightCalculationMethod
	          : heightCalcMode;
	      widthCalcMode =
	        'widthCalculationMethod' in data
	          ? data.widthCalculationMethod
	          : widthCalcMode;
	    }
	
	    function setupCustomCalcMethods(calcMode, calcFunc) {
	      if ('function' === typeof calcMode) {
	        log('Setup custom ' + calcFunc + 'CalcMethod');
	        customCalcMethods[calcFunc] = calcMode;
	        calcMode = 'custom';
	      }
	
	      return calcMode;
	    }
	
	    if (
	      'iFrameResizer' in window &&
	      Object === window.iFrameResizer.constructor
	    ) {
	      readData();
	      heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
	      widthCalcMode = setupCustomCalcMethods(widthCalcMode, 'width');
	    }
	
	    log('TargetOrigin for parent set to: ' + targetOriginDefault);
	  }
	
	  function chkCSS(attr, value) {
	    if (-1 !== value.indexOf('-')) {
	      warn('Negative CSS value ignored for ' + attr);
	      value = '';
	    }
	    return value;
	  }
	
	  function setBodyStyle(attr, value) {
	    if (undefined !== value && '' !== value && 'null' !== value) {
	      document.body.style[attr] = value;
	      log('Body ' + attr + ' set to "' + value + '"');
	    }
	  }
	
	  function setMargin() {
	    //If called via V1 script, convert bodyMargin from int to str
	    if (undefined === bodyMarginStr) {
	      bodyMarginStr = bodyMargin + 'px';
	    }
	
	    setBodyStyle('margin', chkCSS('margin', bodyMarginStr));
	  }
	
	  function stopInfiniteResizingOfIFrame() {
	    document.documentElement.style.height = '';
	    document.body.style.height = '';
	    log('HTML & body height set to "auto"');
	  }
	
	  function manageTriggerEvent(options) {
	    var listener = {
	      add: function(eventName) {
	        function handleEvent() {
	          sendSize(options.eventName, options.eventType);
	        }
	
	        eventHandlersByName[eventName] = handleEvent;
	
	        addEventListener(window, eventName, handleEvent, { passive: true });
	      },
	      remove: function(eventName) {
	        var handleEvent = eventHandlersByName[eventName];
	        delete eventHandlersByName[eventName];
	
	        removeEventListener(window, eventName, handleEvent);
	      }
	    };
	
	    if (options.eventNames && Array.prototype.map) {
	      options.eventName = options.eventNames[0];
	      options.eventNames.map(listener[options.method]);
	    } else {
	      listener[options.method](options.eventName);
	    }
	
	    log(
	      capitalizeFirstLetter(options.method) +
	        ' event listener: ' +
	        options.eventType
	    );
	  }
	
	  function manageEventListeners(method) {
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Animation Start',
	      eventNames: ['animationstart', 'webkitAnimationStart']
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Animation Iteration',
	      eventNames: ['animationiteration', 'webkitAnimationIteration']
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Animation End',
	      eventNames: ['animationend', 'webkitAnimationEnd']
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Input',
	      eventName: 'input'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Mouse Up',
	      eventName: 'mouseup'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Mouse Down',
	      eventName: 'mousedown'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Orientation Change',
	      eventName: 'orientationchange'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Print',
	      eventName: ['afterprint', 'beforeprint']
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Ready State Change',
	      eventName: 'readystatechange'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Touch Start',
	      eventName: 'touchstart'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Touch End',
	      eventName: 'touchend'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Touch Cancel',
	      eventName: 'touchcancel'
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Transition Start',
	      eventNames: [
	        'transitionstart',
	        'webkitTransitionStart',
	        'MSTransitionStart',
	        'oTransitionStart',
	        'otransitionstart'
	      ]
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Transition Iteration',
	      eventNames: [
	        'transitioniteration',
	        'webkitTransitionIteration',
	        'MSTransitionIteration',
	        'oTransitionIteration',
	        'otransitioniteration'
	      ]
	    });
	    manageTriggerEvent({
	      method: method,
	      eventType: 'Transition End',
	      eventNames: [
	        'transitionend',
	        'webkitTransitionEnd',
	        'MSTransitionEnd',
	        'oTransitionEnd',
	        'otransitionend'
	      ]
	    });
	    if ('child' === resizeFrom) {
	      manageTriggerEvent({
	        method: method,
	        eventType: 'IFrame Resized',
	        eventName: 'resize'
	      });
	    }
	  }
	
	  function checkCalcMode(calcMode, calcModeDefault, modes, type) {
	    if (calcModeDefault !== calcMode) {
	      if (!(calcMode in modes)) {
	        warn(
	          calcMode + ' is not a valid option for ' + type + 'CalculationMethod.'
	        );
	        calcMode = calcModeDefault;
	      }
	      log(type + ' calculation method set to "' + calcMode + '"');
	    }
	
	    return calcMode;
	  }
	
	  function checkHeightMode() {
	    heightCalcMode = checkCalcMode(
	      heightCalcMode,
	      heightCalcModeDefault,
	      getHeight,
	      'height'
	    );
	  }
	
	  function checkWidthMode() {
	    widthCalcMode = checkCalcMode(
	      widthCalcMode,
	      widthCalcModeDefault,
	      getWidth,
	      'width'
	    );
	  }
	
	  function startEventListeners() {
	    if (true === autoResize) {
	      manageEventListeners('add');
	      setupMutationObserver();
	    } else {
	      log('Auto Resize disabled');
	    }
	  }
	
	  function stopMsgsToParent() {
	    log('Disable outgoing messages');
	    sendPermit = false;
	  }
	
	  function removeMsgListener() {
	    log('Remove event listener: Message');
	    removeEventListener(window, 'message', receiver);
	  }
	
	  function disconnectMutationObserver() {
	    if (null !== bodyObserver) {
	      /* istanbul ignore next */ // Not testable in PhantonJS
	      bodyObserver.disconnect();
	    }
	  }
	
	  function stopEventListeners() {
	    manageEventListeners('remove');
	    disconnectMutationObserver();
	    clearInterval(intervalTimer);
	  }
	
	  function teardown() {
	    stopMsgsToParent();
	    removeMsgListener();
	    if (true === autoResize) stopEventListeners();
	  }
	
	  function injectClearFixIntoBodyElement() {
	    var clearFix = document.createElement('div');
	    clearFix.style.clear = 'both';
	    clearFix.style.display = 'block'; //Guard against this having been globally redefined in CSS.
	    document.body.appendChild(clearFix);
	  }
	
	  function setupInPageLinks() {
	    function getPagePosition() {
	      return {
	        x:
	          window.pageXOffset !== undefined
	            ? window.pageXOffset
	            : document.documentElement.scrollLeft,
	        y:
	          window.pageYOffset !== undefined
	            ? window.pageYOffset
	            : document.documentElement.scrollTop
	      };
	    }
	
	    function getElementPosition(el) {
	      var elPosition = el.getBoundingClientRect(),
	        pagePosition = getPagePosition();
	
	      return {
	        x: parseInt(elPosition.left, 10) + parseInt(pagePosition.x, 10),
	        y: parseInt(elPosition.top, 10) + parseInt(pagePosition.y, 10)
	      };
	    }
	
	    function findTarget(location) {
	      function jumpToTarget(target) {
	        var jumpPosition = getElementPosition(target);
	
	        log(
	          'Moving to in page link (#' +
	            hash +
	            ') at x: ' +
	            jumpPosition.x +
	            ' y: ' +
	            jumpPosition.y
	        );
	        sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
	      }
	
	      var hash = location.split('#')[1] || location, //Remove # if present
	        hashData = decodeURIComponent(hash),
	        target =
	          document.getElementById(hashData) ||
	          document.getElementsByName(hashData)[0];
	
	      if (undefined !== target) {
	        jumpToTarget(target);
	      } else {
	        log(
	          'In page link (#' +
	            hash +
	            ') not found in iFrame, so sending to parent'
	        );
	        sendMsg(0, 0, 'inPageLink', '#' + hash);
	      }
	    }
	
	    function checkLocationHash() {
	      if ('' !== location.hash && '#' !== location.hash) {
	        findTarget(location.href);
	      }
	    }
	
	    function bindAnchors() {
	      function setupLink(el) {
	        function linkClicked(e) {
	          e.preventDefault();
	
	          /*jshint validthis:true */
	          findTarget(this.getAttribute('href'));
	        }
	
	        if ('#' !== el.getAttribute('href')) {
	          addEventListener(el, 'click', linkClicked);
	        }
	      }
	
	      Array.prototype.forEach.call(
	        document.querySelectorAll('a[href^="#"]'),
	        setupLink
	      );
	    }
	
	    function bindLocationHash() {
	      addEventListener(window, 'hashchange', checkLocationHash);
	    }
	
	    function initCheck() {
	      //check if page loaded with location hash after init resize
	      setTimeout(checkLocationHash, eventCancelTimer);
	    }
	
	    function enableInPageLinks() {
	      /* istanbul ignore else */ // Not testable in phantonJS
	      if (Array.prototype.forEach && document.querySelectorAll) {
	        log('Setting up location.hash handlers');
	        bindAnchors();
	        bindLocationHash();
	        initCheck();
	      } else {
	        warn(
	          'In page linking not fully supported in this browser! (See README.md for IE8 workaround)'
	        );
	      }
	    }
	
	    if (inPageLinks.enable) {
	      enableInPageLinks();
	    } else {
	      log('In page linking not enabled');
	    }
	
	    return {
	      findTarget: findTarget
	    };
	  }
	
	  function setupPublicMethods() {
	    log('Enable public methods');
	
	    win.parentIFrame = {
	      autoResize: function autoResizeF(resize) {
	        if (true === resize && false === autoResize) {
	          autoResize = true;
	          startEventListeners();
	          //sendSize('autoResize','Auto Resize enabled');
	        } else if (false === resize && true === autoResize) {
	          autoResize = false;
	          stopEventListeners();
	        }
	
	        return autoResize;
	      },
	
	      close: function closeF() {
	        sendMsg(0, 0, 'close');
	        teardown();
	      },
	
	      getId: function getIdF() {
	        return myID;
	      },
	
	      getPageInfo: function getPageInfoF(callback) {
	        if ('function' === typeof callback) {
	          pageInfoCallback = callback;
	          sendMsg(0, 0, 'pageInfo');
	        } else {
	          pageInfoCallback = function() {};
	          sendMsg(0, 0, 'pageInfoStop');
	        }
	      },
	
	      moveToAnchor: function moveToAnchorF(hash) {
	        inPageLinks.findTarget(hash);
	      },
	
	      reset: function resetF() {
	        resetIFrame('parentIFrame.reset');
	      },
	
	      scrollTo: function scrollToF(x, y) {
	        sendMsg(y, x, 'scrollTo'); // X&Y reversed at sendMsg uses height/width
	      },
	
	      scrollToOffset: function scrollToF(x, y) {
	        sendMsg(y, x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
	      },
	
	      sendMessage: function sendMessageF(msg, targetOrigin) {
	        sendMsg(0, 0, 'message', JSON.stringify(msg), targetOrigin);
	      },
	
	      setHeightCalculationMethod: function setHeightCalculationMethodF(
	        heightCalculationMethod
	      ) {
	        heightCalcMode = heightCalculationMethod;
	        checkHeightMode();
	      },
	
	      setWidthCalculationMethod: function setWidthCalculationMethodF(
	        widthCalculationMethod
	      ) {
	        widthCalcMode = widthCalculationMethod;
	        checkWidthMode();
	      },
	
	      setTargetOrigin: function setTargetOriginF(targetOrigin) {
	        log('Set targetOrigin: ' + targetOrigin);
	        targetOriginDefault = targetOrigin;
	      },
	
	      size: function sizeF(customHeight, customWidth) {
	        var valString =
	          '' +
	          (customHeight ? customHeight : '') +
	          (customWidth ? ',' + customWidth : '');
	        //lockTrigger();
	        sendSize(
	          'size',
	          'parentIFrame.size(' + valString + ')',
	          customHeight,
	          customWidth
	        );
	      }
	    };
	  }
	
	  function initInterval() {
	    if (0 !== interval) {
	      log('setInterval: ' + interval + 'ms');
	      intervalTimer = setInterval(function() {
	        sendSize('interval', 'setInterval: ' + interval);
	      }, Math.abs(interval));
	    }
	  } //Not testable in PhantomJS
	
	  /* istanbul ignore next */ function setupBodyMutationObserver() {
	    function addImageLoadListners(mutation) {
	      function addImageLoadListener(element) {
	        if (false === element.complete) {
	          log('Attach listeners to ' + element.src);
	          element.addEventListener('load', imageLoaded, false);
	          element.addEventListener('error', imageError, false);
	          elements.push(element);
	        }
	      }
	
	      if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
	        addImageLoadListener(mutation.target);
	      } else if (mutation.type === 'childList') {
	        Array.prototype.forEach.call(
	          mutation.target.querySelectorAll('img'),
	          addImageLoadListener
	        );
	      }
	    }
	
	    function removeFromArray(element) {
	      elements.splice(elements.indexOf(element), 1);
	    }
	
	    function removeImageLoadListener(element) {
	      log('Remove listeners from ' + element.src);
	      element.removeEventListener('load', imageLoaded, false);
	      element.removeEventListener('error', imageError, false);
	      removeFromArray(element);
	    }
	
	    function imageEventTriggered(event, type, typeDesc) {
	      removeImageLoadListener(event.target);
	      sendSize(type, typeDesc + ': ' + event.target.src, undefined, undefined);
	    }
	
	    function imageLoaded(event) {
	      imageEventTriggered(event, 'imageLoad', 'Image loaded');
	    }
	
	    function imageError(event) {
	      imageEventTriggered(event, 'imageLoadFailed', 'Image load failed');
	    }
	
	    function mutationObserved(mutations) {
	      sendSize(
	        'mutationObserver',
	        'mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type
	      );
	
	      //Deal with WebKit asyncing image loading when tags are injected into the page
	      mutations.forEach(addImageLoadListners);
	    }
	
	    function createMutationObserver() {
	      var target = document.querySelector('body'),
	        config = {
	          attributes: true,
	          attributeOldValue: false,
	          characterData: true,
	          characterDataOldValue: false,
	          childList: true,
	          subtree: true
	        };
	
	      observer = new MutationObserver(mutationObserved);
	
	      log('Create body MutationObserver');
	      observer.observe(target, config);
	
	      return observer;
	    }
	
	    var elements = [],
	      MutationObserver =
	        window.MutationObserver || window.WebKitMutationObserver,
	      observer = createMutationObserver();
	
	    return {
	      disconnect: function() {
	        if ('disconnect' in observer) {
	          log('Disconnect body MutationObserver');
	          observer.disconnect();
	          elements.forEach(removeImageLoadListener);
	        }
	      }
	    };
	  }
	
	  function setupMutationObserver() {
	    var forceIntervalTimer = 0 > interval; // Not testable in PhantomJS
	
	    /* istanbul ignore if */ if (
	      window.MutationObserver ||
	      window.WebKitMutationObserver
	    ) {
	      if (forceIntervalTimer) {
	        initInterval();
	      } else {
	        bodyObserver = setupBodyMutationObserver();
	      }
	    } else {
	      log('MutationObserver not supported in this browser!');
	      initInterval();
	    }
	  }
	
	  // document.documentElement.offsetHeight is not reliable, so
	  // we have to jump through hoops to get a better value.
	  function getComputedStyle(prop, el) {
	    /* istanbul ignore next */ //Not testable in PhantomJS
	    function convertUnitsToPxForIE8(value) {
	      var PIXEL = /^\d+(px)?$/i;
	
	      if (PIXEL.test(value)) {
	        return parseInt(value, base);
	      }
	
	      var style = el.style.left,
	        runtimeStyle = el.runtimeStyle.left;
	
	      el.runtimeStyle.left = el.currentStyle.left;
	      el.style.left = value || 0;
	      value = el.style.pixelLeft;
	      el.style.left = style;
	      el.runtimeStyle.left = runtimeStyle;
	
	      return value;
	    }
	
	    var retVal = 0;
	    el = el || document.body; // Not testable in phantonJS
	
	    /* istanbul ignore else */ if (
	      'defaultView' in document &&
	      'getComputedStyle' in document.defaultView
	    ) {
	      retVal = document.defaultView.getComputedStyle(el, null);
	      retVal = null !== retVal ? retVal[prop] : 0;
	    } else {
	      //IE8
	      retVal = convertUnitsToPxForIE8(el.currentStyle[prop]);
	    }
	
	    return parseInt(retVal, base);
	  }
	
	  function chkEventThottle(timer) {
	    if (timer > throttledTimer / 2) {
	      throttledTimer = 2 * timer;
	      log('Event throttle increased to ' + throttledTimer + 'ms');
	    }
	  }
	
	  //Idea from https://github.com/guardian/iframe-messenger
	  function getMaxElement(side, elements) {
	    var elementsLength = elements.length,
	      elVal = 0,
	      maxVal = 0,
	      Side = capitalizeFirstLetter(side),
	      timer = getNow();
	
	    for (var i = 0; i < elementsLength; i++) {
	      elVal =
	        elements[i].getBoundingClientRect()[side] +
	        getComputedStyle('margin' + Side, elements[i]);
	      if (elVal > maxVal) {
	        maxVal = elVal;
	      }
	    }
	
	    timer = getNow() - timer;
	
	    log('Parsed ' + elementsLength + ' HTML elements');
	    log('Element position calculated in ' + timer + 'ms');
	
	    chkEventThottle(timer);
	
	    return maxVal;
	  }
	
	  function getAllMeasurements(dimention) {
	    return [
	      dimention.bodyOffset(),
	      dimention.bodyScroll(),
	      dimention.documentElementOffset(),
	      dimention.documentElementScroll()
	    ];
	  }
	
	  function getTaggedElements(side, tag) {
	    function noTaggedElementsFound() {
	      warn('No tagged elements (' + tag + ') found on page');
	      return document.querySelectorAll('body *');
	    }
	
	    var elements = document.querySelectorAll('[' + tag + ']');
	
	    if (0 === elements.length) noTaggedElementsFound();
	
	    return getMaxElement(side, elements);
	  }
	
	  function getAllElements() {
	    return document.querySelectorAll('body *');
	  }
	
	  var getHeight = {
	      bodyOffset: function getBodyOffsetHeight() {
	        return (
	          document.body.offsetHeight +
	          getComputedStyle('marginTop') +
	          getComputedStyle('marginBottom')
	        );
	      },
	
	      offset: function() {
	        return getHeight.bodyOffset(); //Backwards compatability
	      },
	
	      bodyScroll: function getBodyScrollHeight() {
	        return document.body.scrollHeight;
	      },
	
	      custom: function getCustomWidth() {
	        return customCalcMethods.height();
	      },
	
	      documentElementOffset: function getDEOffsetHeight() {
	        return document.documentElement.offsetHeight;
	      },
	
	      documentElementScroll: function getDEScrollHeight() {
	        return document.documentElement.scrollHeight;
	      },
	
	      max: function getMaxHeight() {
	        return Math.max.apply(null, getAllMeasurements(getHeight));
	      },
	
	      min: function getMinHeight() {
	        return Math.min.apply(null, getAllMeasurements(getHeight));
	      },
	
	      grow: function growHeight() {
	        return getHeight.max(); //Run max without the forced downsizing
	      },
	
	      lowestElement: function getBestHeight() {
	        return Math.max(
	          getHeight.bodyOffset() || getHeight.documentElementOffset(),
	          getMaxElement('bottom', getAllElements())
	        );
	      },
	
	      taggedElement: function getTaggedElementsHeight() {
	        return getTaggedElements('bottom', 'data-iframe-height');
	      }
	    },
	    getWidth = {
	      bodyScroll: function getBodyScrollWidth() {
	        return document.body.scrollWidth;
	      },
	
	      bodyOffset: function getBodyOffsetWidth() {
	        return document.body.offsetWidth;
	      },
	
	      custom: function getCustomWidth() {
	        return customCalcMethods.width();
	      },
	
	      documentElementScroll: function getDEScrollWidth() {
	        return document.documentElement.scrollWidth;
	      },
	
	      documentElementOffset: function getDEOffsetWidth() {
	        return document.documentElement.offsetWidth;
	      },
	
	      scroll: function getMaxWidth() {
	        return Math.max(
	          getWidth.bodyScroll(),
	          getWidth.documentElementScroll()
	        );
	      },
	
	      max: function getMaxWidth() {
	        return Math.max.apply(null, getAllMeasurements(getWidth));
	      },
	
	      min: function getMinWidth() {
	        return Math.min.apply(null, getAllMeasurements(getWidth));
	      },
	
	      rightMostElement: function rightMostElement() {
	        return getMaxElement('right', getAllElements());
	      },
	
	      taggedElement: function getTaggedElementsWidth() {
	        return getTaggedElements('right', 'data-iframe-width');
	      }
	    };
	
	  function sizeIFrame(
	    triggerEvent,
	    triggerEventDesc,
	    customHeight,
	    customWidth
	  ) {
	    function resizeIFrame() {
	      height = currentHeight;
	      width = currentWidth;
	
	      sendMsg(height, width, triggerEvent);
	    }
	
	    function isSizeChangeDetected() {
	      function checkTolarance(a, b) {
	        var retVal = Math.abs(a - b) <= tolerance;
	        return !retVal;
	      }
	
	      currentHeight =
	        undefined !== customHeight ? customHeight : getHeight[heightCalcMode]();
	      currentWidth =
	        undefined !== customWidth ? customWidth : getWidth[widthCalcMode]();
	
	      return (
	        checkTolarance(height, currentHeight) ||
	        (calculateWidth && checkTolarance(width, currentWidth))
	      );
	    }
	
	    function isForceResizableEvent() {
	      return !(triggerEvent in { init: 1, interval: 1, size: 1 });
	    }
	
	    function isForceResizableCalcMode() {
	      return (
	        heightCalcMode in resetRequiredMethods ||
	        (calculateWidth && widthCalcMode in resetRequiredMethods)
	      );
	    }
	
	    function logIgnored() {
	      log('No change in size detected');
	    }
	
	    function checkDownSizing() {
	      if (isForceResizableEvent() && isForceResizableCalcMode()) {
	        resetIFrame(triggerEventDesc);
	      } else if (!(triggerEvent in { interval: 1 })) {
	        logIgnored();
	      }
	    }
	
	    var currentHeight, currentWidth;
	
	    if (isSizeChangeDetected() || 'init' === triggerEvent) {
	      lockTrigger();
	      resizeIFrame();
	    } else {
	      checkDownSizing();
	    }
	  }
	
	  var sizeIFrameThrottled = throttle(sizeIFrame);
	
	  function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
	    function recordTrigger() {
	      if (!(triggerEvent in { reset: 1, resetPage: 1, init: 1 })) {
	        log('Trigger event: ' + triggerEventDesc);
	      }
	    }
	
	    function isDoubleFiredEvent() {
	      return triggerLocked && triggerEvent in doubleEventList;
	    }
	
	    if (!isDoubleFiredEvent()) {
	      recordTrigger();
	      if (triggerEvent === 'init') {
	        sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
	      } else {
	        sizeIFrameThrottled(
	          triggerEvent,
	          triggerEventDesc,
	          customHeight,
	          customWidth
	        );
	      }
	    } else {
	      log('Trigger event cancelled: ' + triggerEvent);
	    }
	  }
	
	  function lockTrigger() {
	    if (!triggerLocked) {
	      triggerLocked = true;
	      log('Trigger event lock on');
	    }
	    clearTimeout(triggerLockedTimer);
	    triggerLockedTimer = setTimeout(function() {
	      triggerLocked = false;
	      log('Trigger event lock off');
	      log('--');
	    }, eventCancelTimer);
	  }
	
	  function triggerReset(triggerEvent) {
	    height = getHeight[heightCalcMode]();
	    width = getWidth[widthCalcMode]();
	
	    sendMsg(height, width, triggerEvent);
	  }
	
	  function resetIFrame(triggerEventDesc) {
	    var hcm = heightCalcMode;
	    heightCalcMode = heightCalcModeDefault;
	
	    log('Reset trigger event: ' + triggerEventDesc);
	    lockTrigger();
	    triggerReset('reset');
	
	    heightCalcMode = hcm;
	  }
	
	  function sendMsg(height, width, triggerEvent, msg, targetOrigin) {
	    function setTargetOrigin() {
	      if (undefined === targetOrigin) {
	        targetOrigin = targetOriginDefault;
	      } else {
	        log('Message targetOrigin: ' + targetOrigin);
	      }
	    }
	
	    function sendToParent() {
	      var size = height + ':' + width,
	        message =
	          myID +
	          ':' +
	          size +
	          ':' +
	          triggerEvent +
	          (undefined !== msg ? ':' + msg : '');
	
	      log('Sending message to host page (' + message + ')');
	      target.postMessage(msgID + message, targetOrigin);
	    }
	
	    if (true === sendPermit) {
	      setTargetOrigin();
	      sendToParent();
	    }
	  }
	
	  function receiver(event) {
	    var processRequestFromParent = {
	      init: function initFromParent() {
	        initMsg = event.data;
	        target = event.source;
	
	        init();
	        firstRun = false;
	        setTimeout(function() {
	          initLock = false;
	        }, eventCancelTimer);
	      },
	
	      reset: function resetFromParent() {
	        if (!initLock) {
	          log('Page size reset by host page');
	          triggerReset('resetPage');
	        } else {
	          log('Page reset ignored by init');
	        }
	      },
	
	      resize: function resizeFromParent() {
	        sendSize('resizeParent', 'Parent window requested size check');
	      },
	
	      moveToAnchor: function moveToAnchorF() {
	        inPageLinks.findTarget(getData());
	      },
	      inPageLink: function inPageLinkF() {
	        this.moveToAnchor();
	      }, //Backward compatability
	
	      pageInfo: function pageInfoFromParent() {
	        var msgBody = getData();
	        log('PageInfoFromParent called from parent: ' + msgBody);
	        pageInfoCallback(JSON.parse(msgBody));
	        log(' --');
	      },
	
	      message: function messageFromParent() {
	        var msgBody = getData();
	
	        log('MessageCallback called from parent: ' + msgBody);
	        messageCallback(JSON.parse(msgBody));
	        log(' --');
	      }
	    };
	
	    function isMessageForUs() {
	      return msgID === ('' + event.data).substr(0, msgIdLen); //''+ Protects against non-string messages
	    }
	
	    function getMessageType() {
	      return event.data.split(']')[1].split(':')[0];
	    }
	
	    function getData() {
	      return event.data.substr(event.data.indexOf(':') + 1);
	    }
	
	    function isMiddleTier() {
	      return (
	        (!(typeof module !== 'undefined' && module.exports) &&
	          'iFrameResize' in window) ||
	        ('jQuery' in window && 'iFrameResize' in window.jQuery.prototype)
	      );
	    }
	
	    function isInitMsg() {
	      //Test if this message is from a child below us. This is an ugly test, however, updating
	      //the message format would break backwards compatibity.
	      return event.data.split(':')[2] in { true: 1, false: 1 };
	    }
	
	    function callFromParent() {
	      var messageType = getMessageType();
	
	      if (messageType in processRequestFromParent) {
	        processRequestFromParent[messageType]();
	      } else if (!isMiddleTier() && !isInitMsg()) {
	        warn('Unexpected message (' + event.data + ')');
	      }
	    }
	
	    function processMessage() {
	      if (false === firstRun) {
	        callFromParent();
	      } else if (isInitMsg()) {
	        processRequestFromParent.init();
	      } else {
	        log(
	          'Ignored message of type "' +
	            getMessageType() +
	            '". Received before initialization.'
	        );
	      }
	    }
	
	    if (isMessageForUs()) {
	      processMessage();
	    }
	  }
	
	  //Normally the parent kicks things off when it detects the iFrame has loaded.
	  //If this script is async-loaded, then tell parent page to retry init.
	  function chkLateLoaded() {
	    if ('loading' !== document.readyState) {
	      window.parent.postMessage('[iFrameResizerChild]Ready', '*');
	    }
	  }
	
	  addEventListener(window, 'message', receiver);
	  addEventListener(window, 'readystatechange', chkLateLoaded);
	  chkLateLoaded();
	
	  
	})();


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = floatLabelDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _autosize = __webpack_require__(14);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Applies the correct class names to the field.
	 *
	 * @param e - The event object
	 */
	function setState() {
	    var _this = this;
	
	    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var field = (0, _jquery2.default)(this);
	
	    // Wrap within an instantaneous timeout so state changes can be detected on the next redraw. This fixes a
	    // problem with the "keydown" event in that the key value is added to the field after the event has been
	    // called. This means the value of the field returned will be the previous value. The timeout ensures that
	    // the input happens before the value is checked.
	    setTimeout(function () {
	
	        // Enhance the file input by outputting information about the selected file
	        if (field.is('input[type="file"]')) {
	            var div = field.siblings('div');
	            var fileName = '';
	
	            if (_this.files && _this.files.length > 1) {
	                fileName = _this.files.length + ' files selected';
	            } else {
	                fileName = _this.value.split('\\').pop();
	            }
	
	            div.html(fileName);
	        }
	
	        field.closest('[sw-float-label]')
	
	        // Set the field type as a class to the float label wrapper
	        .addClass('-type-' + field.prop('tagName').toLowerCase())
	
	        // Is the element in focus?
	        .toggleClass('is-focused', e.type == 'focus' || field.is(':focus'))
	
	        // Check if the fields value is an empty string. This works for select options that have an empty
	        // value. This can be exploited by creating an empty option, disabling it and setting it as the
	        // default.
	        .toggleClass('is-filled', !!field.val())
	
	        // Only apply if browser supports field validation
	        .toggleClass('is-invalid', field[0].validity && !field[0].validity.valid)
	
	        // Specifically for textarea's. This is useful so that the label can be hidden when the content is
	        // scrolled, so that the label and the fields text don't overlap and look ugly.
	        .toggleClass('is-scrolled', field.scrollTop() > 0);
	    });
	}
	
	/**
	 * Adds float label behaviour to marked fields.
	 *
	 * @param context
	 */
	function floatLabelDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	
	    (0, _jquery2.default)(context).find('[sw-float-label]').find('input, select, textarea').on('focus blur change keyup keydown scroll', setState).each(setState);
	}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = validatorDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The CDN directory of the Parsley library.
	 *
	 * @see http://parsleyjs.org/
	 * @type {string}
	 */
	var parsleyDir = 'https://cdnjs.cloudflare.com/ajax/libs/parsley.js/2.7.2/';
	
	function setFormEnabled($form, enabled) {
	    $form.find('input, select, textarea').prop('readonly', !enabled);
	    $form.find('button').prop('disabled', !enabled);
	}
	
	/**
	 * Enhances forms with live validation.
	 *
	 * @param context
	 */
	function validatorDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $forms = $context.find('form[sw-validator]');
	
	    // Only load Parsley if there are forms on the page
	    if ($forms.length > 0) {
	        (0, _request.dependency)(parsleyDir + 'parsley.min.js', function () {
	            return window.Parsley;
	        }).then(function () {
	            $forms.each(function () {
	                var $form = (0, _jquery2.default)(this);
	                var parsley = $form.parsley();
	
	                parsley.on('field:validated', function (_ref) {
	                    var $element = _ref.$element;
	
	                    // Make sure errors reported by the server get removed
	                    $element.siblings('.float-label_errors').remove();
	                });
	
	                parsley.on('form:submit', function (_ref2) {
	                    var $element = _ref2.$element;
	
	                    $element.addClass('is-posting');
	                    setFormEnabled($element, false);
	
	                    var target = $element.prop('target');
	                    var $iframe = target ? (0, _jquery2.default)('iframe[name="' + target + '"]') : (0, _jquery2.default)();
	
	                    $iframe.one('load', function (e) {
	                        $element.removeClass('is-posting');
	                        setFormEnabled($element, true);
	                    });
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.dependency = dependency;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Loads an external Javascript file and executes it.
	 *
	 * @param url - The URL to the Javascript file
	 * @param check - An optional function to return a boolean for manually checking if the script has correctly executed.
	 *   This ensures that the callback actually happens after the script has been executed. For example, if loading jQuery
	 *   this function could check whether the jQuery property exists on the window object.
	 * @return Promise
	 */
	var loadedDependencies = null;
	function dependency(url) {
	    var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	        return true;
	    };
	    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
	
	
	    if (!loadedDependencies) {
	        loadedDependencies = {};
	
	        // Add existing Javascript files as dependencies
	        // TODO Handle `defer` and `async`
	        (0, _jquery2.default)('script[src]').each(function () {
	            var src = (0, _jquery2.default)(this).prop('src');
	            loadedDependencies[src] = true;
	        });
	    }
	
	    return new Promise(function (resolve, reject) {
	
	        var startTime = Date.now();
	        function poll() {
	            if (check()) {
	                resolve();
	            } else if (Date.now() - startTime > timeout) {
	                reject();
	            } else {
	                setTimeout(poll, 50);
	            }
	        }
	
	        if (!loadedDependencies[url]) {
	            loadedDependencies[url] = true;
	            _jquery2.default.getScript(url).done(poll).fail(reject);
	        } else {
	            poll();
	        }
	    });
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = validatorDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recaptchaPath = 'https://www.google.com/recaptcha/api.js';
	
	/**
	 * Enhances forms with Google reCAPTCHA functionality.
	 * Requires use of the reCAPTCHA Craft plugin.
	 *
	 * @param context
	 */
	function validatorDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
		var $forms = $context.find('form[sw-recaptcha]');
	
		// Only load reCAPTCHA API if there are forms on the page
		if ($forms.length > 0) {
			(0, _request.dependency)(recaptchaPath, function () {
	
				$forms.each(function () {
					var $form = (0, _jquery2.default)(this);
	
					var $recaptcha = $form.find('.g-recaptcha');
					var callbackName = $form.attr('sw-recaptcha');
					var formParsley = window.Parsley ? $form.parsley() : null;
	
					window[callbackName] = function () {
						// Removes all recaptcha event listeners so the recaptcha doesn't resend when resubmitting
						$recaptcha.replaceWith($recaptcha.clone());
						if (formParsley) {
							formParsley.whenValidate().then(function () {
								$form.submit();
							});
						}
					};
				});
			}, function () {
				return window.grecaptcha;
			});
		}
	}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = lightboxDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(21);
	
	var _drawing = __webpack_require__(10);
	
	var _parse = __webpack_require__(6);
	
	var _data = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The CDN directory of the PhotoSwipe library.
	 *
	 * @see http://photoswipe.com
	 * @type {string}
	 */
	var photoswipeDir = 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.2/';
	
	/**
	 * The reusable template for PhotoSwipe.
	 *
	 * @see http://photoswipe.com/documentation/getting-started.html
	 */
	var template = '\n    <div id="lightbox" class="pswp lightbox" tabindex="-1" role="dialog" aria-hidden="true">\n        <div class="pswp__bg"></div>\n        <div class="pswp__scroll-wrap">\n            <div class="pswp__container">\n                <div class="pswp__item lightbox_item"></div>\n                <div class="pswp__item lightbox_item"></div>\n                <div class="pswp__item lightbox_item"></div>\n            </div>\n            <div class="pswp__ui pswp__ui--hidden">\n                <div class="pswp__top-bar">\n                    <div class="pswp__counter"></div>\n                    <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\n                    <button class="pswp__button pswp__button--share" title="Share"></button>\n                    <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>\n                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>\n                    <div class="pswp__preloader">\n                        <div class="pswp__preloader__icn">\n                          <div class="pswp__preloader__cut">\n                            <div class="pswp__preloader__donut"></div>\n                          </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\n                    <div class="pswp__share-tooltip"></div>\n                </div>\n                <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>\n                <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>\n                <div class="pswp__caption">\n                    <div class="pswp__caption__center"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n';
	
	/**
	 *
	 * @param element
	 * @returns {{}}
	 */
	function getConfigFromElement(element) {
	    // TODO
	    return {};
	}
	
	var initialised = false;
	var pswpElement = null;
	
	/**
	 * Initializes a PhotoSwipe gallery.
	 *
	 * @see http://idangero.us/swiper
	 * @param context
	 */
	function lightboxDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $lightboxes = $context.find('[sw-lightbox]');
	
	    if ($lightboxes.length > 0) {
	
	        if (!initialised) {
	            initialised = true;
	
	            (0, _jquery2.default)('head').append('\n                <link rel="stylesheet" href="' + photoswipeDir + 'photoswipe.min.css">\n                <link rel="stylesheet" href="' + photoswipeDir + 'default-skin/default-skin.min.css">\n            ');
	
	            (0, _jquery2.default)('body').append(template);
	
	            pswpElement = (0, _jquery2.default)('#lightbox')[0];
	        }
	
	        (0, _request.dependency)(photoswipeDir + 'photoswipe.min.js');
	        (0, _request.dependency)(photoswipeDir + 'photoswipe-ui-default.min.js', function () {
	            return window.PhotoSwipe && window.PhotoSwipeUI_Default;
	        }).then(function () {
	            var groups = {};
	
	            $lightboxes.each(function () {
	                var $element = (0, _jquery2.default)(this);
	                var json = $element.attr('sw-lightbox');
	                var settings = (0, _parse.directiveSettings)(json, {
	                    group: null,
	                    thumbnailUrl: '',
	                    html: '',
	                    url: '',
	                    width: 1280,
	                    height: 720,
	                    title: null
	                }, 'url');
	
	                settings.group = settings.group || (0, _data.uniqueId)();
	
	                if (!(settings.group in groups)) {
	                    groups[settings.group] = {
	                        elements: [],
	                        items: []
	                    };
	                }
	
	                var group = groups[settings.group];
	                var item = {
	                    msrc: settings.thumbnailUrl,
	                    w: settings.width | 0,
	                    h: settings.height | 0,
	                    title: settings.title
	                };
	
	                if (settings.html) {
	                    item.html = settings.html;
	                } else {
	                    item.src = settings.url;
	                }
	
	                group.elements.push(this);
	                group.items.push(item);
	
	                $element.on('click', function (e) {
	                    e.preventDefault();
	
	                    var options = {
	                        history: false,
	                        index: group.elements.indexOf(this),
	                        getThumbBoundsFn: function getThumbBoundsFn(index) {
	                            var $currentElement = (0, _jquery2.default)(group.elements[index]);
	                            var $thumb = $currentElement.is('[sw-lightbox-thumb]') ? $currentElement : $currentElement.find('[sw-lightbox-thumb]');
	                            var offset = $thumb.offset();
	                            var width = $thumb.width();
	                            var height = $thumb.height();
	
	                            // If the thumbnail has been letterboxed, this will get the correct width
	                            var trueWidth = Math.min(width, height / settings.height * settings.width);
	
	                            return offset ? {
	                                x: offset.left + (width - trueWidth) / 2,
	                                y: offset.top,
	                                w: trueWidth
	                            } : null;
	                        }
	                    };
	
	                    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, group.items, options);
	                    gallery.init();
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.uniqueId = uniqueId;
	/**
	 * Generates a unique ID.
	 *
	 * @returns String
	 */
	var existingUniqueIds = {};
	function uniqueId() {
	    var range = Math.pow(10, 9);
	    var id = null;
	    while (!id || existingUniqueIds[id]) {
	        id = 'id' + (Math.random() * range | 0).toString(36);
	    }
	    existingUniqueIds[id] = true;
	    return id;
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = playOnHoverDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function playOnHoverDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $element = (0, _jquery2.default)(context).find('[sw-play-on-hover]');
	
	    $element.each(function () {
	        var $this = (0, _jquery2.default)(this);
	        var $videos = $this.find('video');
	
	        $this.on('mouseenter', function () {
	            $videos.each(function () {
	                if (!this.ended || this.loop) {
	                    this.play();
	                }
	            });
	        }).on('mouseleave', function () {
	            $videos.each(function () {
	                this.pause();
	            });
	        });
	    });
	}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = swiperDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(21);
	
	var _drawing = __webpack_require__(10);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The CDN directory of the Swiper library.
	 *
	 * @see http://idangero.us/swiper
	 * @type {string}
	 */
	var swiperDir = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/3.4.2/';
	
	var addedCss = false;
	
	/**
	 * Initializes a Swiper carousel.
	 *
	 * @see http://idangero.us/swiper
	 * @param context
	 */
	function swiperDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $swipers = $context.find('[sw-swiper]');
	
	    if ($swipers.length > 0) {
	
	        if (!addedCss) {
	            addedCss = true;
	            (0, _jquery2.default)('head').append('<link rel="stylesheet" href="' + swiperDir + 'css/swiper.min.css">');
	        }
	
	        (0, _request.dependency)(swiperDir + 'js/swiper.min.js', function () {
	            return window.Swiper;
	        }).then(function () {
	            $swipers.each(function () {
	                var $element = (0, _jquery2.default)(this);
	                var json = $element.attr('sw-swiper');
	                var settings = (0, _parse.directiveSettings)(json, {
	                    loop: true,
	                    preloadImages: false,
	                    lazyLoading: true,
	                    lazyLoadingInPrevNext: true,
	                    paginationElement: 'button',
	                    paginationClickable: true,
	                    paginationBulletRender: function paginationBulletRender(swiper, index, className) {
	                        var arr = Array.from(swiper.slides);
	                        var newArr = [];
	                        // console.log(arr);
	
	                        arr.forEach(function (element) {
	                            if (!(0, _jquery2.default)(element).hasClass('swiper-slide-duplicate')) {
	                                newArr.push((0, _jquery2.default)(element).find('.media .media_object img'));
	                            }
	                        });
	
	                        // console.log(newArr);
	
	                        return '<button class="' + className + '"><img src="' + newArr[index][0].currentSrc + '" /></button>';
	                    },
	                    runCallbacksOnInit: true
	                });
	
	                var $slides = $element.find('.swiper-slide');
	                var swiper = $slides.length > 1 ? new Swiper(this, settings) : false;
	
	                (0, _drawing.frame)(function () {
	                    return $element.addClass('swiper-ready');
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = mapDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(21);
	
	var _parse = __webpack_require__(6);
	
	var _drawing = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The URL to the Google Maps JS API
	 *
	 * @type {string}
	 */
	var apiUrl = 'https://maps.googleapis.com/maps/api/js?libraries=geometry,places';
	
	/**
	 * Initializes a Google Map.
	 *
	 * @param context
	 * @param init
	 */
	function mapDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $window = (0, _jquery2.default)(window);
		var $context = (0, _jquery2.default)(context);
		var $maps = $context.find('[sw-map]');
	
		$maps.each(function () {
			var $element = (0, _jquery2.default)(this);
			var json = $element.attr('sw-map');
			var settings = (0, _parse.directiveSettings)(json, {
				apiKey: null,
				lat: 0,
				lng: 0,
				zoom: 0,
				control: false,
				marker: true,
				markerColor: false,
				link: null,
				style: []
			});
	
			if (settings.apiKey) {
				(0, _request.dependency)(apiUrl + ('&key=' + settings.apiKey), function () {
					return window.google && google.maps;
				}).then(function () {
	
					var point = new google.maps.LatLng(settings.lat, settings.lng);
					var map = new google.maps.Map($element[0], {
						center: point,
						zoom: settings.zoom,
						mapTypeId: google.maps.MapTypeId.ROADMAP,
						scrollwheel: false,
						streetViewControl: false,
						draggable: settings.control,
						panControl: false,
						overviewMapControl: false,
						zoomControl: settings.control,
						mapTypeControl: false,
						disableDefaultUI: true,
						disableDoubleClickZoom: true,
						styles: settings.style
					});
	
					var offset = 0;
	
					if (settings.marker) {
	
						var icon = settings.markerColor ? {
							path: 'M10,2.009c-2.762,0-5,2.229-5,4.99c0,4.774,5,11,5,11s5-6.227,5-11C15,4.239,12.762,2.009,10,2.009z M10,9.76c-1.492,0-2.7-1.209-2.7-2.7s1.208-2.7,2.7-2.7c1.49,0,2.699,1.209,2.699,2.7S11.49,9.76,10,9.76z',
							anchor: new google.maps.Point(10, 20),
							scale: 4,
							fillColor: settings.markerColor,
							fillOpacity: 1,
							strokeWeight: 0
						} : null;
	
						var marker = new google.maps.Marker({ map: map, icon: icon, position: point });
	
						if (settings.link) {
							marker.addListener('click', function () {
								return window.open(settings.link, '_blank');
							});
						}
					}
	
					function recenterMap() {
						map.setCenter(point);
						map.panBy(0, offset);
					}
	
					recenterMap();
					$window.on('load resize', function () {
						return (0, _drawing.frame)(recenterMap);
					});
				});
			}
		});
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = fadeDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Fades an element out or in, the closer or farther it moves to or from the top of the window.
	 * Start fade-out once an element reaches 25% of the window height: <div sw-fade="0.25"></div>
	 * Start fade-out at 75% of the window height, and finish at 25%, based on the top position of the element:
	 * <div sw-fade='{"scroll": 0.5, "position": "top", "offset": 0.25}'></div>
	 *
	 * @param context
	 */
	function fadeDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('[sw-fade]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-fade');
	        var settings = (0, _parse.directiveSettings)(json, {
	            scroll: 0.25,
	            position: 'middle',
	            offset: 0
	        }, 'scroll');
	
	        (0, _window.onScroll)(function () {
	            var elementOffset = $element.offset().top - (0, _window.getHeight)() * settings.offset;
	            var elementHeight = $element.outerHeight();
	            var elementPosition = void 0;
	            switch (settings.position) {
	                case 'top':
	                    elementPosition = 0;break;
	                case 'bottom':
	                    elementPosition = elementHeight;break;
	                default:
	                    elementPosition = elementHeight / 2;break;
	            }
	            var contentPos = elementOffset + elementPosition - (0, _window.getScrollTop)();
	            var fadeHeight = (0, _window.getHeight)() * settings.scroll;
	            var opacity = contentPos / fadeHeight;
	            if (opacity < 0) {
	                opacity = 0;
	            } else if (opacity > 1) {
	                opacity = 1;
	            }
	            if (parseFloat($element.css('opacity')) !== opacity) {
	                $element.css('opacity', opacity);
	            }
	        });
	    });
	}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getProperties = getProperties;
	exports.getWidth = getWidth;
	exports.getHeight = getHeight;
	exports.getScrollTop = getScrollTop;
	exports.getScrollLeft = getScrollLeft;
	exports.getScrollWidth = getScrollWidth;
	exports.getScrollHeight = getScrollHeight;
	exports.onResize = onResize;
	exports.onScroll = onScroll;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _drawing = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $window = (0, _jquery2.default)(window);
	var properties = {};
	
	function updateDimensions() {
	  properties.width = $window.width();
	  properties.height = $window.height();
	}
	
	function updateScroll() {
	  properties.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
	  properties.scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
	  properties.scrollWidth = document.documentElement.scrollWidth || document.body.scrollWidth;
	  properties.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
	}
	
	updateDimensions();
	updateScroll();
	
	$window.on('load resize', function () {
	  updateDimensions();updateScroll();
	});
	$window.on('scroll', function () {
	  updateScroll();
	});
	
	/**
	 * Returns all the above properties of the window object.
	 *
	 * @returns Object
	 */
	function getProperties() {
	  return Object.assign({}, properties);
	}
	
	/**
	 * Returns the width of the window in pixels.
	 *
	 * @returns Number
	 */
	function getWidth() {
	  return properties.width;
	}
	
	/**
	 * Returns the height of the window in pixels.
	 *
	 * @returns Number
	 */
	function getHeight() {
	  return properties.height;
	}
	
	/**
	 * Returns the top scroll value of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollTop() {
	  return properties.scrollTop;
	}
	
	/**
	 * Returns the left scroll value of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollLeft() {
	  return properties.scrollLeft;
	}
	
	/**
	 * Returns the scrollable width of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollWidth() {
	  return properties.scrollWidth;
	}
	
	/**
	 * Returns the scrollable height of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollHeight() {
	  return properties.scrollHeight;
	}
	
	/**
	 * Binds a callback to resize events in a performant way.
	 * Returns a function that, when called, unbinds the events.
	 *
	 * @param callback
	 * @returns {Function}
	 */
	function onResize(callback) {
	  var currentFrame = void 0;
	  function debounce(e) {
	    (0, _drawing.unframe)(currentFrame);
	    currentFrame = (0, _drawing.frame)(function () {
	      return callback(e);
	    });
	  }
	
	  $window.on('load resize', debounce);
	
	  callback();
	
	  return function () {
	    return $window.off('load resize', debounce);
	  };
	}
	
	/**
	 * Binds a callback to scrolling events in a performant way.
	 * Returns a function that, when called, unbinds the events.
	 *
	 * @param callback
	 * @returns {Function}
	 */
	function onScroll(callback) {
	  var currentFrame = void 0;
	  function debounce(e) {
	    (0, _drawing.unframe)(currentFrame);
	    currentFrame = (0, _drawing.frame)(function () {
	      return callback(e);
	    });
	  }
	
	  $window.on('load resize scroll', debounce);
	
	  callback();
	
	  return function () {
	    return $window.off('load resize scroll', debounce);
	  };
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = lazyLoadDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _blazy = __webpack_require__(31);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _data = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Lazily loads images, backgrounds, videos and iframes.
	 *
	 * @see http://dinbror.dk/blog/blazy/
	 * @param context
	 */
	function lazyLoadDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var container = 'window';
	
		/*
	  * Problem:
	  *   Blazy library only supports a string selector for the container element.
	  *   This means that the `context` argument above cannot be passed directly as a DOM element to the Blazy
	  *   initialisation function.
	  *
	  * Solution:
	  *   Generate a unique attribute for the element, add it to the element, then use a selector targeting that
	  *   attribute.
	  */
		if (context !== document.body) {
			var uniqueAttr = 'data-' + (0, _data.uniqueId)();
			container = '[' + uniqueAttr + ']';
	
			(0, _jquery2.default)(context).attr(uniqueAttr, true);
		}
	
		var blazy = new _blazy2.default({
			container: container,
			selector: '[sw-lazy-load]',
			src: 'sw-lazy-load',
			successClass: 'is-ready',
			errorClass: 'is-broken'
		});
	
		(0, _jquery2.default)(function () {
			return blazy.revalidate();
		});
	}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  hey, [be]Lazy.js - v1.8.2 - 2016.10.25
	  A fast, small and dependency free lazy load script (https://github.com/dinbror/blazy)
	  (c) Bjoern Klinggaard - @bklinggaard - http://dinbror.dk/blazy
	*/
	;
	(function(root, blazy) {
	    if (true) {
	        // AMD. Register bLazy as an anonymous module
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (blazy), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = blazy();
	    } else {
	        // Browser globals. Register bLazy on window
	        root.Blazy = blazy();
	    }
	})(this, function() {
	    'use strict';
	
	    //private vars
	    var _source, _viewport, _isRetina, _supportClosest, _attrSrc = 'src', _attrSrcset = 'srcset';
	
	    // constructor
	    return function Blazy(options) {
	        //IE7- fallback for missing querySelectorAll support
	        if (!document.querySelectorAll) {
	            var s = document.createStyleSheet();
	            document.querySelectorAll = function(r, c, i, j, a) {
	                a = document.all, c = [], r = r.replace(/\[for\b/gi, '[htmlFor').split(',');
	                for (i = r.length; i--;) {
	                    s.addRule(r[i], 'k:v');
	                    for (j = a.length; j--;) a[j].currentStyle.k && c.push(a[j]);
	                    s.removeRule(0);
	                }
	                return c;
	            };
	        }
	
	        //options and helper vars
	        var scope = this;
	        var util = scope._util = {};
	        util.elements = [];
	        util.destroyed = true;
	        scope.options = options || {};
	        scope.options.error = scope.options.error || false;
	        scope.options.offset = scope.options.offset || 100;
	        scope.options.root = scope.options.root || document;
	        scope.options.success = scope.options.success || false;
	        scope.options.selector = scope.options.selector || '.b-lazy';
	        scope.options.separator = scope.options.separator || '|';
	        scope.options.containerClass = scope.options.container;
	        scope.options.container = scope.options.containerClass ? document.querySelectorAll(scope.options.containerClass) : false;
	        scope.options.errorClass = scope.options.errorClass || 'b-error';
	        scope.options.breakpoints = scope.options.breakpoints || false;
	        scope.options.loadInvisible = scope.options.loadInvisible || false;
	        scope.options.successClass = scope.options.successClass || 'b-loaded';
	        scope.options.validateDelay = scope.options.validateDelay || 25;
	        scope.options.saveViewportOffsetDelay = scope.options.saveViewportOffsetDelay || 50;
	        scope.options.srcset = scope.options.srcset || 'data-srcset';
	        scope.options.src = _source = scope.options.src || 'data-src';
	        _supportClosest = Element.prototype.closest;
	        _isRetina = window.devicePixelRatio > 1;
	        _viewport = {};
	        _viewport.top = 0 - scope.options.offset;
	        _viewport.left = 0 - scope.options.offset;
	
	
	        /* public functions
	         ************************************/
	        scope.revalidate = function() {
	            initialize(scope);
	        };
	        scope.load = function(elements, force) {
	            var opt = this.options;
	            if (elements && elements.length === undefined) {
	                loadElement(elements, force, opt);
	            } else {
	                each(elements, function(element) {
	                    loadElement(element, force, opt);
	                });
	            }
	        };
	        scope.destroy = function() {            
	            var util = scope._util;
	            if (scope.options.container) {
	                each(scope.options.container, function(object) {
	                    unbindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            unbindEvent(window, 'scroll', util.validateT);
	            unbindEvent(window, 'resize', util.validateT);
	            unbindEvent(window, 'resize', util.saveViewportOffsetT);
	            util.count = 0;
	            util.elements.length = 0;
	            util.destroyed = true;
	        };
	
	        //throttle, ensures that we don't call the functions too often
	        util.validateT = throttle(function() {
	            validate(scope);
	        }, scope.options.validateDelay, scope);
	        util.saveViewportOffsetT = throttle(function() {
	            saveViewportOffset(scope.options.offset);
	        }, scope.options.saveViewportOffsetDelay, scope);
	        saveViewportOffset(scope.options.offset);
	
	        //handle multi-served image src (obsolete)
	        each(scope.options.breakpoints, function(object) {
	            if (object.width >= window.screen.width) {
	                _source = object.src;
	                return false;
	            }
	        });
	
	        // start lazy load
	        setTimeout(function() {
	            initialize(scope);
	        }); // "dom ready" fix
	
	    };
	
	
	    /* Private helper functions
	     ************************************/
	    function initialize(self) {
	        var util = self._util;
	        // First we create an array of elements to lazy load
	        util.elements = toArray(self.options);
	        util.count = util.elements.length;
	        // Then we bind resize and scroll events if not already binded
	        if (util.destroyed) {
	            util.destroyed = false;
	            if (self.options.container) {
	                each(self.options.container, function(object) {
	                    bindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            bindEvent(window, 'resize', util.saveViewportOffsetT);
	            bindEvent(window, 'resize', util.validateT);
	            bindEvent(window, 'scroll', util.validateT);
	        }
	        // And finally, we start to lazy load.
	        validate(self);
	    }
	
	    function validate(self) {
	        var util = self._util;
	        for (var i = 0; i < util.count; i++) {
	            var element = util.elements[i];
	            if (elementInView(element, self.options) || hasClass(element, self.options.successClass)) {
	                self.load(element);
	                util.elements.splice(i, 1);
	                util.count--;
	                i--;
	            }
	        }
	        if (util.count === 0) {
	            self.destroy();
	        }
	    }
	
	    function elementInView(ele, options) {
	        var rect = ele.getBoundingClientRect();
	
	        if(options.container && _supportClosest){
	            // Is element inside a container?
	            var elementContainer = ele.closest(options.containerClass);
	            if(elementContainer){
	                var containerRect = elementContainer.getBoundingClientRect();
	                // Is container in view?
	                if(inView(containerRect, _viewport)){
	                    var top = containerRect.top - options.offset;
	                    var right = containerRect.right + options.offset;
	                    var bottom = containerRect.bottom + options.offset;
	                    var left = containerRect.left - options.offset;
	                    var containerRectWithOffset = {
	                        top: top > _viewport.top ? top : _viewport.top,
	                        right: right < _viewport.right ? right : _viewport.right,
	                        bottom: bottom < _viewport.bottom ? bottom : _viewport.bottom,
	                        left: left > _viewport.left ? left : _viewport.left
	                    };
	                    // Is element in view of container?
	                    return inView(rect, containerRectWithOffset);
	                } else {
	                    return false;
	                }
	            }
	        }      
	        return inView(rect, _viewport);
	    }
	
	    function inView(rect, viewport){
	        // Intersection
	        return rect.right >= viewport.left &&
	               rect.bottom >= viewport.top && 
	               rect.left <= viewport.right && 
	               rect.top <= viewport.bottom;
	    }
	
	    function loadElement(ele, force, options) {
	        // if element is visible, not loaded or forced
	        if (!hasClass(ele, options.successClass) && (force || options.loadInvisible || (ele.offsetWidth > 0 && ele.offsetHeight > 0))) {
	            var dataSrc = getAttr(ele, _source) || getAttr(ele, options.src); // fallback to default 'data-src'
	            if (dataSrc) {
	                var dataSrcSplitted = dataSrc.split(options.separator);
	                var src = dataSrcSplitted[_isRetina && dataSrcSplitted.length > 1 ? 1 : 0];
	                var srcset = getAttr(ele, options.srcset);
	                var isImage = equal(ele, 'img');
	                var parent = ele.parentNode;
	                var isPicture = parent && equal(parent, 'picture');
	                // Image or background image
	                if (isImage || ele.src === undefined) {
	                    var img = new Image();
	                    // using EventListener instead of onerror and onload
	                    // due to bug introduced in chrome v50 
	                    // (https://productforums.google.com/forum/#!topic/chrome/p51Lk7vnP2o)
	                    var onErrorHandler = function() {
	                        if (options.error) options.error(ele, "invalid");
	                        addClass(ele, options.errorClass);
	                        unbindEvent(img, 'error', onErrorHandler);
	                        unbindEvent(img, 'load', onLoadHandler);
	                    };
	                    var onLoadHandler = function() {
	                        // Is element an image
	                        if (isImage) {
	                            if(!isPicture) {
	                                handleSources(ele, src, srcset);
	                            }
	                        // or background-image
	                        } else {
	                            ele.style.backgroundImage = 'url("' + src + '")';
	                        }
	                        itemLoaded(ele, options);
	                        unbindEvent(img, 'load', onLoadHandler);
	                        unbindEvent(img, 'error', onErrorHandler);
	                    };
	                    
	                    // Picture element
	                    if (isPicture) {
	                        img = ele; // Image tag inside picture element wont get preloaded
	                        each(parent.getElementsByTagName('source'), function(source) {
	                            handleSource(source, _attrSrcset, options.srcset);
	                        });
	                    }
	                    bindEvent(img, 'error', onErrorHandler);
	                    bindEvent(img, 'load', onLoadHandler);
	                    handleSources(img, src, srcset); // Preload
	
	                } else { // An item with src like iframe, unity games, simpel video etc
	                    ele.src = src;
	                    itemLoaded(ele, options);
	                }
	            } else {
	                // video with child source
	                if (equal(ele, 'video')) {
	                    each(ele.getElementsByTagName('source'), function(source) {
	                        handleSource(source, _attrSrc, options.src);
	                    });
	                    ele.load();
	                    itemLoaded(ele, options);
	                } else {
	                    if (options.error) options.error(ele, "missing");
	                    addClass(ele, options.errorClass);
	                }
	            }
	        }
	    }
	
	    function itemLoaded(ele, options) {
	        addClass(ele, options.successClass);
	        if (options.success) options.success(ele);
	        // cleanup markup, remove data source attributes
	        removeAttr(ele, options.src);
	        removeAttr(ele, options.srcset);
	        each(options.breakpoints, function(object) {
	            removeAttr(ele, object.src);
	        });
	    }
	
	    function handleSource(ele, attr, dataAttr) {
	        var dataSrc = getAttr(ele, dataAttr);
	        if (dataSrc) {
	            setAttr(ele, attr, dataSrc);
	            removeAttr(ele, dataAttr);
	        }
	    }
	
	    function handleSources(ele, src, srcset){
	        if(srcset) {
	            setAttr(ele, _attrSrcset, srcset); //srcset
	        }
	        ele.src = src; //src 
	    }
	
	    function setAttr(ele, attr, value){
	        ele.setAttribute(attr, value);
	    }
	
	    function getAttr(ele, attr) {
	        return ele.getAttribute(attr);
	    }
	
	    function removeAttr(ele, attr){
	        ele.removeAttribute(attr); 
	    }
	
	    function equal(ele, str) {
	        return ele.nodeName.toLowerCase() === str;
	    }
	
	    function hasClass(ele, className) {
	        return (' ' + ele.className + ' ').indexOf(' ' + className + ' ') !== -1;
	    }
	
	    function addClass(ele, className) {
	        if (!hasClass(ele, className)) {
	            ele.className += ' ' + className;
	        }
	    }
	
	    function toArray(options) {
	        var array = [];
	        var nodelist = (options.root).querySelectorAll(options.selector);
	        for (var i = nodelist.length; i--; array.unshift(nodelist[i])) {}
	        return array;
	    }
	
	    function saveViewportOffset(offset) {
	        _viewport.bottom = (window.innerHeight || document.documentElement.clientHeight) + offset;
	        _viewport.right = (window.innerWidth || document.documentElement.clientWidth) + offset;
	    }
	
	    function bindEvent(ele, type, fn) {
	        if (ele.attachEvent) {
	            ele.attachEvent && ele.attachEvent('on' + type, fn);
	        } else {
	            ele.addEventListener(type, fn, { capture: false, passive: true });
	        }
	    }
	
	    function unbindEvent(ele, type, fn) {
	        if (ele.detachEvent) {
	            ele.detachEvent && ele.detachEvent('on' + type, fn);
	        } else {
	            ele.removeEventListener(type, fn, { capture: false, passive: true });
	        }
	    }
	
	    function each(object, fn) {
	        if (object && fn) {
	            var l = object.length;
	            for (var i = 0; i < l && fn(object[i], i) !== false; i++) {}
	        }
	    }
	
	    function throttle(fn, minDelay, scope) {
	        var lastCall = 0;
	        return function() {
	            var now = +new Date();
	            if (now - lastCall < minDelay) {
	                return;
	            }
	            lastCall = now;
	            fn.apply(scope, arguments);
	        };
	    }
	});


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = parallaxDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _drawing = __webpack_require__(10);
	
	var _window = __webpack_require__(29);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds parallax to an element.
	 *
	 * Parallax with 75% speed: <div sw-parallax="0.75"></div>
	 * Parallax for background images: <div sw-parallax='{"scale": true}'></div>
	 *
	 * @param context
	 */
	function parallaxDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $window = (0, _jquery2.default)(window);
	
	    $context.find('[sw-parallax]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-parallax');
	        var settings = (0, _parse.directiveSettings)(json, {
	            speed: 0.5,
	            align: 0.5,
	            target: false,
	            scale: false
	        }, 'speed');
	
	        var $target = settings.target && !settings.scale ? (0, _jquery2.default)(settings.target) : false;
	
	        var height = void 0;
	        var offset = void 0;
	        var transform = void 0;
	
	        function setup() {
	            $element.css('transform', '');
	            $element.css('transform-origin', 'top center');
	
	            (0, _drawing.redraw)($element);
	
	            height = $element.outerHeight();
	            offset = $element.offset();
	
	            if (settings.scale) {
	                var viewHeight = Math.min((0, _window.getHeight)(), offset.top + height);
	                var newHeight = viewHeight - (viewHeight - height) * settings.speed;
	                transform = 'scale(' + newHeight / height + ')';
	            } else {
	                transform = '';
	            }
	
	            position();
	        }
	
	        function position() {
	            var targetHeight = $target ? $target.height() : (0, _window.getHeight)();
	            var scaleOffset = (targetHeight - height) * settings.align;
	            var translate = ((0, _window.getScrollTop)() - offset.top + scaleOffset) * (settings.speed - 1);
	
	            $element.css('transform', 'translate3d(0, ' + -translate + 'px, 0) ' + transform);
	        }
	
	        setup();
	        (0, _jquery2.default)(function () {
	            return (0, _drawing.frame)(setup);
	        });
	        $window.on('load resize', function () {
	            return (0, _drawing.frame)(setup);
	        });
	        $window.on('scroll', function () {
	            return (0, _drawing.frame)(position);
	        });
	    });
	}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = revealDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _inspection = __webpack_require__(34);
	
	var _drawing = __webpack_require__(10);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $window = (0, _jquery2.default)(window);
	
	function revealDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $reveal = $context.find('[sw-reveal]');
	
	    if (!(0, _inspection.isTouch)()) {
	        var checkForReveal = function checkForReveal(element) {
	            var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            var $this = (0, _jquery2.default)(element);
	            var isScrolled = $window.scrollTop() + $window.outerHeight() > $this.offset().top;
	            if (isScrolled && !$this.hasClass('is-revealed')) {
	                $this.addClass('is-revealed');
	            } else if (reset && !isScrolled && $this.hasClass('is-revealed')) {
	                $this.removeClass('is-revealed');
	            }
	        };
	
	        $reveal.each(function () {
	            var $element = (0, _jquery2.default)(this);
	            var json = $element.attr('sw-reveal');
	            var settings = (0, _parse.directiveSettings)(json, {
	                force: false,
	                reset: true
	            }, 'force');
	
	            if (!settings.force) {
	                $element.css('transition', 'none');
	            }
	
	            checkForReveal($element, settings.reset);
	
	            if (!settings.force) {
	                (0, _drawing.frame)(function () {
	                    return $element.css('transition', '');
	                });
	            }
	
	            (0, _window.onScroll)(function () {
	                return checkForReveal($element, settings.reset);
	            });
	        });
	    } else {
	
	        $reveal.css('transition', 'none');
	        $reveal.addClass('is-revealed');
	    }
	}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isTouch = isTouch;
	exports.isIE = isIE;
	exports.isSafari = isSafari;
	/**
	 * Crude check to see if the device is a touch screen.
	 * @see http://stackoverflow.com/a/4819886/556609
	 *
	 * @returns {boolean}
	 */
	function isTouch() {
	    return 'ontouchstart' in window || !!navigator.maxTouchPoints;
	}
	
	/**
	 * Crude check to see if the browser is IE.
	 *
	 * @param version - Optionally check a specific version (11, 10, or 9)
	 * @returns {boolean}
	 */
	function isIE() {
	    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    var ua = navigator.userAgent;
	    var is11 = /rv:11\.0/i.test(ua);
	    var is10 = /MSIE 10/i.test(ua);
	    var is9 = /MSIE 9/i.test(ua);
	
	    switch (version) {
	        case 11:
	            return is11;
	        case 10:
	            return is10;
	        case 9:
	            return is9;
	    }
	
	    return is11 && is10 && is9;
	}
	
	/**
	 * Crude check to see if the browser is Safari.
	 *
	 * @returns {boolean}
	 */
	function isSafari() {
	    return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
	    );
	}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stickyDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sticks an element top the top of the screen.
	 * TODO Allow for a sticky container to stop elements sticking too far.
	 *
	 * @param context
	 */
	function stickyDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $window = (0, _jquery2.default)(window);
	
	    $context.find('[sw-sticky]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-sticky');
	        var settings = (0, _parse.directiveSettings)(json, {
	            name: '',
	            offset: 0
	        }, 'name');
	
	        var $filler = settings.name ? $context.find('[sw-sticky-filler=\'' + settings.name + '\']') : (0, _jquery2.default)();
	        if ($filler.length === 0) {
	            $filler = (0, _jquery2.default)('<div sw-sticky-filler="' + settings.name + '">');
	            $element.before($filler);
	        }
	
	        var isFixed = false;
	
	        function fillerSize() {
	            $filler.css('height', $element.outerHeight() + 'px');
	        }
	
	        function stickyScroll() {
	            if (isFixed) {
	                var fillerTop = $filler.offset().top + settings.offset;
	                if ((0, _window.getScrollTop)() <= fillerTop) {
	                    isFixed = false;
	                    fixSticky(false);
	                }
	            } else {
	                var stickyTop = $element.offset().top + settings.offset;
	                if ((0, _window.getScrollTop)() > stickyTop) {
	                    isFixed = true;
	                    fixSticky(true);
	                }
	            }
	        }
	
	        function fixSticky(fix) {
	            if (fix) {
	                $filler.css('display', '');
	                $element.addClass('is-stuck').removeClass('is-unstuck');
	            } else {
	                $filler.css('display', 'none');
	                $element.removeClass('is-stuck').addClass('is-unstuck');
	            }
	        }
	
	        fillerSize();
	        fixSticky(false);
	        stickyScroll();
	
	        $window.on('resize', fillerSize);
	        $window.on('resize scroll', stickyScroll);
	    });
	}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = inspectScrollDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function inspectScrollDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
	
		$context.find('[sw-inspect-scroll]').each(function () {
			var $element = (0, _jquery2.default)(this);
			var json = $element.attr('sw-inspect-scroll');
			var settings = (0, _parse.directiveSettings)(json, {
				target: null,
				class: 'is-scrollable',
				inverted: false
			}, 'target');
	
			var $target = settings.target ? (0, _jquery2.default)(settings.target) : $element;
	
			if ($target.length > 0) {
				(0, _window.onResize)(function () {
					var width = $target.width();
					var scrollWidth = $target[0].scrollWidth;
	
					var height = $target.height();
					var scrollHeight = $target[0].scrollHeight;
	
					var isScrolling = scrollWidth - width > 0 || scrollHeight - height > 0;
	
					$element.toggleClass(settings.class, settings.inverted ? !isScrolling : isScrolling);
				});
			}
		});
	}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = modalSection;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function modalSection() {
		var $html = (0, _jquery2.default)('html');
		var $modal = (0, _jquery2.default)('#modal');
		var $iframe = $modal.find('iframe');
		var toggler = $modal.data('toggler');
	
		var url = $modal.attr('data-url');
	
		(0, _jquery2.default)('a[href^="' + url + '/"]').attr('target', 'modal-frame');
	
		function resetIframe() {
			$iframe.attr('src', '');
			$iframe.attr('src', 'about:blank');
		}
	
		if (toggler) {
	
			$iframe.on('load', function () {
				try {
					var href = $iframe[0].contentWindow.location.href;
					var isBlank = href === 'about:blank';
					toggler.toggle(!isBlank);
				} catch (e) {
					toggler.close();
				}
	
				// console.log('asdf');
			});
	
			$modal.on('click', function (e) {
				if (e.target === this) {
					toggler.close();
					resetIframe();
				}
			});
	
			toggler.on('toggle', function () {
				// console.log(toggler.isOpen);
				$html.toggleClass('is-modal-open', toggler.isOpen);
	
				if (toggler.isOpen == false) {
					resetIframe();
				}
			});
		}
	
		// pop a modal
		var popupModal = function popupModal(el) {
	
			// don't pop if cookie is set
			var cookieName = 'spicyPopupModal' + el.id,
			    popped = document.cookie.split('; ').find(function (row) {
				return row.startsWith(cookieName + '=');
			});
			if (!popped || el.dataset.devmode) {
	
				// pop
				var frame = document.getElementById("modal").querySelector('iframe');
				if (frame) frame.src = el.dataset.url;
	
				// set cookie
				var expiry = new Date();
				expiry.setTime(expiry.getTime() + el.dataset.expiry * 60 * 60 * 1000);
				document.cookie = cookieName + '=true; expires=' + expiry.toUTCString() + ';';
			}
		};
	
		// go over each popup modal box in the page and pop it with timers
		[].concat(_toConsumableArray(document.querySelectorAll('.popup-modal'))).forEach(function (el) {
	
			// delays
			if (el) setTimeout(function () {
				popupModal(el);
			}, el.dataset.delay * 1000);
		});
	}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = headerSection;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _window = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function headerSection() {
		var $html = (0, _jquery2.default)('html');
		var $scroller = (0, _jquery2.default)('html, body');
	
		var $header = (0, _jquery2.default)('#header');
		var $headerNav = (0, _jquery2.default)('#header-nav');
		var headerToggler = $headerNav.data('toggler');
		var headerHeight = $header.outerHeight();
		var $headerButtonNormal = $header.find('.header_button.-type-normal');
		var overlay = false;
	
		if (headerToggler) {
	
			headerToggler.on('toggle', function () {
				$html.toggleClass('is-header-open', headerToggler.isOpen);
	
				if (headerToggler.isOpen) {
					// $scroller.animate({ scrollTop: 0 }, { duration: 200 });
					$headerNav.find('.-parent').removeClass('is-open');
					$headerNav.find('.-parent > ul').css('display', '');
				}
			});
		}
	
		function closeMenuItems() {
			$headerNav.find('.-parent').each(function () {
				var _this = this;
	
				(0, _jquery2.default)(_this).find('> ul').slideUp('fast', function () {
					(0, _jquery2.default)(_this).removeClass('is-open');
				});
			});
		}
	
		$headerNav.find('.-parent').each(function () {
			var _this = this;
			(0, _jquery2.default)(_this).find('> a').click(function (e) {
				e.preventDefault();
				// $headerNav.find('.-parent').removeClass('is-open');
	
	
				// closeMenuItems();
				// $(_this).addClass('is-open');
				// $(_this).find('> ul').slideDown('fast');
	
	
				if (!(0, _jquery2.default)(_this).hasClass('is-open')) {
					closeMenuItems();
					(0, _jquery2.default)(_this).addClass('is-open');
					(0, _jquery2.default)(_this).find('> ul').slideDown('fast');
				} else {
					(0, _jquery2.default)(_this).find('> ul').slideUp('fast', function () {
						(0, _jquery2.default)(_this).removeClass('is-open');
					});
				}
			});
		});
	
		if ((0, _window.getWidth)() > 1080) {
	
			var lastScrollTop = 0;
	
			if ($header.hasClass('-overlay')) {
				overlay = true;
				$header.addClass('is-stuck');
			}
	
			(0, _window.onScroll)(function () {
	
				// if(getScrollTop() > headerHeight && $header.hasClass('-overlay')) {
				// 	if(!$header.hasClass('is-sticky')) {
				// 		$header.addClass('is-sticky');
				// 		$header.attr('style', 'transition: none;');
	
				// 		setTimeout(function(){
				// 			$header.attr('style', '');
				// 		}, 300);
				// 	}
				// } else {
				// 	$header.removeClass('show-fixed');
				// 	$header.removeClass('hide-fixed');
				// 	$header.removeClass('is-sticky');
				// }
	
				// when scrolling
				var st = (0, _window.getScrollTop)();
				if (st > lastScrollTop) {
					// downscroll code
					if ((0, _window.getScrollTop)() > headerHeight) {
						$header.removeClass('show-fixed');
						$header.addClass('hide-fixed');
	
						if (overlay) {
							setTimeout(function () {
								$header.removeClass('-overlay');
								$headerButtonNormal.addClass('-no-overlay');
							}, 300);
						}
					} else {
						$header.removeClass('show-fixed');
						$header.removeClass('hide-fixed');
					}
				} else {
					// upscroll code
					$header.removeClass('hide-fixed');
					$header.addClass('show-fixed');
	
					if ((0, _window.getScrollTop)() < headerHeight && overlay) {
						$header.addClass('-overlay');
						$headerButtonNormal.removeClass('-no-overlay');
					}
				}
				lastScrollTop = st;
			});
		}
	}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = founderSection;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _window = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function founderSection() {
	    var $html = (0, _jquery2.default)('html');
	    var $scroller = (0, _jquery2.default)('html, body');
	
	    if ((0, _jquery2.default)('#content').hasClass('homepage')) {
	        var reSize = function reSize() {
	            var topHeight = 0;
	            var bottomHeight = 0;
	
	            if ((0, _window.getWidth)() > 1220) {
	                $message.css('height', '');
	                $video.css('height', '');
	                $info.css('height', '');
	
	                // console.log($message.outerHeight());
	                if ($message.outerHeight() > $video.outerHeight()) {
	                    topHeight = $message.outerHeight();
	                } else {
	                    topHeight = $video.outerHeight();
	                }
	
	                if ($image.outerHeight() > $info.outerHeight()) {
	                    bottomHeight = $image.outerHeight();
	                } else {
	                    bottomHeight = $info.outerHeight();
	                }
	                // $message.css('height', topHeight+'px');
	                $video.css('height', topHeight + 'px');
	                $info.css('height', bottomHeight + 'px');
	            } else {
	                $video.css('height', '');
	                $info.css('height', '');
	            }
	        };
	
	        var $founder = (0, _jquery2.default)('.founder');
	        var $message = $founder.find('.founder-message');
	        var $image = $founder.find('.founder-image');
	        var $video = $founder.find('.founder-video');
	        var $info = $founder.find('.founder-info');
	
	        reSize();
	
	        (0, _window.onResize)(function () {
	            reSize();
	        });
	    }
	}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = cardSection;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _window = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cardSection() {
	    var $html = (0, _jquery2.default)('html');
	    // const $scroller = $('html, body');
	    var cards = (0, _jquery2.default)('.card.-style-over');
	
	    (0, _jquery2.default)(function () {
	        if ((0, _window.getWidth)() > 1080) {
	            setTimeout(function () {
	                cards.each(function (e) {
	                    var _this = this;
	
	                    (0, _jquery2.default)(_this).find('.card_content_body').attr('data-height', (0, _jquery2.default)(_this).find('.card_content_body').innerHeight());
	                    (0, _jquery2.default)(_this).find('.card_content_body').css('height', 0);
	
	                    (0, _jquery2.default)(_this).mouseenter(function () {
	                        // on hover
	                        (0, _jquery2.default)(_this).find('.card_content_body').animate({
	                            height: (0, _jquery2.default)(_this).find('.card_content_body').attr('data-height')
	                        }, 300);
	                    });
	
	                    (0, _jquery2.default)(_this).mouseleave(function () {
	                        (0, _jquery2.default)(_this).find('.card_content_body').animate({
	                            height: 0
	                        }, 300);
	                    });
	                });
	            }, 100);
	        }
	    });
	}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	      value: true
	});
	exports.default = donateSection;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Donation form scripts
	 */
	function donateSection() {
	      [].concat(_toConsumableArray(document.querySelectorAll('[sw-donate]'))).forEach(function (container) {
	
	            // Get the form
	            var form = container.querySelector('#donationForm');
	            if (!form) return;
	
	            // Get context elements
	            var donationLabel = form.querySelector('#donation-label'),
	                donationAmount = form.querySelector('#donation-amount'),
	                donationBoxInput = form.querySelector('.donation-box .donation-box_input');
	            if (!donationBoxInput || !donationAmount) return;
	
	            /**
	             * Formats the donation amount input box (prepend the dollar sign)
	             * @param {String} [value]
	             */
	            var formatDonationInputValue = function formatDonationInputValue() {
	                  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	                  value = value || donationBoxInput.value || form.dataset.defaultDonation;
	                  donationBoxInput.value = '$' + value.replace('$', '');
	            };
	
	            // Format donation amount input on blur
	            donationBoxInput.addEventListener('blur', function () {
	                  return formatDonationInputValue();
	            });
	
	            // Enable donation amount input on click
	            donationBoxInput.addEventListener('click', function () {
	                  return donationBoxInput.removeAttribute('disabled');
	            });
	
	            // Key input control for donation amount
	            donationBoxInput.addEventListener('keydown', function (event) {
	                  var allow = ['Backspace', 'ArrowLeft', 'ArrowRight'];
	                  if ((isNaN(event.key) || event.key === " ") && !allow.includes(event.key)) event.preventDefault();
	            });
	
	            // Radio button changes
	            [].concat(_toConsumableArray(form.querySelectorAll('input[type="radio"]'))).forEach(function (radio) {
	                  radio.addEventListener('change', function () {
	
	                        // Switch value
	                        var input = donationBoxInput.value.replace('$', '');
	                        formatDonationInputValue(+input >= form.dataset.defaultDonation ? input : radio.value);
	
	                        // Hide the donation amount input if radio preset is zero
	                        donationBoxInput.parentElement.style.display = +radio.value > 0 ? 'inline-block' : 'none';
	
	                        // Update purpose (item_name for PayPal)
	                        var purpose = radio.parentElement.dataset.purpose;
	                        if (purpose) donationLabel.value = donationLabel.value.split(' - ')[0] + ' - ' + purpose;
	                  });
	            });
	
	            // Set post value and disable
	            form.addEventListener('submit', function () {
	                  donationBoxInput.setAttribute('disabled', '');
	                  var amount = donationBoxInput.parentElement.style.display === 'none' ? 0 : donationBoxInput.value.replace('$', '');
	                  donationAmount.value = isNaN(amount) ? 0 : amount;
	            });
	      });
	}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = productsPage;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _window = __webpack_require__(29);
	
	var _shopify = __webpack_require__(43);
	
	var _shopify2 = _interopRequireDefault(_shopify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Client from 'shopify-buy';
	// import Cookie from 'js-cookie';
	
	// for the product section/page. remember to activate the shopify plugin if using shopify
	
	function productsPage() {
	
	    if (!window.shopifyClient) {
	        // You'll need to change the apikey and domain
	        // remember to change the domain in the product.twig file as well.
	        window.shopifyClient = new _shopify2.default('b40a37fc7dc6fca8bb0ca548e23a0b24', 'h-elp.myshopify.com');
	    }
	    // const client = new shopify('a46c806bc951b3d9dadbd0631e7251a1', 'cuvee-develop.myshopify.com');
	
	    if (window.shopifyClient) {
	        window.shopifyClient.setupCheckoutInfo();
	        window.shopifyClient.setupCartContainer('.cart-num');
	    }
	
	    if ((0, _jquery2.default)('.product-page').length > 0) {
	        var $qtySelect = (0, _jquery2.default)('#qty_select');
	        var $sizeSelect = (0, _jquery2.default)('#size_select');
	        var $addToCartButton = (0, _jquery2.default)('.add-to-cart .button.submit');
	        var $hiddenMainId = (0, _jquery2.default)('.add-to-cart [name="mainId"]');
	        var $props = (0, _jquery2.default)('.add-to-cart [name="props"]');
	        var props = JSON.parse($props.val());
	        var $hiddenQuantity = (0, _jquery2.default)('.add-to-cart [name="quantity"]');
	        var $price = (0, _jquery2.default)('.product-page_info .variant-price');
	
	        // const client = new shopify('a46c806bc951b3d9dadbd0631e7251a1', 'cuvee-develop.myshopify.com');
	
	        $qtySelect.on('change', function () {
	            $hiddenQuantity.val(this.value);
	        });
	
	        $sizeSelect.on('change', function () {
	
	            var json = JSON.parse(this.value);
	
	            $hiddenMainId.val(json.id);
	            $price.html('$' + json.price);
	        });
	
	        $addToCartButton.click(function (e) {
	            e.preventDefault();
	
	            var cusAttr = [{
	                key: "summary",
	                value: props.summary
	            }];
	
	            window.shopifyClient.addProductToCart([{
	                variantId: $hiddenMainId.val(),
	                quantity: parseInt($hiddenQuantity.val(), 10),
	                customAttributes: cusAttr
	            }]);
	        });
	    }
	}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _shopifyBuy = __webpack_require__(44);
	
	var _shopifyBuy2 = _interopRequireDefault(_shopifyBuy);
	
	var _jsCookie = __webpack_require__(45);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _function = __webpack_require__(46);
	
	var _function2 = _interopRequireDefault(_function);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Shopify_ = function () {
	    function Shopify_(apiKey, domain) {
	        _classCallCheck(this, Shopify_);
	
	        this.apiKey = apiKey;
	        this.domain = domain;
	        this.cartIcon = '';
	        this.cartContainer = '';
	        this.checkoutId = '';
	        this.checkoutUrl = '';
	
	        this.cookie = _jsCookie2.default.get('myCartId');
	
	        this.shopifyClient = _shopifyBuy2.default.buildClient({
	            domain: this.domain,
	            storefrontAccessToken: this.apiKey
	        });
	    }
	
	    _createClass(Shopify_, [{
	        key: 'shopifyPromise',
	        value: function shopifyPromise() {
	            var t = this;
	
	            return new Promise(function (resolve, reject) {
	                if (t.shopifyClient) {
	                    resolve('success');
	                } else {
	                    reject('rejected');
	                }
	            });
	        }
	    }, {
	        key: 'getCookie',
	        value: function getCookie() {
	            return this.cookie;
	        }
	    }, {
	        key: 'setCookie',
	        value: function setCookie(id) {
	            _jsCookie2.default.set('myCartId', id, { expires: 1 });
	        }
	    }, {
	        key: 'setupSubTotal',
	        value: function setupSubTotal(price) {
	            // console.log(price);
	            (0, _jquery2.default)('.cart-buttons_price').html('$' + price);
	        }
	    }, {
	        key: 'toggleCart',
	        value: function toggleCart() {
	
	            var t = this;
	
	            if (t.cartContainer.hasClass('is-open')) {
	                t.cartContainer.removeClass('is-open');
	                t.cartContainer.addClass('is-closing');
	
	                setTimeout(function () {
	                    t.cartContainer.removeClass('is-closing');
	                    t.cartContainer.addClass('is-closed');
	                }, 900);
	            } else {
	                t.cartContainer.addClass('is-open');
	
	                if (t.cartContainer.hasClass('is-closed')) {
	                    setTimeout(function () {
	                        t.cartContainer.removeClass('is-closed');
	                    }, 300);
	                }
	            }
	        }
	    }, {
	        key: 'setupCartIcon',
	        value: function setupCartIcon(iconClass) {
	            var t = this;
	
	            this.cartIcon = (0, _jquery2.default)(iconClass);
	            var closetHe = (0, _jquery2.default)(this.cartIcon.closest('.header_button'));
	            closetHe.off('click');
	            (0, _jquery2.default)('.cart-heading_close, .cart_bg, .cart-close').off('click');
	
	            function close(el) {
	                // if(t.cartContainer.hasClass('is-open')) {
	                //     t.cartContainer.removeClass('is-open');
	                //     t.cartContainer.addClass('is-closing');
	
	                //     setTimeout(()=>{
	                //         t.cartContainer.removeClass('is-closing');
	                //         t.cartContainer.addClass('is-closed');
	                //     }, 900);
	                // } else {
	                //     t.cartContainer.addClass('is-open');
	
	                //     if(t.cartContainer.hasClass('is-closed')) {
	                //         setTimeout(()=>{                    
	                //             t.cartContainer.removeClass('is-closed');
	                //         }, 300);
	                //     }
	                // }
	
	                t.toggleCart();
	            }
	
	            closetHe.click(close);
	            (0, _jquery2.default)('.cart-heading_close, .cart_bg, .cart-close').click(close);
	        }
	    }, {
	        key: 'updateCartIcon',
	        value: function updateCartIcon(data) {
	
	            var num = 0;
	
	            if (data.length > 0) {
	                data.forEach(function (el) {
	                    num = num + el.quantity;
	                });
	
	                if (num > 9) {
	                    this.cartIcon.text('9+');
	                } else {
	                    this.cartIcon.text(num);
	                }
	            } else {
	                this.cartIcon.text(0);
	            }
	        }
	    }, {
	        key: 'setupCheckoutItems',
	        value: function setupCheckoutItems(data, code) {
	            var _this = this;
	
	            var t = this;
	
	            this.cartItems.html('');
	
	            data.forEach(function (dataEl) {
	
	                var customArr = dataEl.customAttributes;
	                var customAttributes = {};
	
	                if (customArr && customArr.length) {
	                    customArr.forEach(function (el) {
	                        customAttributes[el.key] = el.value;
	                    });
	                }
	
	                // console.log(customAttributes);
	
	                var selectInput = '';
	
	                var cross = (0, _jquery2.default)('.cart-close-arrow');
	
	                selectInput += '<option></option>';
	
	                var size = 21;
	
	                if (dataEl.quantity > 20) {
	                    size = dataEl.quantity + 1;
	                }
	
	                for (var temp = 1; temp < size; temp++) {
	                    if (dataEl.quantity == temp) {
	                        selectInput += '<option value="' + temp + '" selected>' + temp + '</option>';
	                    } else {
	                        selectInput += '<option value="' + temp + '">' + temp + '</option>';
	                    }
	                }
	
	                // console.log(dataEl);
	
	                var newEl = '<div class="cart-item" data-id="' + dataEl.id + '">' + '<div class="cart-item-image">' + ('<img src="' + dataEl.variant.image.src + '" />') + '</div>' + '<div class="cart-item-info">' + '<div class="cart-item-content">' + ('<div class="cart-item-content_item cart-item_title">' + dataEl.title + '</div>') + ('<div class="cart-item-content_item cart-item_summary">' + customAttributes.summary + '</div>') +
	                // `<div class="cart-item-content_item cart-item_weight">${dataEl.variant.weight + 'g'}</div>` +
	                '</div>' + '<div class="cart-item-tools">' + ('<div class="cart-item_update"><select>' + selectInput + '</select></div>') + ('<div class="cart-item-content_item cart-item_price">$' + (dataEl.quantity * dataEl.variant.price).toFixed(2) + '<span class="cart-item_price-code">' + code + '</span></div>') + '</div>' + '<div class="cart-item-remove">' + ('<div class="cart-item_remove">' + cross.html() + '</div>') + '</div>' + '</div>' + '</div>';
	
	                newEl = (0, _jquery2.default)(newEl);
	
	                // input
	                newEl.find('.cart-item_update select').change(_function2.default.debounce(function () {
	                    var $this = this;
	                    var item = $this.closest('.cart-item');
	                    var id = (0, _jquery2.default)(item).data('id');
	                    var $price = (0, _jquery2.default)(item).find('.cart-item_price');
	
	                    var value = parseInt((0, _jquery2.default)(this).val());
	                    if (value <= 0) {
	                        t.removeProductFromCart(newEl, [id]);
	                    } else {
	                        if (value > 0) {
	                            t.updateProductInCart([{
	                                id: id,
	                                quantity: value
	                            }]);
	                            (0, _jquery2.default)($price).html('$' + (value * dataEl.variant.price).toFixed(2) + '<span class="cart-item_price-code">' + code + '</span>');
	                        }
	                    }
	                }, 250));
	
	                newEl.find('.cart-item_remove').click(function () {
	                    var $this = this;
	                    var item = $this.closest('.cart-item');
	                    var id = (0, _jquery2.default)(item).data('id');
	
	                    t.removeProductFromCart(newEl, [id]);
	                });
	
	                _this.cartItems.append(newEl);
	            });
	        }
	    }, {
	        key: 'createNewCheckout',
	        value: function createNewCheckout() {
	            var _this2 = this;
	
	            this.shopifyClient.checkout.create().then(function (checkout) {
	                _this2.checkoutId = checkout.id;
	                _this2.checkoutUrl = checkout.webUrl;
	                _this2.setCookie(checkout.id);
	                _this2.setupSubTotal(checkout.totalPrice);
	
	                // console.log('checkout: ', checkout);
	
	                if (checkout.lineItems.length == 0) {
	                    (0, _jquery2.default)('.cart-buttons_checkout').attr('disabled', 'true');
	                }
	            });
	        }
	    }, {
	        key: 'setupCheckoutInfo',
	        value: function setupCheckoutInfo() {
	            var _this3 = this;
	
	            var t = this;
	
	            if (this.cookie) {
	                this.checkoutId = this.getCookie();
	
	                this.shopifyClient.checkout.fetch(this.checkoutId).then(function (checkout) {
	
	                    if (checkout.completedAt == null) {
	                        _this3.checkoutUrl = checkout.webUrl;
	
	                        // console.log('checkout: ', checkout);
	
	                        _this3.setupSubTotal(checkout.totalPrice);
	
	                        if (checkout.lineItems.length == 0) {
	                            (0, _jquery2.default)('.cart-buttons_checkout').attr('disabled', 'true');
	                        } else {
	                            (0, _jquery2.default)('.cart-buttons_checkout').removeAttr('disabled');
	
	                            _this3.setupCheckoutItems(checkout.lineItems, checkout.currencyCode);
	                            _this3.updateCartIcon(checkout.lineItems);
	                        }
	                    } else {
	                        t.createNewCheckout();
	                    }
	                });
	            } else {
	                t.createNewCheckout();
	            }
	
	            (0, _jquery2.default)('.cart-buttons_checkout').off('click');
	            (0, _jquery2.default)('.cart-buttons_checkout').click(function () {
	                window.location = t.checkoutUrl;
	            });
	        }
	    }, {
	        key: 'setupCartContainer',
	        value: function setupCartContainer(iconClass) {
	            if ((0, _jquery2.default)('.cart-container').length != 0) {
	                this.cartContainer = (0, _jquery2.default)('.cart');
	                this.cartItems = this.cartContainer.find('.cart-items');
	
	                this.setupCartIcon(iconClass);
	            }
	        }
	    }, {
	        key: 'addProductToCart',
	        value: function addProductToCart(lineItemsToAdd) {
	            var _this4 = this;
	
	            var t = this;
	            this.shopifyPromise().then(function (success) {
	                _this4.shopifyClient.checkout.addLineItems(_this4.checkoutId, lineItemsToAdd).then(function (checkout) {
	                    // console.log(checkout);
	
	                    _this4.updateCartIcon(checkout.lineItems);
	                    _this4.setupCheckoutItems(checkout.lineItems, checkout.currencyCode);
	                    _this4.setupSubTotal(checkout.totalPrice);
	
	                    if (checkout.lineItems.length > 0) {
	                        (0, _jquery2.default)('.cart-buttons_checkout').removeAttr('disabled');
	                    }
	
	                    t.toggleCart();
	                }).catch(function (e) {
	                    console.error('e: ', e);
	                });
	            });
	        }
	    }, {
	        key: 'removeProductFromCart',
	        value: function removeProductFromCart(el, lineItemIdsToRemove) {
	            var _this5 = this;
	
	            this.shopifyPromise().then(function (success) {
	                _this5.shopifyClient.checkout.removeLineItems(_this5.checkoutId, lineItemIdsToRemove).then(function (checkout) {
	                    _this5.updateCartIcon(checkout.lineItems);
	                    _this5.setupSubTotal(checkout.totalPrice);
	
	                    if (checkout.lineItems.length == 0) {
	                        (0, _jquery2.default)('.cart-buttons_checkout').attr('disabled', 'true');
	                    }
	
	                    el.remove();
	                });
	            });
	        }
	    }, {
	        key: 'updateProductInCart',
	        value: function updateProductInCart(lineItemsToUpdate) {
	            var _this6 = this;
	
	            // const lineItemsToUpdate = [
	            //   {id: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0Lzc4NTc5ODkzODQ=', quantity: 2}
	            // ];
	
	            this.shopifyPromise().then(function (success) {
	                _this6.shopifyClient.checkout.updateLineItems(_this6.checkoutId, lineItemsToUpdate).then(function (checkout) {
	                    _this6.updateCartIcon(checkout.lineItems);
	                    _this6.setupSubTotal(checkout.totalPrice);
	                    if (checkout.lineItems.length == 0) {
	                        (0, _jquery2.default)('.cart-buttons_checkout').attr('disabled', 'true');
	                    }
	                });
	            });
	        }
	    }]);
	
	    return Shopify_;
	}();
	
	exports.default = Shopify_;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	/*
	The MIT License (MIT)
	
	Copyright (c) 2016 Shopify Inc.
	
	Permission is hereby granted, free of charge, to any person obtaining a
	copy of this software and associated documentation files (the
	"Software"), to deal in the Software without restriction, including
	without limitation the rights to use, copy, modify, merge, publish,
	distribute, sublicense, and/or sell copies of the Software, and to
	permit persons to whom the Software is furnished to do so, subject to
	the following conditions:
	
	The above copyright notice and this permission notice shall be included
	in all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	*/
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck$1 = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass$1 = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits$1 = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn$1 = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	/*
	The MIT License (MIT)
	Copyright (c) 2016 Shopify Inc.
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in all
	copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
	OR OTHER DEALINGS IN THE SOFTWARE.
	
	
	*/
	function join() {
	  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
	    fields[_key] = arguments[_key];
	  }
	
	  return fields.join(' ');
	}
	
	function isObject(value) {
	  return Boolean(value) && Object.prototype.toString.call(value.valueOf()) === '[object Object]';
	}
	
	function deepFreezeCopyExcept(predicate, structure) {
	  if (predicate(structure)) {
	    return structure;
	  } else if (isObject(structure)) {
	    return Object.freeze(Object.keys(structure).reduce(function (copy, key) {
	      copy[key] = deepFreezeCopyExcept(predicate, structure[key]);
	
	      return copy;
	    }, {}));
	  } else if (Array.isArray(structure)) {
	    return Object.freeze(structure.map(function (item) {
	      return deepFreezeCopyExcept(predicate, item);
	    }));
	  } else {
	    return structure;
	  }
	}
	
	function schemaForType(typeBundle, typeName) {
	  var type = typeBundle.types[typeName];
	
	  if (type) {
	    return type;
	  }
	
	  throw new Error("No type of " + typeName + " found in schema");
	}
	
	var classCallCheck = function classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
	};
	
	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();
	
	var toConsumableArray = function toConsumableArray(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	var VariableDefinition = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Client#variable} to create a VariableDefinition.
	   *
	   * @param {String} name The name of the variable.
	   * @param {String} type The GraphQL type of the variable.
	   * @param {*} [defaultValue] The default value of the variable.
	   */
	  function VariableDefinition(name, type, defaultValue) {
	    classCallCheck(this, VariableDefinition);
	
	    this.name = name;
	    this.type = type;
	    this.defaultValue = defaultValue;
	    Object.freeze(this);
	  }
	
	  /**
	   * Returns the GraphQL query string for the variable as an input value (e.g. `$variableName`).
	   *
	   * @return {String} The GraphQL query string for the variable as an input value.
	   */
	
	  createClass(VariableDefinition, [{
	    key: 'toInputValueString',
	    value: function toInputValueString() {
	      return '$' + this.name;
	    }
	
	    /**
	     * Returns the GraphQL query string for the variable (e.g. `$variableName:VariableType = defaultValue`).
	     *
	     * @return {String} The GraphQL query string for the variable.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var defaultValueString = this.defaultValue ? ' = ' + formatInputValue(this.defaultValue) : '';
	
	      return '$' + this.name + ':' + this.type + defaultValueString;
	    }
	  }]);
	  return VariableDefinition;
	}();
	
	function isVariable(value) {
	  return VariableDefinition.prototype.isPrototypeOf(value);
	}
	
	function variable(name, type, defaultValue) {
	  return new VariableDefinition(name, type, defaultValue);
	}
	
	var Enum = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Client#enum} to create an Enum.
	   *
	   * @param {String} key The key of the enum.
	   */
	  function Enum(key) {
	    classCallCheck(this, Enum);
	
	    this.key = key;
	  }
	
	  /**
	   * Returns the GraphQL query string for the enum (e.g. `enumKey`).
	   *
	   * @return {String} The GraphQL query string for the enum.
	   */
	
	  createClass(Enum, [{
	    key: "toString",
	    value: function toString() {
	      return this.key;
	    }
	  }, {
	    key: "valueOf",
	    value: function valueOf() {
	      return this.key.valueOf();
	    }
	  }]);
	  return Enum;
	}();
	
	var enumFunction = function enumFunction(key) {
	  return new Enum(key);
	};
	
	var Scalar = function () {
	  function Scalar(value) {
	    classCallCheck(this, Scalar);
	
	    this.value = value;
	  }
	
	  createClass(Scalar, [{
	    key: "toString",
	    value: function toString() {
	      return this.value.toString();
	    }
	  }, {
	    key: "valueOf",
	    value: function valueOf() {
	      return this.value.valueOf();
	    }
	  }, {
	    key: "unwrapped",
	    get: function get$$1() {
	      return this.value;
	    }
	  }]);
	  return Scalar;
	}();
	
	function formatInputValue(value) {
	  if (VariableDefinition.prototype.isPrototypeOf(value)) {
	    return value.toInputValueString();
	  } else if (Enum.prototype.isPrototypeOf(value)) {
	    return String(value);
	  } else if (Scalar.prototype.isPrototypeOf(value)) {
	    return JSON.stringify(value.valueOf());
	  } else if (Array.isArray(value)) {
	    return '[' + join.apply(undefined, toConsumableArray(value.map(formatInputValue))) + ']';
	  } else if (isObject(value)) {
	    return formatObject(value, '{', '}');
	  } else {
	    return JSON.stringify(value);
	  }
	}
	
	function formatObject(value) {
	  var openChar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var closeChar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  var argPairs = Object.keys(value).map(function (key) {
	    return key + ': ' + formatInputValue(value[key]);
	  });
	
	  return '' + openChar + join.apply(undefined, toConsumableArray(argPairs)) + closeChar;
	}
	
	function formatArgs(args) {
	  if (!Object.keys(args).length) {
	    return '';
	  }
	
	  return ' (' + formatObject(args) + ')';
	}
	
	// eslint-disable-next-line no-empty-function
	var noop = function noop() {};
	
	var Profiler = {
	  trackTypeDependency: noop,
	  trackFieldDependency: noop
	};
	
	var trackTypeDependency = Profiler.trackTypeDependency;
	var trackFieldDependency = Profiler.trackFieldDependency;
	
	function parseFieldCreationArgs(creationArgs) {
	  var callback = noop;
	  var options = {};
	  var selectionSet = null;
	
	  if (creationArgs.length === 2) {
	    if (typeof creationArgs[1] === 'function') {
	      var _creationArgs = slicedToArray(creationArgs, 2);
	
	      options = _creationArgs[0];
	      callback = _creationArgs[1];
	    } else {
	      var _creationArgs2 = slicedToArray(creationArgs, 2);
	
	      options = _creationArgs2[0];
	      selectionSet = _creationArgs2[1];
	    }
	  } else if (creationArgs.length === 1) {
	    // SelectionSet is defined before this function is called since it's
	    // called by SelectionSet
	    // eslint-disable-next-line no-use-before-define
	    if (SelectionSet.prototype.isPrototypeOf(creationArgs[0])) {
	      selectionSet = creationArgs[0];
	    } else if (typeof creationArgs[0] === 'function') {
	      callback = creationArgs[0];
	    } else {
	      options = creationArgs[0];
	    }
	  }
	
	  return { options: options, selectionSet: selectionSet, callback: callback };
	}
	
	var emptyArgs = Object.freeze({});
	
	var Field = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Fields are added to a selection by {@link SelectionSetBuilder#add}, {@link SelectionSetBuilder#addConnection}
	   * and {@link SelectionSetBuilder#addInlineFragmentOn}.
	   *
	   * @param {String} name The name of the field.
	   * @param {Object} [options] An options object containing:
	   *   @param {Object} [options.args] Arguments for the field.
	   *   @param {String} [options.alias] An alias for the field.
	   * @param {SelectionSet} selectionSet The selection set on the field.
	   */
	  function Field(name, options, selectionSet) {
	    classCallCheck(this, Field);
	
	    this.name = name;
	    this.alias = options.alias || null;
	    this.responseKey = this.alias || this.name;
	    this.args = options.args ? deepFreezeCopyExcept(isVariable, options.args) : emptyArgs;
	    this.selectionSet = selectionSet;
	    Object.freeze(this);
	  }
	
	  /**
	   * Returns the GraphQL query string for the Field (e.g. `catAlias: cat(size: 'small') { name }` or `name`).
	   *
	   * @return {String} The GraphQL query string for the Field.
	   */
	
	  createClass(Field, [{
	    key: 'toString',
	    value: function toString() {
	      var aliasPrefix = this.alias ? this.alias + ': ' : '';
	
	      return '' + aliasPrefix + this.name + formatArgs(this.args) + this.selectionSet;
	    }
	  }]);
	  return Field;
	}();
	
	// This is an interface that defines a usage, and simplifies type checking
	var Spread = function Spread() {
	  classCallCheck(this, Spread);
	};
	
	var InlineFragment = function (_Spread) {
	  inherits(InlineFragment, _Spread);
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link SelectionSetBuilder#addInlineFragmentOn} to create an InlineFragment.
	   *
	   * @param {String} typeName The type of the fragment.
	   * @param {SelectionSet} selectionSet The selection set on the fragment.
	   */
	  function InlineFragment(typeName, selectionSet) {
	    classCallCheck(this, InlineFragment);
	
	    var _this = possibleConstructorReturn(this, (InlineFragment.__proto__ || Object.getPrototypeOf(InlineFragment)).call(this));
	
	    _this.typeName = typeName;
	    _this.selectionSet = selectionSet;
	    Object.freeze(_this);
	    return _this;
	  }
	
	  /**
	   * Returns the GraphQL query string for the InlineFragment (e.g. `... on Cat { name }`).
	   *
	   * @return {String} The GraphQL query string for the InlineFragment.
	   */
	
	  createClass(InlineFragment, [{
	    key: 'toString',
	    value: function toString() {
	      return '... on ' + this.typeName + this.selectionSet;
	    }
	  }]);
	  return InlineFragment;
	}(Spread);
	
	var FragmentSpread = function (_Spread2) {
	  inherits(FragmentSpread, _Spread2);
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Document#defineFragment} to create a FragmentSpread.
	   *
	   * @param {FragmentDefinition} fragmentDefinition The corresponding fragment definition.
	   */
	  function FragmentSpread(fragmentDefinition) {
	    classCallCheck(this, FragmentSpread);
	
	    var _this2 = possibleConstructorReturn(this, (FragmentSpread.__proto__ || Object.getPrototypeOf(FragmentSpread)).call(this));
	
	    _this2.name = fragmentDefinition.name;
	    _this2.selectionSet = fragmentDefinition.selectionSet;
	    Object.freeze(_this2);
	    return _this2;
	  }
	
	  /**
	   * Returns the GraphQL query string for the FragmentSpread (e.g. `...catName`).
	   *
	   * @return {String} The GraphQL query string for the FragmentSpread.
	   */
	
	  createClass(FragmentSpread, [{
	    key: 'toString',
	    value: function toString() {
	      return '...' + this.name;
	    }
	  }, {
	    key: 'toDefinition',
	    value: function toDefinition() {
	      // eslint-disable-next-line no-use-before-define
	      return new FragmentDefinition(this.name, this.selectionSet.typeSchema.name, this.selectionSet);
	    }
	  }]);
	  return FragmentSpread;
	}(Spread);
	
	var FragmentDefinition = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Document#defineFragment} to create a FragmentDefinition on a {@link Document}.
	   *
	   * @param {String} name The name of the fragment definition.
	   * @param {String} typeName The type of the fragment.
	   */
	  function FragmentDefinition(name, typeName, selectionSet) {
	    classCallCheck(this, FragmentDefinition);
	
	    this.name = name;
	    this.typeName = typeName;
	    this.selectionSet = selectionSet;
	    this.spread = new FragmentSpread(this);
	    Object.freeze(this);
	  }
	
	  /**
	   * Returns the GraphQL query string for the FragmentDefinition (e.g. `fragment catName on Cat { name }`).
	   *
	   * @return {String} The GraphQL query string for the FragmentDefinition.
	   */
	
	  createClass(FragmentDefinition, [{
	    key: 'toString',
	    value: function toString() {
	      return 'fragment ' + this.name + ' on ' + this.typeName + ' ' + this.selectionSet;
	    }
	  }]);
	  return FragmentDefinition;
	}();
	
	function selectionsHaveIdField(selections) {
	  return selections.some(function (fieldOrFragment) {
	    if (Field.prototype.isPrototypeOf(fieldOrFragment)) {
	      return fieldOrFragment.name === 'id';
	    } else if (Spread.prototype.isPrototypeOf(fieldOrFragment) && fieldOrFragment.selectionSet.typeSchema.implementsNode) {
	      return selectionsHaveIdField(fieldOrFragment.selectionSet.selections);
	    }
	
	    return false;
	  });
	}
	
	function selectionsHaveTypenameField(selections) {
	  return selections.some(function (fieldOrFragment) {
	    if (Field.prototype.isPrototypeOf(fieldOrFragment)) {
	      return fieldOrFragment.name === '__typename';
	    } else if (Spread.prototype.isPrototypeOf(fieldOrFragment) && fieldOrFragment.selectionSet.typeSchema.implementsNode) {
	      return selectionsHaveTypenameField(fieldOrFragment.selectionSet.selections);
	    }
	
	    return false;
	  });
	}
	
	function indexSelectionsByResponseKey(selections) {
	  function assignOrPush(obj, key, value) {
	    if (Array.isArray(obj[key])) {
	      obj[key].push(value);
	    } else {
	      obj[key] = [value];
	    }
	  }
	  var unfrozenObject = selections.reduce(function (acc, selection) {
	    if (selection.responseKey) {
	      assignOrPush(acc, selection.responseKey, selection);
	    } else {
	      var responseKeys = Object.keys(selection.selectionSet.selectionsByResponseKey);
	
	      responseKeys.forEach(function (responseKey) {
	        assignOrPush(acc, responseKey, selection);
	      });
	    }
	
	    return acc;
	  }, {});
	
	  Object.keys(unfrozenObject).forEach(function (key) {
	    Object.freeze(unfrozenObject[key]);
	  });
	
	  return Object.freeze(unfrozenObject);
	}
	
	/**
	 * Class that specifies the full selection of data to query.
	 */
	
	var SelectionSet = function () {
	
	  /**
	   * This constructor should not be invoked directly. SelectionSets are created when building queries/mutations.
	   *
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {(Object|String)} type The type of the current selection.
	   * @param {Function} builderFunction Callback function used to build the SelectionSet.
	   *   The callback takes a {@link SelectionSetBuilder} as its argument.
	   */
	  function SelectionSet(typeBundle, type, builderFunction) {
	    classCallCheck(this, SelectionSet);
	
	    if (typeof type === 'string') {
	      this.typeSchema = schemaForType(typeBundle, type);
	    } else {
	      this.typeSchema = type;
	    }
	
	    trackTypeDependency(this.typeSchema.name);
	
	    this.typeBundle = typeBundle;
	    this.selections = [];
	    if (builderFunction) {
	      // eslint-disable-next-line no-use-before-define
	      builderFunction(new SelectionSetBuilder(this.typeBundle, this.typeSchema, this.selections));
	    }
	
	    if (this.typeSchema.implementsNode || this.typeSchema.name === 'Node') {
	      if (!selectionsHaveIdField(this.selections)) {
	        this.selections.unshift(new Field('id', {}, new SelectionSet(typeBundle, 'ID')));
	      }
	    }
	
	    if (this.typeSchema.kind === 'INTERFACE') {
	      if (!selectionsHaveTypenameField(this.selections)) {
	        this.selections.unshift(new Field('__typename', {}, new SelectionSet(typeBundle, 'String')));
	      }
	    }
	
	    this.selectionsByResponseKey = indexSelectionsByResponseKey(this.selections);
	    Object.freeze(this.selections);
	    Object.freeze(this);
	  }
	
	  /**
	   * Returns the GraphQL query string for the SelectionSet (e.g. `{ cat { name } }`).
	   *
	   * @return {String} The GraphQL query string for the SelectionSet.
	   */
	
	  createClass(SelectionSet, [{
	    key: 'toString',
	    value: function toString() {
	      if (this.typeSchema.kind === 'SCALAR' || this.typeSchema.kind === 'ENUM') {
	        return '';
	      } else {
	        return ' { ' + join(this.selections) + ' }';
	      }
	    }
	  }]);
	  return SelectionSet;
	}();
	
	var SelectionSetBuilder = function () {
	
	  /**
	   * This constructor should not be invoked directly. SelectionSetBuilders are created when building queries/mutations.
	   *
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {Object} typeSchema The schema object for the type of the current selection.
	   * @param {Field[]} selections The fields on the current selection.
	   */
	  function SelectionSetBuilder(typeBundle, typeSchema, selections) {
	    classCallCheck(this, SelectionSetBuilder);
	
	    this.typeBundle = typeBundle;
	    this.typeSchema = typeSchema;
	    this.selections = selections;
	  }
	
	  createClass(SelectionSetBuilder, [{
	    key: 'hasSelectionWithResponseKey',
	    value: function hasSelectionWithResponseKey(responseKey) {
	      return this.selections.some(function (field) {
	        return field.responseKey === responseKey;
	      });
	    }
	
	    /**
	     * Adds a field to be queried on the current selection.
	     *
	     * @example
	     * client.query((root) => {
	     *   root.add('cat', {args: {id: '123456'}, alias: 'meow'}, (cat) => {
	     *     cat.add('name');
	     *   });
	     * });
	     *
	     * @param {SelectionSet|String} selectionOrFieldName The selection or name of the field to add.
	     * @param {Object} [options] Options on the query including:
	     *   @param {Object} [options.args] Arguments on the query (e.g. `{id: '123456'}`).
	     *   @param {String} [options.alias] Alias for the field being added.
	     * @param {Function|SelectionSet} [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
	     */
	
	  }, {
	    key: 'add',
	    value: function add(selectionOrFieldName) {
	      var selection = void 0;
	
	      if (Object.prototype.toString.call(selectionOrFieldName) === '[object String]') {
	        trackFieldDependency(this.typeSchema.name, selectionOrFieldName);
	
	        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          rest[_key - 1] = arguments[_key];
	        }
	
	        selection = this.field.apply(this, [selectionOrFieldName].concat(rest));
	      } else {
	        if (Field.prototype.isPrototypeOf(selectionOrFieldName)) {
	          trackFieldDependency(this.typeSchema.name, selectionOrFieldName.name);
	        }
	
	        selection = selectionOrFieldName;
	      }
	
	      if (selection.responseKey && this.hasSelectionWithResponseKey(selection.responseKey)) {
	        throw new Error('The field name or alias \'' + selection.responseKey + '\' has already been added.');
	      }
	      this.selections.push(selection);
	    }
	  }, {
	    key: 'field',
	    value: function field(name) {
	      for (var _len2 = arguments.length, creationArgs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        creationArgs[_key2 - 1] = arguments[_key2];
	      }
	
	      var parsedArgs = parseFieldCreationArgs(creationArgs);
	      var options = parsedArgs.options,
	          callback = parsedArgs.callback;
	      var selectionSet = parsedArgs.selectionSet;
	
	      if (!selectionSet) {
	        if (!this.typeSchema.fieldBaseTypes[name]) {
	          throw new Error('No field of name "' + name + '" found on type "' + this.typeSchema.name + '" in schema');
	        }
	
	        var fieldBaseType = schemaForType(this.typeBundle, this.typeSchema.fieldBaseTypes[name]);
	
	        selectionSet = new SelectionSet(this.typeBundle, fieldBaseType, callback);
	      }
	
	      return new Field(name, options, selectionSet);
	    }
	
	    /**
	     * Creates an inline fragment.
	     *
	     * @access private
	     * @param {String} typeName The type  the inline fragment.
	     * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
	     * @return {InlineFragment} An inline fragment.
	     */
	
	  }, {
	    key: 'inlineFragmentOn',
	    value: function inlineFragmentOn(typeName) {
	      var builderFunctionOrSelectionSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
	      var selectionSet = void 0;
	
	      if (SelectionSet.prototype.isPrototypeOf(builderFunctionOrSelectionSet)) {
	        selectionSet = builderFunctionOrSelectionSet;
	      } else {
	        selectionSet = new SelectionSet(this.typeBundle, schemaForType(this.typeBundle, typeName), builderFunctionOrSelectionSet);
	      }
	
	      return new InlineFragment(typeName, selectionSet);
	    }
	
	    /**
	     * Adds a field to be queried on the current selection.
	     *
	     * @access private
	     * @param {String}    name The name of the field to add to the query.
	     * @param {Object} [options] Options on the query including:
	     *   @param {Object} [options.args] Arguments on the query (e.g. `{id: '123456'}`).
	     *   @param {String} [options.alias] Alias for the field being added.
	     * @param {Function}  [callback] Callback which will be used to create a new {@link SelectionSet} for the field added.
	     */
	
	  }, {
	    key: 'addField',
	    value: function addField(name) {
	      for (var _len3 = arguments.length, creationArgs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        creationArgs[_key3 - 1] = arguments[_key3];
	      }
	
	      this.add.apply(this, [name].concat(creationArgs));
	    }
	
	    /**
	     * Adds a connection to be queried on the current selection.
	     * This adds all the fields necessary for pagination.
	     *
	     * @example
	     * client.query((root) => {
	     *   root.add('cat', (cat) => {
	     *     cat.addConnection('friends', {args: {first: 10}, alias: 'coolCats'}, (friends) => {
	     *       friends.add('name');
	     *     });
	     *   });
	     * });
	     *
	     * @param {String}    name The name of the connection to add to the query.
	     * @param {Object} [options] Options on the query including:
	     *   @param {Object} [options.args] Arguments on the query (e.g. `{first: 10}`).
	     *   @param {String} [options.alias] Alias for the field being added.
	     * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
	     */
	
	  }, {
	    key: 'addConnection',
	    value: function addConnection(name) {
	      for (var _len4 = arguments.length, creationArgs = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	        creationArgs[_key4 - 1] = arguments[_key4];
	      }
	
	      var _parseFieldCreationAr = parseFieldCreationArgs(creationArgs),
	          options = _parseFieldCreationAr.options,
	          callback = _parseFieldCreationAr.callback,
	          selectionSet = _parseFieldCreationAr.selectionSet;
	
	      this.add(name, options, function (connection) {
	        connection.add('pageInfo', {}, function (pageInfo) {
	          pageInfo.add('hasNextPage');
	          pageInfo.add('hasPreviousPage');
	        });
	        connection.add('edges', {}, function (edges) {
	          edges.add('cursor');
	          edges.addField('node', {}, selectionSet || callback); // This is bad. Don't do this
	        });
	      });
	    }
	
	    /**
	     * Adds an inline fragment on the current selection.
	     *
	     * @example
	     * client.query((root) => {
	     *   root.add('animal', (animal) => {
	     *     animal.addInlineFragmentOn('cat', (cat) => {
	     *       cat.add('name');
	     *     });
	     *   });
	     * });
	     *
	     * @param {String} typeName The name of the type of the inline fragment.
	     * @param {Function|SelectionSet}  [callbackOrSelectionSet] Either a callback which will be used to create a new {@link SelectionSet}, or an existing {@link SelectionSet}.
	     */
	
	  }, {
	    key: 'addInlineFragmentOn',
	    value: function addInlineFragmentOn(typeName) {
	      var fieldTypeCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
	      this.add(this.inlineFragmentOn(typeName, fieldTypeCb));
	    }
	
	    /**
	     * Adds a fragment spread on the current selection.
	     *
	     * @example
	     * client.query((root) => {
	     *   root.addFragment(catFragmentSpread);
	     * });
	     *
	     * @param {FragmentSpread} fragmentSpread The fragment spread to add.
	     */
	
	  }, {
	    key: 'addFragment',
	    value: function addFragment(fragmentSpread) {
	      this.add(fragmentSpread);
	    }
	  }]);
	  return SelectionSetBuilder;
	}();
	
	function parseArgs(args) {
	  var name = void 0;
	  var variables = void 0;
	  var selectionSetCallback = void 0;
	
	  if (args.length === 3) {
	    var _args = slicedToArray(args, 3);
	
	    name = _args[0];
	    variables = _args[1];
	    selectionSetCallback = _args[2];
	  } else if (args.length === 2) {
	    if (Object.prototype.toString.call(args[0]) === '[object String]') {
	      name = args[0];
	      variables = null;
	    } else if (Array.isArray(args[0])) {
	      variables = args[0];
	      name = null;
	    }
	
	    selectionSetCallback = args[1];
	  } else {
	    selectionSetCallback = args[0];
	    name = null;
	  }
	
	  return { name: name, variables: variables, selectionSetCallback: selectionSetCallback };
	}
	
	var VariableDefinitions = function () {
	  function VariableDefinitions(variableDefinitions) {
	    classCallCheck(this, VariableDefinitions);
	
	    this.variableDefinitions = variableDefinitions ? [].concat(toConsumableArray(variableDefinitions)) : [];
	    Object.freeze(this.variableDefinitions);
	    Object.freeze(this);
	  }
	
	  createClass(VariableDefinitions, [{
	    key: 'toString',
	    value: function toString() {
	      if (this.variableDefinitions.length === 0) {
	        return '';
	      }
	
	      return ' (' + join(this.variableDefinitions) + ') ';
	    }
	  }]);
	  return VariableDefinitions;
	}();
	
	/**
	 * Base class for {@link Query} and {@link Mutation}.
	 * @abstract
	 */
	
	var Operation = function () {
	
	  /**
	   * This constructor should not be invoked. The subclasses {@link Query} and {@link Mutation} should be used instead.
	   */
	  function Operation(typeBundle, operationType) {
	    classCallCheck(this, Operation);
	
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var _parseArgs = parseArgs(args),
	        name = _parseArgs.name,
	        variables = _parseArgs.variables,
	        selectionSetCallback = _parseArgs.selectionSetCallback;
	
	    this.typeBundle = typeBundle;
	    this.name = name;
	    this.variableDefinitions = new VariableDefinitions(variables);
	    this.operationType = operationType;
	    if (operationType === 'query') {
	      this.selectionSet = new SelectionSet(typeBundle, typeBundle.queryType, selectionSetCallback);
	      this.typeSchema = schemaForType(typeBundle, typeBundle.queryType);
	    } else {
	      this.selectionSet = new SelectionSet(typeBundle, typeBundle.mutationType, selectionSetCallback);
	      this.typeSchema = schemaForType(typeBundle, typeBundle.mutationType);
	    }
	    Object.freeze(this);
	  }
	
	  /**
	   * Whether the operation is anonymous (i.e. has no name).
	   */
	
	  createClass(Operation, [{
	    key: 'toString',
	
	    /**
	     * Returns the GraphQL query or mutation string (e.g. `query myQuery { cat { name } }`).
	     *
	     * @return {String} The GraphQL query or mutation string.
	     */
	    value: function toString() {
	      var nameString = this.name ? ' ' + this.name : '';
	
	      return '' + this.operationType + nameString + this.variableDefinitions + this.selectionSet;
	    }
	  }, {
	    key: 'isAnonymous',
	    get: function get$$1() {
	      return !this.name;
	    }
	  }]);
	  return Operation;
	}();
	
	/**
	 * GraphQL Query class.
	 * @extends Operation
	 */
	
	var Query = function (_Operation) {
	  inherits(Query, _Operation);
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory functions {@link Client#query} or {@link Document#addQuery} to create a Query.
	   *
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {String} [name] A name for the query.
	   * @param {Object[]} [variables] A list of variables in the query. See {@link Client#variable}.
	   * @param {Function} selectionSetCallback The query builder callback.
	   *   A {@link SelectionSet} is created using this callback.
	   */
	  function Query(typeBundle) {
	    var _ref;
	
	    classCallCheck(this, Query);
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return possibleConstructorReturn(this, (_ref = Query.__proto__ || Object.getPrototypeOf(Query)).call.apply(_ref, [this, typeBundle, 'query'].concat(args)));
	  }
	
	  return Query;
	}(Operation);
	
	/**
	 * GraphQL Mutation class.
	 * @extends Operation
	 */
	
	var Mutation = function (_Operation) {
	  inherits(Mutation, _Operation);
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory functions {@link Client#mutation} or {@link Document#addMutation} to create a Mutation.
	   *
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {String} [name] A name for the mutation.
	   * @param {Object[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
	   * @param {Function} selectionSetCallback The mutation builder callback.
	   *   A {@link SelectionSet} is created using this callback.
	   */
	  function Mutation(typeBundle) {
	    var _ref;
	
	    classCallCheck(this, Mutation);
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return possibleConstructorReturn(this, (_ref = Mutation.__proto__ || Object.getPrototypeOf(Mutation)).call.apply(_ref, [this, typeBundle, 'mutation'].concat(args)));
	  }
	
	  return Mutation;
	}(Operation);
	
	function isAnonymous(operation) {
	  return operation.isAnonymous;
	}
	
	function hasAnonymousOperations(operations) {
	  return operations.some(isAnonymous);
	}
	
	function hasDuplicateOperationNames(operations) {
	  var names = operations.map(function (operation) {
	    return operation.name;
	  });
	
	  return names.reduce(function (hasDuplicates, name, index) {
	    return hasDuplicates || names.indexOf(name) !== index;
	  }, false);
	}
	
	function extractOperation(typeBundle, operationType) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  if (Operation.prototype.isPrototypeOf(args[0])) {
	    return args[0];
	  }
	
	  if (operationType === 'query') {
	    return new (Function.prototype.bind.apply(Query, [null].concat([typeBundle], args)))();
	  } else {
	    return new (Function.prototype.bind.apply(Mutation, [null].concat([typeBundle], args)))();
	  }
	}
	
	function isInvalidOperationCombination(operations) {
	  if (operations.length === 1) {
	    return false;
	  }
	
	  return hasAnonymousOperations(operations) || hasDuplicateOperationNames(operations);
	}
	
	function fragmentNameIsNotUnique(existingDefinitions, name) {
	  return existingDefinitions.some(function (definition) {
	    return definition.name === name;
	  });
	}
	
	var Document = function () {
	
	  /**
	   * This constructor should not be invoked directly.
	   * Use the factory function {@link Client#document} to create a Document.
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   */
	  function Document(typeBundle) {
	    classCallCheck(this, Document);
	
	    this.typeBundle = typeBundle;
	    this.definitions = [];
	  }
	
	  /**
	   * Returns the GraphQL query string for the Document (e.g. `query queryOne { ... } query queryTwo { ... }`).
	   *
	   * @return {String} The GraphQL query string for the Document.
	   */
	
	  createClass(Document, [{
	    key: 'toString',
	    value: function toString() {
	      return join(this.definitions);
	    }
	
	    /**
	     * Adds an operation to the Document.
	     *
	     * @private
	     * @param {String} operationType The type of the operation. Either 'query' or 'mutation'.
	     * @param {(Operation|String)} [query|queryName] Either an instance of an operation
	     *   object, or the name of an operation. Both are optional.
	     * @param {Object[]} [variables] A list of variables in the operation. See {@link Client#variable}.
	     * @param {Function} [callback] The query builder callback. If an operation
	     *   instance is passed, this callback will be ignored.
	     *   A {@link SelectionSet} is created using this callback.
	      */
	
	  }, {
	    key: 'addOperation',
	    value: function addOperation(operationType) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      var operation = extractOperation.apply(undefined, [this.typeBundle, operationType].concat(args));
	
	      if (isInvalidOperationCombination(this.operations.concat(operation))) {
	        throw new Error('All operations must be uniquely named on a multi-operation document');
	      }
	
	      this.definitions.push(operation);
	    }
	
	    /**
	     * Adds a query to the Document.
	     *
	     * @example
	     * document.addQuery('myQuery', (root) => {
	     *   root.add('cat', (cat) => {
	     *    cat.add('name');
	     *   });
	     * });
	     *
	     * @param {(Query|String)} [query|queryName] Either an instance of a query
	     *   object, or the name of a query. Both are optional.
	     * @param {Object[]} [variables] A list of variables in the query. See {@link Client#variable}.
	     * @param {Function} [callback] The query builder callback. If a query
	     *   instance is passed, this callback will be ignored.
	     *   A {@link SelectionSet} is created using this callback.
	     */
	
	  }, {
	    key: 'addQuery',
	    value: function addQuery() {
	      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      this.addOperation.apply(this, ['query'].concat(args));
	    }
	
	    /**
	     * Adds a mutation to the Document.
	     *
	     * @example
	     * const input = client.variable('input', 'CatCreateInput!');
	     *
	     * document.addMutation('myMutation', [input], (root) => {
	     *   root.add('catCreate', {args: {input}}, (catCreate) => {
	     *     catCreate.add('cat', (cat) => {
	     *       cat.add('name');
	     *     });
	     *   });
	     * });
	     *
	     * @param {(Mutation|String)} [mutation|mutationName] Either an instance of a mutation
	     *   object, or the name of a mutation. Both are optional.
	     * @param {Object[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
	     * @param {Function} [callback] The mutation builder callback. If a mutation
	     *   instance is passed, this callback will be ignored.
	     *   A {@link SelectionSet} is created using this callback.
	     */
	
	  }, {
	    key: 'addMutation',
	    value: function addMutation() {
	      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      this.addOperation.apply(this, ['mutation'].concat(args));
	    }
	
	    /**
	     * Defines a fragment on the Document.
	     *
	     * @param {String} name The name of the fragment.
	     * @param {String} onType The type the fragment is on.
	     * @param {Function} [builderFunction] The query builder callback.
	     *   A {@link SelectionSet} is created using this callback.
	     * @return {FragmentSpread} A {@link FragmentSpread} to be used with {@link SelectionSetBuilder#addFragment}.
	     */
	
	  }, {
	    key: 'defineFragment',
	    value: function defineFragment(name, onType, builderFunction) {
	      if (fragmentNameIsNotUnique(this.fragmentDefinitions, name)) {
	        throw new Error('All fragments must be uniquely named on a multi-fragment document');
	      }
	
	      var selectionSet = new SelectionSet(this.typeBundle, onType, builderFunction);
	      var fragment = new FragmentDefinition(name, onType, selectionSet);
	
	      this.definitions.push(fragment);
	
	      return fragment.spread;
	    }
	
	    /**
	     * All operations ({@link Query} and {@link Mutation}) on the Document.
	     */
	
	  }, {
	    key: 'operations',
	    get: function get$$1() {
	      return this.definitions.filter(function (definition) {
	        return Operation.prototype.isPrototypeOf(definition);
	      });
	    }
	
	    /**
	     * All {@link FragmentDefinition}s on the Document.
	     */
	
	  }, {
	    key: 'fragmentDefinitions',
	    get: function get$$1() {
	      return this.definitions.filter(function (definition) {
	        return FragmentDefinition.prototype.isPrototypeOf(definition);
	      });
	    }
	  }]);
	  return Document;
	}();
	
	/**
	 * The base class used when deserializing response data.
	 * Provides rich features, like functions to generate queries to refetch a node or fetch the next page.
	 *
	 * @class
	 */
	var GraphModel =
	
	/**
	 * @param {Object} attrs Attributes on the GraphModel.
	 */
	function GraphModel(attrs) {
	  var _this = this;
	
	  classCallCheck(this, GraphModel);
	
	  Object.defineProperty(this, 'attrs', { value: attrs, enumerable: false });
	
	  Object.keys(this.attrs).filter(function (key) {
	    return !(key in _this);
	  }).forEach(function (key) {
	    var descriptor = void 0;
	
	    if (attrs[key] === null) {
	      descriptor = {
	        enumerable: true,
	        get: function get$$1() {
	          return null;
	        }
	      };
	    } else {
	      descriptor = {
	        enumerable: true,
	        get: function get$$1() {
	          return this.attrs[key].valueOf();
	        }
	      };
	    }
	    Object.defineProperty(_this, key, descriptor);
	  });
	};
	
	/**
	 * A registry of classes used to deserialize the response data. Uses {@link GraphModel} by default.
	 */
	
	var ClassRegistry = function () {
	  function ClassRegistry() {
	    classCallCheck(this, ClassRegistry);
	
	    this.classStore = {};
	  }
	
	  /**
	   * Registers a class for a GraphQL type in the registry.
	   *
	   * @param {Class} constructor The constructor of the class.
	   * @param {String} type The GraphQL type of the object to deserialize into the class.
	   */
	
	  createClass(ClassRegistry, [{
	    key: 'registerClassForType',
	    value: function registerClassForType(constructor, type) {
	      this.classStore[type] = constructor;
	    }
	
	    /**
	     * Unregisters a class for a GraphQL type in the registry.
	     *
	     * @param {String} type The GraphQL type to unregister.
	     */
	
	  }, {
	    key: 'unregisterClassForType',
	    value: function unregisterClassForType(type) {
	      delete this.classStore[type];
	    }
	
	    /**
	     * Returns the class for the given GraphQL type.
	     *
	     * @param {String} type The GraphQL type to look up.
	     * @return {Class|GraphModel} The class for the given GraphQL type. Defaults to {@link GraphModel} if no class is registered for the GraphQL type.
	     */
	
	  }, {
	    key: 'classForType',
	    value: function classForType(type) {
	      return this.classStore[type] || GraphModel;
	    }
	  }]);
	  return ClassRegistry;
	}();
	
	function isValue(arg) {
	  return Object.prototype.toString.call(arg) !== '[object Null]' && Object.prototype.toString.call(arg) !== '[object Undefined]';
	}
	
	function isNodeContext(context) {
	  return context.selection.selectionSet.typeSchema.implementsNode;
	}
	
	function isConnection(context) {
	  return context.selection.selectionSet.typeSchema.name.endsWith('Connection');
	}
	
	function nearestNode(context) {
	  if (context == null) {
	    return null;
	  } else if (isNodeContext(context)) {
	    return context;
	  } else {
	    return nearestNode(context.parent);
	  }
	}
	
	function contextsFromRoot(context) {
	  if (context.parent) {
	    return contextsFromRoot(context.parent).concat(context);
	  } else {
	    return [context];
	  }
	}
	
	function contextsFromNearestNode(context) {
	  if (context.selection.selectionSet.typeSchema.implementsNode) {
	    return [context];
	  } else {
	    return contextsFromNearestNode(context.parent).concat(context);
	  }
	}
	
	function initializeDocumentAndVars(currentContext, contextChain) {
	  var lastInChain = contextChain[contextChain.length - 1];
	  var first = lastInChain.selection.args.first;
	  var variableDefinitions = Object.keys(lastInChain.selection.args).filter(function (key) {
	    return isVariable(lastInChain.selection.args[key]);
	  }).map(function (key) {
	    return lastInChain.selection.args[key];
	  });
	
	  var firstVar = variableDefinitions.find(function (definition) {
	    return definition.name === 'first';
	  });
	
	  if (!firstVar) {
	    firstVar = variable('first', 'Int', first);
	    variableDefinitions.push(firstVar);
	  }
	
	  var document = new Document(currentContext.selection.selectionSet.typeBundle);
	
	  return [document, variableDefinitions, firstVar];
	}
	
	function addNextFieldTo(currentSelection, contextChain, path, cursor) {
	  // There are always at least two. When we start, it's the root context, and the first set
	  var nextContext = contextChain.shift();
	
	  path.push(nextContext.selection.responseKey);
	
	  if (contextChain.length) {
	    currentSelection.add(nextContext.selection.name, { alias: nextContext.selection.alias, args: nextContext.selection.args }, function (newSelection) {
	      addNextFieldTo(newSelection, contextChain, path, cursor);
	    });
	  } else {
	    var edgesField = nextContext.selection.selectionSet.selections.find(function (field) {
	      return field.name === 'edges';
	    });
	    var nodeField = edgesField.selectionSet.selections.find(function (field) {
	      return field.name === 'node';
	    });
	    var first = void 0;
	
	    if (isVariable(nextContext.selection.args.first)) {
	      first = nextContext.selection.args.first;
	    } else {
	      first = variable('first', 'Int', nextContext.selection.args.first);
	    }
	
	    var options = {
	      alias: nextContext.selection.alias,
	      args: Object.assign({}, nextContext.selection.args, { after: cursor, first: first })
	    };
	
	    currentSelection.addConnection(nextContext.selection.name, options, nodeField.selectionSet);
	  }
	}
	
	function collectFragments(selections) {
	  return selections.reduce(function (fragmentDefinitions, field) {
	    if (FragmentSpread.prototype.isPrototypeOf(field)) {
	      fragmentDefinitions.push(field.toDefinition());
	    }
	
	    fragmentDefinitions.push.apply(fragmentDefinitions, toConsumableArray(collectFragments(field.selectionSet.selections)));
	
	    return fragmentDefinitions;
	  }, []);
	}
	
	function nextPageQueryAndPath(context, cursor) {
	  var nearestNodeContext = nearestNode(context);
	
	  if (nearestNodeContext) {
	    return function () {
	      var _document$definitions;
	
	      var path = [];
	      var nodeType = nearestNodeContext.selection.selectionSet.typeSchema;
	      var nodeId = nearestNodeContext.responseData.id;
	      var contextChain = contextsFromNearestNode(context);
	
	      var _initializeDocumentAn = initializeDocumentAndVars(context, contextChain),
	          _initializeDocumentAn2 = slicedToArray(_initializeDocumentAn, 2),
	          document = _initializeDocumentAn2[0],
	          variableDefinitions = _initializeDocumentAn2[1];
	
	      document.addQuery(variableDefinitions, function (root) {
	        path.push('node');
	        root.add('node', { args: { id: nodeId } }, function (node) {
	          node.addInlineFragmentOn(nodeType.name, function (fragment) {
	            addNextFieldTo(fragment, contextChain.slice(1), path, cursor);
	          });
	        });
	      });
	
	      var fragments = collectFragments(document.operations[0].selectionSet.selections);
	
	      (_document$definitions = document.definitions).unshift.apply(_document$definitions, toConsumableArray(fragments));
	
	      return [document, path];
	    };
	  } else {
	    return function () {
	      var _document$definitions2;
	
	      var path = [];
	      var contextChain = contextsFromRoot(context);
	
	      var _initializeDocumentAn3 = initializeDocumentAndVars(context, contextChain),
	          _initializeDocumentAn4 = slicedToArray(_initializeDocumentAn3, 2),
	          document = _initializeDocumentAn4[0],
	          variableDefinitions = _initializeDocumentAn4[1];
	
	      document.addQuery(variableDefinitions, function (root) {
	        addNextFieldTo(root, contextChain.slice(1), path, cursor);
	      });
	
	      var fragments = collectFragments(document.operations[0].selectionSet.selections);
	
	      (_document$definitions2 = document.definitions).unshift.apply(_document$definitions2, toConsumableArray(fragments));
	
	      return [document, path];
	    };
	  }
	}
	
	function hasNextPage$1(connection, edge) {
	  if (edge !== connection.edges[connection.edges.length - 1]) {
	    return new Scalar(true);
	  }
	
	  return connection.pageInfo.hasNextPage;
	}
	
	function hasPreviousPage(connection, edge) {
	  if (edge !== connection.edges[0]) {
	    return new Scalar(true);
	  }
	
	  return connection.pageInfo.hasPreviousPage;
	}
	
	function transformConnections(variableValues) {
	  return function (context, value) {
	    if (isConnection(context)) {
	      if (!(value.pageInfo && value.pageInfo.hasOwnProperty('hasNextPage') && value.pageInfo.hasOwnProperty('hasPreviousPage'))) {
	        throw new Error('Connections must include the selections "pageInfo { hasNextPage, hasPreviousPage }".');
	      }
	
	      return value.edges.map(function (edge) {
	        return Object.assign(edge.node, {
	          nextPageQueryAndPath: nextPageQueryAndPath(context, edge.cursor),
	          hasNextPage: hasNextPage$1(value, edge),
	          hasPreviousPage: hasPreviousPage(value, edge),
	          variableValues: variableValues
	        });
	      });
	    } else {
	      return value;
	    }
	  };
	}
	
	/* eslint-disable no-warning-comments */
	var DecodingContext = function () {
	  function DecodingContext(selection, responseData) {
	    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    classCallCheck(this, DecodingContext);
	
	    this.selection = selection;
	    this.responseData = responseData;
	    this.parent = parent;
	    Object.freeze(this);
	  }
	
	  createClass(DecodingContext, [{
	    key: 'contextForObjectProperty',
	    value: function contextForObjectProperty(responseKey) {
	      var nestedSelections = this.selection.selectionSet.selectionsByResponseKey[responseKey];
	      var nextSelection = nestedSelections && nestedSelections[0];
	      var nextContext = void 0;
	
	      // fragment spreads operate inside the current context, so we recurse to get the proper
	      // selection set, but retain the current response context
	      if (Spread.prototype.isPrototypeOf(nextSelection)) {
	        nextContext = new DecodingContext(nextSelection, this.responseData, this.parent);
	      } else {
	        nextContext = new DecodingContext(nextSelection, this.responseData[responseKey], this);
	      }
	
	      if (!nextSelection) {
	        throw new Error('Unexpected response key "' + responseKey + '", not found in selection set: ' + this.selection.selectionSet);
	      }
	
	      if (Field.prototype.isPrototypeOf(nextSelection)) {
	        return nextContext;
	      } else {
	        return nextContext.contextForObjectProperty(responseKey);
	      }
	    }
	  }, {
	    key: 'contextForArrayItem',
	    value: function contextForArrayItem(item) {
	      return new DecodingContext(this.selection, item, this.parent);
	    }
	  }]);
	  return DecodingContext;
	}();
	
	function decodeArrayItems(context, transformers) {
	  return context.responseData.map(function (item) {
	    return decodeContext(context.contextForArrayItem(item), transformers);
	  });
	}
	
	function decodeObjectValues(context, transformers) {
	  return Object.keys(context.responseData).reduce(function (acc, responseKey) {
	    acc[responseKey] = decodeContext(context.contextForObjectProperty(responseKey), transformers);
	
	    return acc;
	  }, {});
	}
	
	function runTransformers(transformers, context, value) {
	  return transformers.reduce(function (acc, transformer) {
	    return transformer(context, acc);
	  }, value);
	}
	
	function decodeContext(context, transformers) {
	  var value = context.responseData;
	
	  if (Array.isArray(value)) {
	    value = decodeArrayItems(context, transformers);
	  } else if (isObject(value)) {
	    value = decodeObjectValues(context, transformers);
	  }
	
	  return runTransformers(transformers, context, value);
	}
	
	function generateRefetchQueries(context, value) {
	  if (isValue(value) && isNodeContext(context)) {
	    value.refetchQuery = function () {
	      return new Query(context.selection.selectionSet.typeBundle, function (root) {
	        root.add('node', { args: { id: context.responseData.id } }, function (node) {
	          node.addInlineFragmentOn(context.selection.selectionSet.typeSchema.name, context.selection.selectionSet);
	        });
	      });
	    };
	  }
	
	  return value;
	}
	
	function transformPojosToClassesWithRegistry(classRegistry) {
	  return function transformPojosToClasses(context, value) {
	    if (isObject(value)) {
	      var Klass = classRegistry.classForType(context.selection.selectionSet.typeSchema.name);
	
	      return new Klass(value);
	    } else {
	      return value;
	    }
	  };
	}
	
	function transformScalars(context, value) {
	  if (isValue(value)) {
	    if (context.selection.selectionSet.typeSchema.kind === 'SCALAR') {
	      return new Scalar(value);
	    } else if (context.selection.selectionSet.typeSchema.kind === 'ENUM') {
	      return new Enum(value);
	    }
	  }
	
	  return value;
	}
	
	function recordTypeInformation(context, value) {
	  if (isValue(value)) {
	    if (value.__typename) {
	      value.type = schemaForType(context.selection.selectionSet.typeBundle, value.__typename);
	    } else {
	      value.type = context.selection.selectionSet.typeSchema;
	    }
	  }
	
	  return value;
	}
	
	function defaultTransformers(_ref) {
	  var _ref$classRegistry = _ref.classRegistry,
	      classRegistry = _ref$classRegistry === undefined ? new ClassRegistry() : _ref$classRegistry,
	      variableValues = _ref.variableValues;
	
	  return [transformScalars, generateRefetchQueries, transformConnections(variableValues), recordTypeInformation, transformPojosToClassesWithRegistry(classRegistry)];
	}
	
	/**
	 * A function used to decode the response data.
	 *
	 * @function decode
	 * @param {SelectionSet} selection The selection set used to query the response data.
	 * @param {Object} responseData The response data returned.
	 * @param {Object} [options] Options to use when decoding including:
	 *   @param {ClassRegistry} [options.classRegistry] A class registry to use when deserializing the data into classes.
	 * @return {GraphModel} The decoded response data.
	 */
	function decode(selection, responseData) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var transformers = options.transformers || defaultTransformers(options);
	  var context = new DecodingContext(selection, responseData);
	
	  return decodeContext(context, transformers);
	}
	
	function httpFetcher(url) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return function fetcher(graphQLParams) {
	    return fetch(url, _extends({
	      body: JSON.stringify(graphQLParams),
	      method: 'POST',
	      mode: 'cors'
	    }, options, {
	      headers: _extends({
	        'Content-Type': 'application/json',
	        Accept: 'application/json'
	      }, options.headers)
	    })).then(function (response) {
	      return response.json();
	    });
	  };
	}
	
	function hasNextPage(paginatedModels) {
	  return paginatedModels && paginatedModels.length && paginatedModels[paginatedModels.length - 1].hasNextPage;
	}
	
	/**
	 * The Client class used to create and send GraphQL documents, fragments, queries and mutations.
	 */
	
	var Client$2 = function () {
	
	  /**
	   * @param {Object} typeBundle A set of ES6 modules generated by {@link https://github.com/Shopify/graphql-js-schema|graphql-js-schema}.
	   * @param {Object} options An options object. Must include either `url` and optional `fetcherOptions` OR a `fetcher` function.
	   *   @param {(String|Function)} options.url|fetcher Either the URL of the GraphQL API endpoint, or a custom fetcher function for further customization.
	   *   @param {Object} [options.fetcherOptions] Additional options to use with `fetch`, like headers. Do not specify this argument if `fetcher` is specified.
	   *   @param {ClassRegistry} [options.registry=new ClassRegistry()] A {@link ClassRegistry} used to decode the response data.
	   */
	  function Client(typeBundle, _ref) {
	    var url = _ref.url,
	        fetcherOptions = _ref.fetcherOptions,
	        fetcher = _ref.fetcher,
	        _ref$registry = _ref.registry,
	        registry = _ref$registry === undefined ? new ClassRegistry() : _ref$registry;
	    classCallCheck(this, Client);
	
	    this.typeBundle = typeBundle;
	    this.classRegistry = registry;
	
	    if (url && fetcher) {
	      throw new Error('Arguments not supported: supply either `url` and optional `fetcherOptions` OR use a `fetcher` function for further customization.');
	    }
	
	    if (url) {
	      this.fetcher = httpFetcher(url, fetcherOptions);
	    } else if (fetcher) {
	      if (fetcherOptions) {
	        throw new Error('Arguments not supported: when specifying your own `fetcher`, set options through it and not with `fetcherOptions`');
	      }
	
	      this.fetcher = fetcher;
	    } else {
	      throw new Error('Invalid arguments: one of `url` or `fetcher` is needed.');
	    }
	  }
	
	  /**
	   * Creates a GraphQL document.
	   *
	   * @example
	   * const document = client.document();
	   *
	   * @return {Document} A GraphQL document.
	   */
	
	  createClass(Client, [{
	    key: 'document',
	    value: function document() {
	      return new Document(this.typeBundle);
	    }
	
	    /**
	     * Creates a GraphQL query.
	     *
	     * @example
	     * const query = client.query('myQuery', (root) => {
	     *   root.add('cat', (cat) => {
	     *    cat.add('name');
	     *   });
	     * });
	     *
	     * @param {String} [name] A name for the query.
	     * @param {VariableDefinition[]} [variables] A list of variables in the query. See {@link Client#variable}.
	     * @param {Function} selectionSetCallback The query builder callback.
	     *   A {@link SelectionSet} is created using this callback.
	     * @return {Query} A GraphQL query.
	     */
	
	  }, {
	    key: 'query',
	    value: function query() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return new (Function.prototype.bind.apply(Query, [null].concat([this.typeBundle], args)))();
	    }
	
	    /**
	     * Creates a GraphQL mutation.
	     *
	     * @example
	     * const input = client.variable('input', 'CatCreateInput!');
	     *
	     * const mutation = client.mutation('myMutation', [input], (root) => {
	     *   root.add('catCreate', {args: {input}}, (catCreate) => {
	     *     catCreate.add('cat', (cat) => {
	     *       cat.add('name');
	     *     });
	     *   });
	     * });
	     *
	     * @param {String} [name] A name for the mutation.
	     * @param {VariableDefinition[]} [variables] A list of variables in the mutation. See {@link Client#variable}.
	     * @param {Function} selectionSetCallback The mutation builder callback.
	     *   A {@link SelectionSet} is created using this callback.
	     * @return {Mutation} A GraphQL mutation.
	     */
	
	  }, {
	    key: 'mutation',
	    value: function mutation() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return new (Function.prototype.bind.apply(Mutation, [null].concat([this.typeBundle], args)))();
	    }
	
	    /**
	     * Sends a GraphQL operation (query or mutation) or a document.
	     *
	     * @example
	     * client.send(query, {id: '12345'}).then((result) => {
	     *   // Do something with the returned result
	     *   console.log(result);
	     * });
	     *
	     * @param {(Query|Mutation|Document|Function)} request The operation or document to send. If represented
	     * as a function, it must return `Query`, `Mutation`, or `Document` and recieve the client as the only param.
	     * @param {Object} [variableValues] The values for variables in the operation or document.
	     * @param {Object} [otherProperties] Other properties to send with the query. For example, a custom operation name.
	     * @return {Promise.<Object>} A promise resolving to an object containing the response data.
	     */
	
	  }, {
	    key: 'send',
	    value: function send(request) {
	      var _this = this;
	
	      var variableValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	      var otherProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	      var operationOrDocument = void 0;
	
	      if (Function.prototype.isPrototypeOf(request)) {
	        operationOrDocument = request(this);
	      } else {
	        operationOrDocument = request;
	      }
	
	      var graphQLParams = { query: operationOrDocument.toString() };
	
	      if (variableValues) {
	        graphQLParams.variables = variableValues;
	      }
	
	      Object.assign(graphQLParams, otherProperties);
	
	      var operation = void 0;
	
	      if (Operation.prototype.isPrototypeOf(operationOrDocument)) {
	        operation = operationOrDocument;
	      } else {
	        var document = operationOrDocument;
	
	        if (document.operations.length === 1) {
	          operation = document.operations[0];
	        } else if (otherProperties.operationName) {
	          operation = document.operations.find(function (documentOperation) {
	            return documentOperation.name === otherProperties.operationName;
	          });
	        } else {
	          throw new Error('\n          A document must contain exactly one operation, or an operationName\n          must be specified. Example:\n\n            client.send(document, null, {operationName: \'myFancyQuery\'});\n        ');
	        }
	      }
	
	      return this.fetcher(graphQLParams).then(function (response) {
	        if (response.data) {
	          response.model = decode(operation, response.data, {
	            classRegistry: _this.classRegistry,
	            variableValues: variableValues
	          });
	        }
	
	        return response;
	      });
	    }
	
	    /**
	     * Fetches the next page of a paginated node or array of nodes.
	     *
	     * @example
	     * client.fetchNextPage(node, {first: 10}).then((result) => {
	     *   // Do something with the next page
	     *   console.log(result);
	     * });
	     *
	     * @param {(GraphModel|GraphModel[])} nodeOrNodes The node or list of nodes on which to fetch the next page.
	     * @param {Object} [options] Options object containing:
	     *   @param {Integer} [options.first] The number of nodes to query on the next page. Defaults to the page size of the previous query.
	     * @return {Promise.<GraphModel[]>} A promise resolving with the next page of {@link GraphModel}s.
	     */
	
	  }, {
	    key: 'fetchNextPage',
	    value: function fetchNextPage(nodeOrNodes, options) {
	      var node = void 0;
	
	      if (Array.isArray(nodeOrNodes)) {
	        node = nodeOrNodes[nodeOrNodes.length - 1];
	      } else {
	        node = nodeOrNodes;
	      }
	
	      var _node$nextPageQueryAn = node.nextPageQueryAndPath(),
	          _node$nextPageQueryAn2 = slicedToArray(_node$nextPageQueryAn, 2),
	          query = _node$nextPageQueryAn2[0],
	          path = _node$nextPageQueryAn2[1];
	
	      var variableValues = void 0;
	
	      if (node.variableValues || options) {
	        variableValues = Object.assign({}, node.variableValues, options);
	      }
	
	      return this.send(query, variableValues).then(function (response) {
	        response.model = path.reduce(function (object, key) {
	          return object[key];
	        }, response.model);
	
	        return response;
	      });
	    }
	
	    /**
	     * Fetches all subsequent pages of a paginated array of nodes.
	     *
	     * @example
	     * client.fetchAllPages(nodes, {pageSize: 20}).then((result) => {
	     *   // Do something with all the models
	     *   console.log(result);
	     * });
	     *
	     * @param {GraphModel[]} paginatedModels The list of nodes on which to fetch all pages.
	     * @param {Object} options Options object containing:
	     *   @param {Integer} options.pageSize The number of nodes to query on each page.
	     * @return {Promise.<GraphModel[]>} A promise resolving with all pages of {@link GraphModel}s, including the original list.
	     */
	
	  }, {
	    key: 'fetchAllPages',
	    value: function fetchAllPages(paginatedModels, _ref2) {
	      var _this2 = this;
	
	      var pageSize = _ref2.pageSize;
	
	      if (hasNextPage(paginatedModels)) {
	        return this.fetchNextPage(paginatedModels, { first: pageSize }).then(function (_ref3) {
	          var model = _ref3.model;
	
	          var pages = paginatedModels.concat(model);
	
	          return _this2.fetchAllPages(pages, { pageSize: pageSize });
	        });
	      }
	
	      return Promise.resolve(paginatedModels);
	    }
	
	    /**
	     * Refetches a {@link GraphModel} whose type implements `Node`.
	     *
	     * @example
	     * client.refetch(node).then((result) => {
	     *   // Do something with the refetched node
	     *   console.log(result);
	     * });
	     *
	     * @param {GraphModel} nodeType A {@link GraphModel} whose type implements `Node`.
	     * @return {Promise.<GraphModel>} The refetched {@link GraphModel}.
	     */
	
	  }, {
	    key: 'refetch',
	    value: function refetch(nodeType) {
	      if (!nodeType) {
	        throw new Error('\'client#refetch\' must be called with a non-null instance of a Node.');
	      } else if (!nodeType.type.implementsNode) {
	        throw new Error('\'client#refetch\' must be called with a type that implements Node. Received ' + nodeType.type.name + '.');
	      }
	
	      return this.send(nodeType.refetchQuery()).then(function (_ref4) {
	        var model = _ref4.model;
	        return model.node;
	      });
	    }
	
	    /**
	     * Creates a variable to be used in a {@link Query} or {@link Mutation}.
	     *
	     * @example
	     * const idVariable = client.variable('id', 'ID!', '12345');
	     *
	     * @param {String} name The name of the variable.
	     * @param {String} type The GraphQL type of the variable.
	     * @param {*} [defaultValue] The default value of the variable.
	     * @return {VariableDefinition} A variable object that can be used in a {@link Query} or {@link Mutation}.
	     */
	
	  }, {
	    key: 'variable',
	    value: function variable$$1(name, type, defaultValue) {
	      return variable(name, type, defaultValue);
	    }
	
	    /**
	     * Creates an enum to be used in a {@link Query} or {@link Mutation}.
	     *
	     * @example
	     * const titleEnum = client.enum('TITLE');
	     *
	     * @param {String} key The key of the enum.
	     * @return {Enum} An enum object that can be used in a {@link Query} or {@link Mutation}.
	     */
	
	  }, {
	    key: 'enum',
	    value: function _enum(key) {
	      return enumFunction(key);
	    }
	  }]);
	  return Client;
	}();
	
	/**
	 * The class used to configure the JS Buy SDK Client.
	 * @class
	 */
	var Config = function () {
	  createClass$1(Config, [{
	    key: 'requiredProperties',
	
	
	    /**
	     * Properties that must be set on initializations
	     * @attribute requiredProperties
	     * @default ['storefrontAccessToken', 'domain']
	     * @type Array
	     * @private
	     */
	    get: function get$$1() {
	      return ['storefrontAccessToken', 'domain'];
	    }
	
	    /**
	     * Deprecated properties that map directly to required properties
	     * @attribute deprecatedProperties
	     * @default {'accessToken': 'storefrontAccessToken', 'apiKey': 'storefrontAccessToken'}
	     * @type Object
	     * @private
	     */
	
	  }, {
	    key: 'deprecatedProperties',
	    get: function get$$1() {
	      return {
	        accessToken: 'storefrontAccessToken',
	        apiKey: 'storefrontAccessToken'
	      };
	    }
	
	    /**
	     * @constructs Config
	     * @param {Object} attrs An object specifying the configuration. Requires the following properties:
	     *   @param {String} attrs.storefrontAccessToken The {@link https://help.shopify.com/api/reference/storefront_access_token|Storefront access token} for the shop.
	     *   @param {String} attrs.domain The `myshopify` domain for the shop (e.g. `graphql.myshopify.com`).
	     */
	
	  }]);
	
	  function Config(attrs) {
	    var _this = this;
	
	    classCallCheck$1(this, Config);
	
	    Object.keys(this.deprecatedProperties).forEach(function (key) {
	      if (!attrs.hasOwnProperty(key)) {
	        return;
	      }
	      // eslint-disable-next-line no-console
	      console.warn('[ShopifyBuy] Config property ' + key + ' is deprecated as of v1.0, please use ' + _this.deprecatedProperties[key] + ' instead.');
	      attrs[_this.deprecatedProperties[key]] = attrs[key];
	    });
	
	    this.requiredProperties.forEach(function (key) {
	      if (attrs.hasOwnProperty(key)) {
	        _this[key] = attrs[key];
	      } else {
	        throw new Error('new Config() requires the option \'' + key + '\'');
	      }
	    });
	  }
	
	  return Config;
	}();
	
	var Resource = function Resource(client) {
	  classCallCheck$1(this, Resource);
	
	  this.graphQLClient = client;
	};
	
	var defaultErrors = [{ message: 'an unknown error has occured.' }];
	
	function defaultResolver(path) {
	  var keys = path.split('.');
	
	  return function (_ref) {
	    var model = _ref.model,
	        errors = _ref.errors;
	
	    return new Promise(function (resolve, reject) {
	      try {
	        var result = keys.reduce(function (ref, key) {
	          return ref[key];
	        }, model);
	
	        resolve(result);
	      } catch (_) {
	        if (errors) {
	          reject(errors);
	        } else {
	          reject(defaultErrors);
	        }
	      }
	    });
	  };
	}
	
	function fetchResourcesForProducts(productOrProduct, client) {
	  var products = [].concat(productOrProduct);
	
	  return Promise.all(products.reduce(function (promiseAcc, product) {
	    // Fetch the rest of the images and variants for this product
	    promiseAcc.push(client.fetchAllPages(product.images, { pageSize: 250 }).then(function (images) {
	      product.attrs.images = images;
	    }));
	
	    promiseAcc.push(client.fetchAllPages(product.variants, { pageSize: 250 }).then(function (variants) {
	      product.attrs.variants = variants;
	    }));
	
	    return promiseAcc;
	  }, []));
	}
	
	function paginateProductConnectionsAndResolve(client) {
	  return function (products) {
	    return fetchResourcesForProducts(products, client).then(function () {
	      return products;
	    });
	  };
	}
	
	function paginateCollectionsProductConnectionsAndResolve(client) {
	  return function (collectionOrCollections) {
	    var collections = [].concat(collectionOrCollections);
	
	    return Promise.all(collections.reduce(function (promiseAcc, collection) {
	      return promiseAcc.concat(fetchResourcesForProducts(collection.products, client));
	    }, [])).then(function () {
	      return collectionOrCollections;
	    });
	  };
	}
	
	/**
	 * @namespace ProductHelpers
	 */
	var productHelpers = {
	
	  /**
	   * Returns the variant of a product corresponding to the options given.
	   *
	   * @example
	   * const selectedVariant = client.product.variantForOptions(product, {
	   *   size: "Small",
	   *   color: "Red"
	   * });
	   *
	   * @memberof ProductHelpers
	   * @method variantForOptions
	   * @param {GraphModel} product The product to find the variant on. Must include `variants`.
	   * @param {Object} options An object containing the options for the variant.
	   * @return {GraphModel} The variant corresponding to the options given.
	   */
	  variantForOptions: function variantForOptions(product, options) {
	    return product.variants.find(function (variant) {
	      return variant.selectedOptions.every(function (selectedOption) {
	        return options[selectedOption.name] === selectedOption.value.valueOf();
	      });
	    });
	  }
	};
	
	function query(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.id = client.variable("id", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.id], function (root) {
	    root.add("node", {
	      args: {
	        id: variables.__defaultOperation__.id
	      }
	    }, function (node) {
	      node.addFragment(spreads.ProductFragment);
	    });
	  });
	  return document;
	}
	
	function query$1(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.ids = client.variable("ids", "[ID!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.ids], function (root) {
	    root.add("nodes", {
	      args: {
	        ids: variables.__defaultOperation__.ids
	      }
	    }, function (nodes) {
	      nodes.addFragment(spreads.ProductFragment);
	    });
	  });
	  return document;
	}
	
	function query$2(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.first = client.variable("first", "Int!");
	  variables.__defaultOperation__.query = client.variable("query", "String");
	  variables.__defaultOperation__.sortKey = client.variable("sortKey", "ProductSortKeys");
	  variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse], function (root) {
	    root.add("shop", function (shop) {
	      shop.add("products", {
	        args: {
	          first: variables.__defaultOperation__.first,
	          query: variables.__defaultOperation__.query,
	          sortKey: variables.__defaultOperation__.sortKey,
	          reverse: variables.__defaultOperation__.reverse
	        }
	      }, function (products) {
	        products.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        products.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.addFragment(spreads.ProductFragment);
	          });
	        });
	      });
	    });
	  });
	  return document;
	}
	
	function query$3(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.handle = client.variable("handle", "String!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.handle], function (root) {
	    root.add("shop", function (shop) {
	      shop.add("productByHandle", {
	        args: {
	          handle: variables.__defaultOperation__.handle
	        }
	      }, function (productByHandle) {
	        productByHandle.addFragment(spreads.ProductFragment);
	      });
	    });
	  });
	  return document;
	}
	
	// GraphQL
	/**
	 * The JS Buy SDK product resource
	 * @class
	 */
	
	var ProductResource = function (_Resource) {
	  inherits$1(ProductResource, _Resource);
	
	  function ProductResource() {
	    classCallCheck$1(this, ProductResource);
	    return possibleConstructorReturn$1(this, (ProductResource.__proto__ || Object.getPrototypeOf(ProductResource)).apply(this, arguments));
	  }
	
	  createClass$1(ProductResource, [{
	    key: 'fetchAll',
	
	
	    /**
	     * Fetches all products on the shop.
	     *
	     * @example
	     * client.product.fetchAll().then((products) => {
	     *   // Do something with the products
	     * });
	     *
	     * @param {Int} [pageSize] The number of products to fetch per page
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
	     */
	    value: function fetchAll() {
	      var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
	
	      return this.graphQLClient.send(query$2, { first: first }).then(defaultResolver('shop.products')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches a single product by ID on the shop.
	     *
	     * @example
	     * client.product.fetch('Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==').then((product) => {
	     *   // Do something with the product
	     * });
	     *
	     * @param {String} id The id of the product to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the product.
	     */
	
	  }, {
	    key: 'fetch',
	    value: function fetch(id) {
	      return this.graphQLClient.send(query, { id: id }).then(defaultResolver('node')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches multiple products by ID on the shop.
	     *
	     * @example
	     * const ids = ['Xk9lM2JkNzFmNzIQ4NTIY4ZDFi9DaGVja291dC9lM2JkN==', 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0Lzc4NTc5ODkzODQ='];
	     * client.product.fetchMultiple(ids).then((products) => {
	     *   // Do something with the products
	     * });
	     *
	     * @param {String[]} ids The ids of the products to fetch
	     * @return {Promise|GraphModel[]} A promise resolving with a `GraphModel` of the product.
	     */
	
	  }, {
	    key: 'fetchMultiple',
	    value: function fetchMultiple(ids) {
	      return this.graphQLClient.send(query$1, { ids: ids }).then(defaultResolver('nodes')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches a single product by handle on the shop.
	     *
	     * @example
	     * client.product.fetchByHandle('my-product').then((product) => {
	     *   // Do something with the product
	     * });
	     *
	     * @param {String} handle The handle of the product to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the product.
	     */
	
	  }, {
	    key: 'fetchByHandle',
	    value: function fetchByHandle(handle) {
	      return this.graphQLClient.send(query$3, { handle: handle }).then(defaultResolver('shop.productByHandle')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches all products on the shop that match the query.
	     *
	     * @example
	     * client.product.fetchQuery({first: 20, sortKey: 'CREATED_AT', reverse: true}).then((products) => {
	     *   // Do something with the first 10 products sorted by title in ascending order
	     * });
	     *
	     * @param {Object} [args] An object specifying the query data containing zero or more of:
	     *   @param {Int} [args.first=20] The relay `first` param. This specifies page size.
	     *   @param {String} [args.sortKey=ID] The key to sort results by. Available values are
	     *   documented as {@link https://help.shopify.com/api/storefront-api/reference/enum/productsortkeys|Product Sort Keys}.
	     *   @param {String} [args.query] A query string. See full documentation {@link https://help.shopify.com/api/storefront-api/reference/object/shop#products|here}
	     *   @param {Boolean} [args.reverse] Whether or not to reverse the sort order of the results
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the products.
	     */
	
	  }, {
	    key: 'fetchQuery',
	    value: function fetchQuery() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$first = _ref.first,
	          first = _ref$first === undefined ? 20 : _ref$first,
	          _ref$sortKey = _ref.sortKey,
	          sortKey = _ref$sortKey === undefined ? 'ID' : _ref$sortKey,
	          query$$1 = _ref.query,
	          reverse = _ref.reverse;
	
	      return this.graphQLClient.send(query$2, {
	        first: first,
	        sortKey: sortKey,
	        query: query$$1,
	        reverse: reverse
	      }).then(defaultResolver('shop.products')).then(paginateProductConnectionsAndResolve(this.graphQLClient));
	    }
	  }, {
	    key: 'helpers',
	    get: function get$$1() {
	      return productHelpers;
	    }
	  }]);
	  return ProductResource;
	}(Resource);
	
	function query$4(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.id = client.variable("id", "ID!");
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.id], function (root) {
	    root.add("node", {
	      args: {
	        id: variables.__defaultOperation__.id
	      }
	    }, function (node) {
	      node.addFragment(spreads.CollectionFragment);
	    });
	  });
	  return document;
	}
	
	function query$5(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.id = client.variable("id", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  spreads.CollectionsProductsFragment = document.defineFragment("CollectionsProductsFragment", "Collection", function (root) {
	    root.add("products", {
	      args: {
	        first: 20
	      }
	    }, function (products) {
	      products.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      products.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.ProductFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.id], function (root) {
	    root.add("node", {
	      args: {
	        id: variables.__defaultOperation__.id
	      }
	    }, function (node) {
	      node.addFragment(spreads.CollectionFragment);
	      node.addFragment(spreads.CollectionsProductsFragment);
	    });
	  });
	  return document;
	}
	
	function query$6(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.first = client.variable("first", "Int!");
	  variables.__defaultOperation__.query = client.variable("query", "String");
	  variables.__defaultOperation__.sortKey = client.variable("sortKey", "CollectionSortKeys");
	  variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse], function (root) {
	    root.add("shop", function (shop) {
	      shop.add("collections", {
	        args: {
	          first: variables.__defaultOperation__.first,
	          query: variables.__defaultOperation__.query,
	          sortKey: variables.__defaultOperation__.sortKey,
	          reverse: variables.__defaultOperation__.reverse
	        }
	      }, function (collections) {
	        collections.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        collections.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.addFragment(spreads.CollectionFragment);
	          });
	        });
	      });
	    });
	  });
	  return document;
	}
	
	function query$7(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.first = client.variable("first", "Int!");
	  variables.__defaultOperation__.query = client.variable("query", "String");
	  variables.__defaultOperation__.sortKey = client.variable("sortKey", "CollectionSortKeys");
	  variables.__defaultOperation__.reverse = client.variable("reverse", "Boolean");
	  variables.__defaultOperation__.productsFirst = client.variable("productsFirst", "Int!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.first, variables.__defaultOperation__.query, variables.__defaultOperation__.sortKey, variables.__defaultOperation__.reverse, variables.__defaultOperation__.productsFirst], function (root) {
	    root.add("shop", function (shop) {
	      shop.add("collections", {
	        args: {
	          first: variables.__defaultOperation__.first,
	          query: variables.__defaultOperation__.query,
	          sortKey: variables.__defaultOperation__.sortKey,
	          reverse: variables.__defaultOperation__.reverse
	        }
	      }, function (collections) {
	        collections.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        collections.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.addFragment(spreads.CollectionFragment);
	            node.add("products", {
	              args: {
	                first: variables.__defaultOperation__.productsFirst
	              }
	            }, function (products) {
	              products.add("pageInfo", function (pageInfo) {
	                pageInfo.add("hasNextPage");
	                pageInfo.add("hasPreviousPage");
	              });
	              products.add("edges", function (edges) {
	                edges.add("cursor");
	                edges.add("node", function (node) {
	                  node.addFragment(spreads.ProductFragment);
	                });
	              });
	            });
	          });
	        });
	      });
	    });
	  });
	  return document;
	}
	
	function query$8(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.handle = client.variable("handle", "String!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.ProductFragment = document.defineFragment("ProductFragment", "Product", function (root) {
	    root.add("id");
	    root.add("availableForSale");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("descriptionHtml");
	    root.add("description");
	    root.add("handle");
	    root.add("productType");
	    root.add("title");
	    root.add("vendor");
	    root.add("publishedAt");
	    root.add("onlineStoreUrl");
	    root.add("options", function (options) {
	      options.add("name");
	      options.add("values");
	    });
	    root.add("images", {
	      args: {
	        first: 250
	      }
	    }, function (images) {
	      images.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      images.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("src");
	          node.add("altText");
	        });
	      });
	    });
	    root.add("variants", {
	      args: {
	        first: 250
	      }
	    }, function (variants) {
	      variants.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      variants.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.VariantFragment);
	        });
	      });
	    });
	  });
	  spreads.CollectionFragment = document.defineFragment("CollectionFragment", "Collection", function (root) {
	    root.add("id");
	    root.add("handle");
	    root.add("description");
	    root.add("descriptionHtml");
	    root.add("updatedAt");
	    root.add("title");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	  });
	  spreads.CollectionsProductsFragment = document.defineFragment("CollectionsProductsFragment", "Collection", function (root) {
	    root.add("products", {
	      args: {
	        first: 20
	      }
	    }, function (products) {
	      products.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      products.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.addFragment(spreads.ProductFragment);
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.handle], function (root) {
	    root.add("shop", function (shop) {
	      shop.add("collectionByHandle", {
	        args: {
	          handle: variables.__defaultOperation__.handle
	        }
	      }, function (collectionByHandle) {
	        collectionByHandle.addFragment(spreads.CollectionFragment);
	        collectionByHandle.addFragment(spreads.CollectionsProductsFragment);
	      });
	    });
	  });
	  return document;
	}
	
	// GraphQL
	/**
	 * The JS Buy SDK collection resource
	 * @class
	 */
	
	var CollectionResource = function (_Resource) {
	  inherits$1(CollectionResource, _Resource);
	
	  function CollectionResource() {
	    classCallCheck$1(this, CollectionResource);
	    return possibleConstructorReturn$1(this, (CollectionResource.__proto__ || Object.getPrototypeOf(CollectionResource)).apply(this, arguments));
	  }
	
	  createClass$1(CollectionResource, [{
	    key: 'fetchAll',
	
	
	    /**
	     * Fetches all collections on the shop, not including products.
	     * To fetch collections with products use [fetchAllsWithProducts]{@link Client#fetchAllsWithProducts}.
	     *
	     * @example
	     * client.collection.fetchAll().then((collections) => {
	     *   // Do something with the collections
	     * });
	     *
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
	     */
	    value: function fetchAll() {
	      var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
	
	      return this.graphQLClient.send(query$6, { first: first }).then(defaultResolver('shop.collections'));
	    }
	
	    /**
	     * Fetches all collections on the shop, including products.
	     *
	     * @example
	     * client.collection.fetchAllWithProducts().then((collections) => {
	     *   // Do something with the collections
	     * });
	     *
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
	     */
	
	  }, {
	    key: 'fetchAllWithProducts',
	    value: function fetchAllWithProducts() {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$first = _ref.first,
	          first = _ref$first === undefined ? 20 : _ref$first,
	          _ref$productsFirst = _ref.productsFirst,
	          productsFirst = _ref$productsFirst === undefined ? 20 : _ref$productsFirst;
	
	      return this.graphQLClient.send(query$7, { first: first, productsFirst: productsFirst }).then(defaultResolver('shop.collections')).then(paginateCollectionsProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches a single collection by ID on the shop, not including products.
	     * To fetch the collection with products use [fetchWithProducts]{@link Client#fetchWithProducts}.
	     *
	     * @example
	     * client.collection.fetch('Xk9lM2JkNzFmNzIQ4NTIY4ZDFiZTUyZTUwNTE2MDNhZjg==').then((collection) => {
	     *   // Do something with the collection
	     * });
	     *
	     * @param {String} id The id of the collection to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
	     */
	
	  }, {
	    key: 'fetch',
	    value: function fetch(id) {
	      return this.graphQLClient.send(query$4, { id: id }).then(defaultResolver('node'));
	    }
	
	    /**
	     * Fetches a single collection by ID on the shop, including products.
	     *
	     * @example
	     * client.collection.fetchWithProducts('Xk9lM2JkNzFmNzIQ4NTIY4ZDFiZTUyZTUwNTE2MDNhZjg==').then((collection) => {
	     *   // Do something with the collection
	     * });
	     *
	     * @param {String} id The id of the collection to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
	     */
	
	  }, {
	    key: 'fetchWithProducts',
	    value: function fetchWithProducts(id) {
	      return this.graphQLClient.send(query$5, { id: id }).then(defaultResolver('node')).then(paginateCollectionsProductConnectionsAndResolve(this.graphQLClient));
	    }
	
	    /**
	     * Fetches a collection by handle on the shop.
	     *
	     * @example
	     * client.collection.fetchByHandle('my-collection').then((collection) => {
	     *   // Do something with the collection
	     * });
	     *
	     * @param {String} handle The handle of the collection to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the collection.
	     */
	
	  }, {
	    key: 'fetchByHandle',
	    value: function fetchByHandle(handle) {
	      return this.graphQLClient.send(query$8, { handle: handle }).then(defaultResolver('shop.collectionByHandle'));
	    }
	
	    /**
	     * Fetches all collections on the shop that match the query.
	     *
	     * @example
	     * client.collection.fetchQuery({first: 20, sortKey: 'CREATED_AT', reverse: true}).then((collections) => {
	     *   // Do something with the first 10 collections sorted by title in ascending order
	     * });
	     *
	     * @param {Object} [args] An object specifying the query data containing zero or more of:
	     *   @param {Int} [args.first=20] The relay `first` param. This specifies page size.
	     *   @param {String} [args.sortKey=ID] The key to sort results by. Available values are
	     *   documented as {@link https://help.shopify.com/api/storefront-api/reference/enum/collectionsortkeys|Collection Sort Keys}.
	     *   @param {String} [args.query] A query string. See full documentation {@link https://help.shopify.com/api/storefront-api/reference/object/shop#collections|here}
	     *   @param {Boolean} [args.reverse] Whether or not to reverse the sort order of the results
	     * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the collections.
	     */
	
	  }, {
	    key: 'fetchQuery',
	    value: function fetchQuery() {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$first = _ref2.first,
	          first = _ref2$first === undefined ? 20 : _ref2$first,
	          _ref2$sortKey = _ref2.sortKey,
	          sortKey = _ref2$sortKey === undefined ? 'ID' : _ref2$sortKey,
	          query = _ref2.query,
	          reverse = _ref2.reverse;
	
	      return this.graphQLClient.send(query$6, {
	        first: first,
	        sortKey: sortKey,
	        query: query,
	        reverse: reverse
	      }).then(defaultResolver('shop.collections'));
	    }
	  }]);
	  return CollectionResource;
	}(Resource);
	
	function query$9(client) {
	  var document = client.document();
	  document.addQuery(function (root) {
	    root.add("shop", function (shop) {
	      shop.add("currencyCode");
	      shop.add("description");
	      shop.add("moneyFormat");
	      shop.add("name");
	      shop.add("primaryDomain", function (primaryDomain) {
	        primaryDomain.add("host");
	        primaryDomain.add("sslEnabled");
	        primaryDomain.add("url");
	      });
	    });
	  });
	  return document;
	}
	
	function query$10(client) {
	  var document = client.document();
	  var spreads = {};
	  spreads.PolicyFragment = document.defineFragment("PolicyFragment", "ShopPolicy", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("url");
	    root.add("body");
	  });
	  document.addQuery(function (root) {
	    root.add("shop", function (shop) {
	      shop.add("privacyPolicy", function (privacyPolicy) {
	        privacyPolicy.addFragment(spreads.PolicyFragment);
	      });
	      shop.add("termsOfService", function (termsOfService) {
	        termsOfService.addFragment(spreads.PolicyFragment);
	      });
	      shop.add("refundPolicy", function (refundPolicy) {
	        refundPolicy.addFragment(spreads.PolicyFragment);
	      });
	    });
	  });
	  return document;
	}
	
	// GraphQL
	/**
	 * The JS Buy SDK shop resource
	 * @class
	 */
	
	var ShopResource = function (_Resource) {
	  inherits$1(ShopResource, _Resource);
	
	  function ShopResource() {
	    classCallCheck$1(this, ShopResource);
	    return possibleConstructorReturn$1(this, (ShopResource.__proto__ || Object.getPrototypeOf(ShopResource)).apply(this, arguments));
	  }
	
	  createClass$1(ShopResource, [{
	    key: 'fetchInfo',
	
	
	    /**
	     * Fetches shop information (`currencyCode`, `description`, `moneyFormat`, `name`, and `primaryDomain`).
	     * See the {@link https://help.shopify.com/api/storefront-api/reference/object/shop|Storefront API reference} for more information.
	     *
	     * @example
	     * client.shop.fetchInfo().then((shop) => {
	     *   // Do something with the shop
	     * });
	     *
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the shop.
	     */
	    value: function fetchInfo() {
	      return this.graphQLClient.send(query$9).then(defaultResolver('shop'));
	    }
	
	    /**
	     * Fetches shop policies (privacy policy, terms of service and refund policy).
	     *
	     * @example
	     * client.shop.fetchPolicies().then((shop) => {
	     *   // Do something with the shop
	     * });
	     *
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the shop.
	     */
	
	  }, {
	    key: 'fetchPolicies',
	    value: function fetchPolicies() {
	      return this.graphQLClient.send(query$10).then(defaultResolver('shop'));
	    }
	  }]);
	  return ShopResource;
	}(Resource);
	
	function handleCheckoutMutation(mutationRootKey, client) {
	  return function (_ref) {
	    var data = _ref.data,
	        errors = _ref.errors,
	        model = _ref.model;
	
	    var rootData = data[mutationRootKey];
	    var rootModel = model[mutationRootKey];
	
	    if (rootData && rootData.checkout) {
	      return client.fetchAllPages(rootModel.checkout.lineItems, { pageSize: 250 }).then(function (lineItems) {
	        rootModel.checkout.attrs.lineItems = lineItems;
	        rootModel.checkout.errors = errors;
	        rootModel.checkout.userErrors = rootModel.userErrors;
	
	        return rootModel.checkout;
	      });
	    }
	
	    if (errors && errors.length) {
	      return Promise.reject(new Error(JSON.stringify(errors)));
	    }
	
	    if (rootData && rootData.userErrors && rootData.userErrors.length) {
	      return Promise.reject(new Error(JSON.stringify(rootData.userErrors)));
	    }
	
	    return Promise.reject(new Error("The " + mutationRootKey + " mutation failed due to an unknown error."));
	  };
	}
	
	function query$11(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.id = client.variable("id", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	    });
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("subtotalPrice");
	    root.add("totalPrice");
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("totalShippingPrice");
	      order.add("totalTax");
	      order.add("totalPrice");
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addQuery([variables.__defaultOperation__.id], function (root) {
	    root.add("node", {
	      args: {
	        id: variables.__defaultOperation__.id
	      }
	    }, function (node) {
	      node.addFragment(spreads.CheckoutFragment);
	    });
	  });
	  return document;
	}
	
	function query$12(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.input = client.variable("input", "CheckoutCreateInput!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("subtotalPrice");
	    root.add("totalPrice");
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("totalShippingPrice");
	      order.add("totalTax");
	      order.add("totalPrice");
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.input], function (root) {
	    root.add("checkoutCreate", {
	      args: {
	        input: variables.__defaultOperation__.input
	      }
	    }, function (checkoutCreate) {
	      checkoutCreate.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutCreate.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$13(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
	  variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemInput!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("subtotalPrice");
	    root.add("totalPrice");
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("totalShippingPrice");
	      order.add("totalTax");
	      order.add("totalPrice");
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function (root) {
	    root.add("checkoutLineItemsAdd", {
	      args: {
	        checkoutId: variables.__defaultOperation__.checkoutId,
	        lineItems: variables.__defaultOperation__.lineItems
	      }
	    }, function (checkoutLineItemsAdd) {
	      checkoutLineItemsAdd.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutLineItemsAdd.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$14(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
	  variables.__defaultOperation__.lineItemIds = client.variable("lineItemIds", "[ID!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("subtotalPrice");
	    root.add("totalPrice");
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("totalShippingPrice");
	      order.add("totalTax");
	      order.add("totalPrice");
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItemIds], function (root) {
	    root.add("checkoutLineItemsRemove", {
	      args: {
	        checkoutId: variables.__defaultOperation__.checkoutId,
	        lineItemIds: variables.__defaultOperation__.lineItemIds
	      }
	    }, function (checkoutLineItemsRemove) {
	      checkoutLineItemsRemove.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutLineItemsRemove.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$15(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.__defaultOperation__ = {};
	  variables.__defaultOperation__.checkoutId = client.variable("checkoutId", "ID!");
	  variables.__defaultOperation__.lineItems = client.variable("lineItems", "[CheckoutLineItemUpdateInput!]!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("subtotalPrice");
	    root.add("totalPrice");
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("totalShippingPrice");
	      order.add("totalTax");
	      order.add("totalPrice");
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation([variables.__defaultOperation__.checkoutId, variables.__defaultOperation__.lineItems], function (root) {
	    root.add("checkoutLineItemsUpdate", {
	      args: {
	        checkoutId: variables.__defaultOperation__.checkoutId,
	        lineItems: variables.__defaultOperation__.lineItems
	      }
	    }, function (checkoutLineItemsUpdate) {
	      checkoutLineItemsUpdate.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutLineItemsUpdate.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$16(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutAttributesUpdateV2 = {};
	  variables.checkoutAttributesUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
	  variables.checkoutAttributesUpdateV2.input = client.variable("input", "CheckoutAttributesUpdateV2Input!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("subtotalPrice");
	    root.add("totalPrice");
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("totalShippingPrice");
	      order.add("totalTax");
	      order.add("totalPrice");
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutAttributesUpdateV2", [variables.checkoutAttributesUpdateV2.checkoutId, variables.checkoutAttributesUpdateV2.input], function (root) {
	    root.add("checkoutAttributesUpdateV2", {
	      args: {
	        checkoutId: variables.checkoutAttributesUpdateV2.checkoutId,
	        input: variables.checkoutAttributesUpdateV2.input
	      }
	    }, function (checkoutAttributesUpdateV2) {
	      checkoutAttributesUpdateV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutAttributesUpdateV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$17(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutDiscountCodeApplyV2 = {};
	  variables.checkoutDiscountCodeApplyV2.discountCode = client.variable("discountCode", "String!");
	  variables.checkoutDiscountCodeApplyV2.checkoutId = client.variable("checkoutId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("subtotalPrice");
	    root.add("totalPrice");
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("totalShippingPrice");
	      order.add("totalTax");
	      order.add("totalPrice");
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutDiscountCodeApplyV2", [variables.checkoutDiscountCodeApplyV2.discountCode, variables.checkoutDiscountCodeApplyV2.checkoutId], function (root) {
	    root.add("checkoutDiscountCodeApplyV2", {
	      args: {
	        discountCode: variables.checkoutDiscountCodeApplyV2.discountCode,
	        checkoutId: variables.checkoutDiscountCodeApplyV2.checkoutId
	      }
	    }, function (checkoutDiscountCodeApplyV2) {
	      checkoutDiscountCodeApplyV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutDiscountCodeApplyV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$18(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutDiscountCodeRemove = {};
	  variables.checkoutDiscountCodeRemove.checkoutId = client.variable("checkoutId", "ID!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("subtotalPrice");
	    root.add("totalPrice");
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("totalShippingPrice");
	      order.add("totalTax");
	      order.add("totalPrice");
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutDiscountCodeRemove", [variables.checkoutDiscountCodeRemove.checkoutId], function (root) {
	    root.add("checkoutDiscountCodeRemove", {
	      args: {
	        checkoutId: variables.checkoutDiscountCodeRemove.checkoutId
	      }
	    }, function (checkoutDiscountCodeRemove) {
	      checkoutDiscountCodeRemove.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutDiscountCodeRemove.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	function query$19(client) {
	  var document = client.document();
	  var spreads = {};
	  var variables = {};
	  variables.checkoutEmailUpdateV2 = {};
	  variables.checkoutEmailUpdateV2.checkoutId = client.variable("checkoutId", "ID!");
	  variables.checkoutEmailUpdateV2.email = client.variable("email", "String!");
	  spreads.VariantFragment = document.defineFragment("VariantFragment", "ProductVariant", function (root) {
	    root.add("id");
	    root.add("title");
	    root.add("price");
	    root.add("weight");
	    root.add("availableForSale", {
	      alias: "available"
	    });
	    root.add("sku");
	    root.add("compareAtPrice");
	    root.add("image", function (image) {
	      image.add("id");
	      image.add("originalSrc", {
	        alias: "src"
	      });
	      image.add("altText");
	    });
	    root.add("selectedOptions", function (selectedOptions) {
	      selectedOptions.add("name");
	      selectedOptions.add("value");
	    });
	  });
	  spreads.DiscountApplicationFragment = document.defineFragment("DiscountApplicationFragment", "DiscountApplication", function (root) {
	    root.add("targetSelection");
	    root.add("allocationMethod");
	    root.add("targetType");
	    root.addInlineFragmentOn("ManualDiscountApplication", function (ManualDiscountApplication) {
	      ManualDiscountApplication.add("title");
	      ManualDiscountApplication.add("description");
	    });
	    root.addInlineFragmentOn("DiscountCodeApplication", function (DiscountCodeApplication) {
	      DiscountCodeApplication.add("code");
	      DiscountCodeApplication.add("applicable");
	    });
	    root.addInlineFragmentOn("ScriptDiscountApplication", function (ScriptDiscountApplication) {
	      ScriptDiscountApplication.add("description");
	    });
	  });
	  spreads.VariantWithProductFragment = document.defineFragment("VariantWithProductFragment", "ProductVariant", function (root) {
	    root.addFragment(spreads.VariantFragment);
	    root.add("product", function (product) {
	      product.add("id");
	    });
	  });
	  spreads.UserErrorFragment = document.defineFragment("UserErrorFragment", "UserError", function (root) {
	    root.add("field");
	    root.add("message");
	  });
	  spreads.MailingAddressFragment = document.defineFragment("MailingAddressFragment", "MailingAddress", function (root) {
	    root.add("id");
	    root.add("address1");
	    root.add("address2");
	    root.add("city");
	    root.add("company");
	    root.add("country");
	    root.add("firstName");
	    root.add("formatted");
	    root.add("lastName");
	    root.add("latitude");
	    root.add("longitude");
	    root.add("phone");
	    root.add("province");
	    root.add("zip");
	    root.add("name");
	    root.add("countryCodeV2", {
	      alias: "countryCode"
	    });
	    root.add("provinceCode");
	  });
	  spreads.CheckoutFragment = document.defineFragment("CheckoutFragment", "Checkout", function (root) {
	    root.add("id");
	    root.add("ready");
	    root.add("requiresShipping");
	    root.add("note");
	    root.add("paymentDue");
	    root.add("webUrl");
	    root.add("orderStatusUrl");
	    root.add("taxExempt");
	    root.add("taxesIncluded");
	    root.add("currencyCode");
	    root.add("totalTax");
	    root.add("subtotalPrice");
	    root.add("totalPrice");
	    root.add("completedAt");
	    root.add("createdAt");
	    root.add("updatedAt");
	    root.add("email");
	    root.add("discountApplications", {
	      args: {
	        first: 10
	      }
	    }, function (discountApplications) {
	      discountApplications.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      discountApplications.add("edges", function (edges) {
	        edges.add("node", function (node) {
	          node.addFragment(spreads.DiscountApplicationFragment);
	        });
	      });
	    });
	    root.add("shippingAddress", function (shippingAddress) {
	      shippingAddress.addFragment(spreads.MailingAddressFragment);
	    });
	    root.add("shippingLine", function (shippingLine) {
	      shippingLine.add("handle");
	      shippingLine.add("price");
	      shippingLine.add("title");
	    });
	    root.add("customAttributes", function (customAttributes) {
	      customAttributes.add("key");
	      customAttributes.add("value");
	    });
	    root.add("order", function (order) {
	      order.add("id");
	      order.add("processedAt");
	      order.add("orderNumber");
	      order.add("subtotalPrice");
	      order.add("totalShippingPrice");
	      order.add("totalTax");
	      order.add("totalPrice");
	      order.add("currencyCode");
	      order.add("totalRefunded");
	      order.add("customerUrl");
	      order.add("shippingAddress", function (shippingAddress) {
	        shippingAddress.addFragment(spreads.MailingAddressFragment);
	      });
	      order.add("lineItems", {
	        args: {
	          first: 250
	        }
	      }, function (lineItems) {
	        lineItems.add("pageInfo", function (pageInfo) {
	          pageInfo.add("hasNextPage");
	          pageInfo.add("hasPreviousPage");
	        });
	        lineItems.add("edges", function (edges) {
	          edges.add("cursor");
	          edges.add("node", function (node) {
	            node.add("title");
	            node.add("variant", function (variant) {
	              variant.addFragment(spreads.VariantWithProductFragment);
	            });
	            node.add("quantity");
	            node.add("customAttributes", function (customAttributes) {
	              customAttributes.add("key");
	              customAttributes.add("value");
	            });
	          });
	        });
	      });
	    });
	    root.add("lineItems", {
	      args: {
	        first: 250
	      }
	    }, function (lineItems) {
	      lineItems.add("pageInfo", function (pageInfo) {
	        pageInfo.add("hasNextPage");
	        pageInfo.add("hasPreviousPage");
	      });
	      lineItems.add("edges", function (edges) {
	        edges.add("cursor");
	        edges.add("node", function (node) {
	          node.add("id");
	          node.add("title");
	          node.add("variant", function (variant) {
	            variant.addFragment(spreads.VariantWithProductFragment);
	          });
	          node.add("quantity");
	          node.add("customAttributes", function (customAttributes) {
	            customAttributes.add("key");
	            customAttributes.add("value");
	          });
	          node.add("discountAllocations", function (discountAllocations) {
	            discountAllocations.add("allocatedAmount", function (allocatedAmount) {
	              allocatedAmount.add("amount");
	              allocatedAmount.add("currencyCode");
	            });
	            discountAllocations.add("discountApplication", function (discountApplication) {
	              discountApplication.addFragment(spreads.DiscountApplicationFragment);
	            });
	          });
	        });
	      });
	    });
	  });
	  document.addMutation("checkoutEmailUpdateV2", [variables.checkoutEmailUpdateV2.checkoutId, variables.checkoutEmailUpdateV2.email], function (root) {
	    root.add("checkoutEmailUpdateV2", {
	      args: {
	        checkoutId: variables.checkoutEmailUpdateV2.checkoutId,
	        email: variables.checkoutEmailUpdateV2.email
	      }
	    }, function (checkoutEmailUpdateV2) {
	      checkoutEmailUpdateV2.add("userErrors", function (userErrors) {
	        userErrors.addFragment(spreads.UserErrorFragment);
	      });
	      checkoutEmailUpdateV2.add("checkout", function (checkout) {
	        checkout.addFragment(spreads.CheckoutFragment);
	      });
	    });
	  });
	  return document;
	}
	
	// GraphQL
	/**
	 * The JS Buy SDK checkout resource
	 * @class
	 */
	
	var CheckoutResource = function (_Resource) {
	  inherits$1(CheckoutResource, _Resource);
	
	  function CheckoutResource() {
	    classCallCheck$1(this, CheckoutResource);
	    return possibleConstructorReturn$1(this, (CheckoutResource.__proto__ || Object.getPrototypeOf(CheckoutResource)).apply(this, arguments));
	  }
	
	  createClass$1(CheckoutResource, [{
	    key: 'fetch',
	
	
	    /**
	     * Fetches a checkout by ID.
	     *
	     * @example
	     * client.checkout.fetch('FlZj9rZXlN5MDY4ZDFiZTUyZTUwNTE2MDNhZjg=').then((checkout) => {
	     *   // Do something with the checkout
	     * });
	     *
	     * @param {String} id The id of the checkout to fetch.
	     * @return {Promise|GraphModel} A promise resolving with a `GraphModel` of the checkout.
	     */
	    value: function fetch(id) {
	      var _this2 = this;
	
	      return this.graphQLClient.send(query$11, { id: id }).then(defaultResolver('node')).then(function (checkout) {
	        if (!checkout) {
	          return null;
	        }
	
	        return _this2.graphQLClient.fetchAllPages(checkout.lineItems, { pageSize: 250 }).then(function (lineItems) {
	          checkout.attrs.lineItems = lineItems;
	
	          return checkout;
	        });
	      });
	    }
	
	    /**
	     * Creates a checkout.
	     *
	     * @example
	     * const input = {
	     *   lineItems: [
	     *     {variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}
	     *   ]
	     * };
	     *
	     * client.checkout.create(input).then((checkout) => {
	     *   // Do something with the newly created checkout
	     * });
	     *
	     * @param {Object} [input] An input object containing zero or more of:
	     *   @param {String} [input.email] An email connected to the checkout.
	     *   @param {Object[]} [input.lineItems] A list of line items in the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input_object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
	     *   @param {Object} [input.shippingAddress] A shipping address. See the {@link https://help.shopify.com/api/storefront-api/reference/input_object/mailingaddressinput|Storefront API reference} for valid input fields.
	     *   @param {String} [input.note] A note for the checkout.
	     *   @param {Object[]} [input.customAttributes] A list of custom attributes for the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input_object/attributeinput|Storefront API reference} for valid input fields.
	     * @return {Promise|GraphModel} A promise resolving with the created checkout.
	     */
	
	  }, {
	    key: 'create',
	    value: function create() {
	      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return this.graphQLClient.send(query$12, { input: input }).then(handleCheckoutMutation('checkoutCreate', this.graphQLClient));
	    }
	
	    /**
	     * Replaces the value of checkout's custom attributes and/or note with values defined in the input
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const input = {customAttributes: [{key: "MyKey", value: "MyValue"}]};
	     *
	     * client.checkout.updateAttributes(checkoutId, input).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to update.
	     * @param {Object} [input] An input object containing zero or more of:
	     *   @param {Boolean} [input.allowPartialAddresses] An email connected to the checkout.
	     *   @param {Object[]} [input.customAttributes] A list of custom attributes for the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input_object/attributeinput|Storefront API reference} for valid input fields.
	     *   @param {String} [input.note] A note for the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'updateAttributes',
	    value: function updateAttributes(checkoutId) {
	      var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this.graphQLClient.send(query$16, { checkoutId: checkoutId, input: input }).then(handleCheckoutMutation('checkoutAttributesUpdateV2', this.graphQLClient));
	    }
	
	    /**
	     * Replaces the value of checkout's email address
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const email = 'user@example.com';
	     *
	     * client.checkout.updateEmail(checkoutId, email).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to update.
	     * @param {String} email The email address to apply to the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'updateEmail',
	    value: function updateEmail(checkoutId, email) {
	      return this.graphQLClient.send(query$19, { checkoutId: checkoutId, email: email }).then(handleCheckoutMutation('checkoutEmailUpdateV2', this.graphQLClient));
	    }
	
	    /**
	     * Adds line items to an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const lineItems = [{variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg==', quantity: 5}];
	     *
	     * client.checkout.addLineItems(checkoutId, lineItems).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to add line items to.
	     * @param {Object[]} lineItems A list of line items to add to the checkout. See the {@link https://help.shopify.com/api/storefront-api/reference/input_object/checkoutlineiteminput|Storefront API reference} for valid input fields for each line item.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'addLineItems',
	    value: function addLineItems(checkoutId, lineItems) {
	      return this.graphQLClient.send(query$13, { checkoutId: checkoutId, lineItems: lineItems }).then(handleCheckoutMutation('checkoutLineItemsAdd', this.graphQLClient));
	    }
	
	    /**
	     * Applies a discount to an existing checkout using a discount code.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const discountCode = 'best-discount-ever';
	     *
	     * client.checkout.addDiscount(checkoutId, discountCode).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to add discount to.
	     * @param {String} discountCode The discount code to apply to the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'addDiscount',
	    value: function addDiscount(checkoutId, discountCode) {
	      return this.graphQLClient.send(query$17, { checkoutId: checkoutId, discountCode: discountCode }).then(handleCheckoutMutation('checkoutDiscountCodeApplyV2', this.graphQLClient));
	    }
	
	    /**
	     * Removes the applied discount from an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     *
	     * client.checkout.removeDiscount(checkoutId).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to remove the discount from.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'removeDiscount',
	    value: function removeDiscount(checkoutId) {
	      return this.graphQLClient.send(query$18, { checkoutId: checkoutId }).then(handleCheckoutMutation('checkoutDiscountCodeRemove', this.graphQLClient));
	    }
	
	    /**
	     * Removes line items from an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const lineItemIds = ['TViZGE5Y2U1ZDFhY2FiMmM2YT9rZXk9NTc2YjBhODcwNWIxYzg0YjE5ZjRmZGQ5NjczNGVkZGU='];
	     *
	     * client.checkout.removeLineItems(checkoutId, lineItemIds).then((checkout) => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to remove line items from.
	     * @param {String[]} lineItemIds A list of the ids of line items to remove from the checkout.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'removeLineItems',
	    value: function removeLineItems(checkoutId, lineItemIds) {
	      return this.graphQLClient.send(query$14, { checkoutId: checkoutId, lineItemIds: lineItemIds }).then(handleCheckoutMutation('checkoutLineItemsRemove', this.graphQLClient));
	    }
	
	    /**
	     * Updates line items on an existing checkout.
	     *
	     * @example
	     * const checkoutId = 'Z2lkOi8vc2hvcGlmeS9DaGVja291dC9kMTZmM2EzMDM4Yjc4N=';
	     * const lineItems = [
	     *   {
	     *     id: 'TViZGE5Y2U1ZDFhY2FiMmM2YT9rZXk9NTc2YjBhODcwNWIxYzg0YjE5ZjRmZGQ5NjczNGVkZGU=',
	     *     quantity: 5,
	     *     variantId: 'Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8yOTEwNjAyMjc5Mg=='
	     *   }
	     * ];
	     *
	     * client.checkout.updateLineItems(checkoutId, lineItems).then(checkout => {
	     *   // Do something with the updated checkout
	     * });
	     *
	     * @param {String} checkoutId The ID of the checkout to update a line item on.
	     * @param {Object[]} lineItems A list of line item information to update. See the {@link https://help.shopify.com/api/storefront-api/reference/input_object/checkoutlineitemupdateinput|Storefront API reference} for valid input fields for each line item.
	     * @return {Promise|GraphModel} A promise resolving with the updated checkout.
	     */
	
	  }, {
	    key: 'updateLineItems',
	    value: function updateLineItems(checkoutId, lineItems) {
	      return this.graphQLClient.send(query$15, { checkoutId: checkoutId, lineItems: lineItems }).then(handleCheckoutMutation('checkoutLineItemsUpdate', this.graphQLClient));
	    }
	  }]);
	  return CheckoutResource;
	}(Resource);
	
	/**
	 * @namespace ImageHelpers
	 */
	var imageHelpers = {
	
	  /**
	   * Generates the image src for a resized image with maximum dimensions `maxWidth` and `maxHeight`.
	   * Images do not scale up.
	   *
	   * @example
	   * const url = client.image.helpers.imageForSize(product.variants[0].image, {maxWidth: 50, maxHeight: 50});
	   *
	   * @memberof ImageHelpers
	   * @method imageForSize
	   * @param {Object} image The original image model to generate the image src for.
	   * @param {Object} options An options object containing:
	   *  @param {Integer} options.maxWidth The maximum width for the image.
	   *  @param {Integer} options.maxHeight The maximum height for the image.
	   * @return {String} The image src for the resized image.
	   */
	  imageForSize: function imageForSize(image, _ref) {
	    var maxWidth = _ref.maxWidth,
	        maxHeight = _ref.maxHeight;
	
	    var splitUrl = image.src.split('?');
	    var notQuery = splitUrl[0];
	    var query = splitUrl[1] ? '?' + splitUrl[1] : '';
	
	    // Use the section before the query
	    var imageTokens = notQuery.split('.');
	
	    // Take the token before the file extension and append the dimensions
	    var imagePathIndex = imageTokens.length - 2;
	
	    imageTokens[imagePathIndex] = imageTokens[imagePathIndex] + '_' + maxWidth + 'x' + maxHeight;
	
	    return '' + imageTokens.join('.') + query;
	  }
	};
	
	/**
	 * The JS Buy SDK image resource
	 * @class
	 */
	
	var ImageResource = function (_Resource) {
	  inherits$1(ImageResource, _Resource);
	
	  function ImageResource() {
	    classCallCheck$1(this, ImageResource);
	    return possibleConstructorReturn$1(this, (ImageResource.__proto__ || Object.getPrototypeOf(ImageResource)).apply(this, arguments));
	  }
	
	  createClass$1(ImageResource, [{
	    key: 'helpers',
	    get: function get$$1() {
	      return imageHelpers;
	    }
	  }]);
	  return ImageResource;
	}(Resource);
	
	var version = "1.11.0";
	
	var Boolean$1 = {
	  "name": "Boolean",
	  "kind": "SCALAR"
	};
	
	var String$1 = {
	  "name": "String",
	  "kind": "SCALAR"
	};
	
	var QueryRoot = {
	  "name": "QueryRoot",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "node": "Node",
	    "nodes": "Node",
	    "shop": "Shop"
	  },
	  "implementsNode": false
	};
	
	var Node = {
	  "name": "Node",
	  "kind": "INTERFACE",
	  "fieldBaseTypes": {},
	  "possibleTypes": ["AppliedGiftCard", "Article", "Blog", "Checkout", "CheckoutLineItem", "Collection", "Comment", "MailingAddress", "Order", "Payment", "Product", "ProductOption", "ProductVariant", "ShopPolicy"]
	};
	
	var ID = {
	  "name": "ID",
	  "kind": "SCALAR"
	};
	
	var DateTime = {
	  "name": "DateTime",
	  "kind": "SCALAR"
	};
	
	var MailingAddress = {
	  "name": "MailingAddress",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "address1": "String",
	    "address2": "String",
	    "city": "String",
	    "company": "String",
	    "country": "String",
	    "countryCodeV2": "CountryCode",
	    "firstName": "String",
	    "formatted": "String",
	    "id": "ID",
	    "lastName": "String",
	    "latitude": "Float",
	    "longitude": "Float",
	    "name": "String",
	    "phone": "String",
	    "province": "String",
	    "provinceCode": "String",
	    "zip": "String"
	  },
	  "implementsNode": true
	};
	
	var Float = {
	  "name": "Float",
	  "kind": "SCALAR"
	};
	
	var CountryCode = {
	  "name": "CountryCode",
	  "kind": "ENUM"
	};
	
	var PageInfo = {
	  "name": "PageInfo",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "hasNextPage": "Boolean",
	    "hasPreviousPage": "Boolean"
	  },
	  "implementsNode": false
	};
	
	var Int = {
	  "name": "Int",
	  "kind": "SCALAR"
	};
	
	var Order = {
	  "name": "Order",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "currencyCode": "CurrencyCode",
	    "customerUrl": "URL",
	    "id": "ID",
	    "lineItems": "OrderLineItemConnection",
	    "orderNumber": "Int",
	    "processedAt": "DateTime",
	    "shippingAddress": "MailingAddress",
	    "subtotalPrice": "Money",
	    "totalPrice": "Money",
	    "totalRefunded": "Money",
	    "totalShippingPrice": "Money",
	    "totalTax": "Money"
	  },
	  "implementsNode": true
	};
	
	var Money = {
	  "name": "Money",
	  "kind": "SCALAR"
	};
	
	var CurrencyCode = {
	  "name": "CurrencyCode",
	  "kind": "ENUM"
	};
	
	var URL = {
	  "name": "URL",
	  "kind": "SCALAR"
	};
	
	var DiscountAllocation = {
	  "name": "DiscountAllocation",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "allocatedAmount": "MoneyV2",
	    "discountApplication": "DiscountApplication"
	  },
	  "implementsNode": false
	};
	
	var MoneyV2 = {
	  "name": "MoneyV2",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "amount": "Decimal",
	    "currencyCode": "CurrencyCode"
	  },
	  "implementsNode": false
	};
	
	var Decimal = {
	  "name": "Decimal",
	  "kind": "SCALAR"
	};
	
	var DiscountApplication = {
	  "name": "DiscountApplication",
	  "kind": "INTERFACE",
	  "fieldBaseTypes": {
	    "allocationMethod": "DiscountApplicationAllocationMethod",
	    "targetSelection": "DiscountApplicationTargetSelection",
	    "targetType": "DiscountApplicationTargetType"
	  },
	  "possibleTypes": ["DiscountCodeApplication", "ManualDiscountApplication", "ScriptDiscountApplication"]
	};
	
	var DiscountApplicationAllocationMethod = {
	  "name": "DiscountApplicationAllocationMethod",
	  "kind": "ENUM"
	};
	
	var DiscountApplicationTargetSelection = {
	  "name": "DiscountApplicationTargetSelection",
	  "kind": "ENUM"
	};
	
	var DiscountApplicationTargetType = {
	  "name": "DiscountApplicationTargetType",
	  "kind": "ENUM"
	};
	
	var OrderLineItemConnection = {
	  "name": "OrderLineItemConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "OrderLineItemEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var OrderLineItemEdge = {
	  "name": "OrderLineItemEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "OrderLineItem"
	  },
	  "implementsNode": false
	};
	
	var OrderLineItem = {
	  "name": "OrderLineItem",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "customAttributes": "Attribute",
	    "quantity": "Int",
	    "title": "String",
	    "variant": "ProductVariant"
	  },
	  "implementsNode": false
	};
	
	var ProductVariant = {
	  "name": "ProductVariant",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "availableForSale": "Boolean",
	    "compareAtPrice": "Money",
	    "id": "ID",
	    "image": "Image",
	    "price": "Money",
	    "product": "Product",
	    "selectedOptions": "SelectedOption",
	    "sku": "String",
	    "title": "String",
	    "weight": "Float"
	  },
	  "implementsNode": true
	};
	
	var Image = {
	  "name": "Image",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "altText": "String",
	    "id": "ID",
	    "originalSrc": "URL",
	    "src": "URL"
	  },
	  "implementsNode": false
	};
	
	var SelectedOption = {
	  "name": "SelectedOption",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "name": "String",
	    "value": "String"
	  },
	  "implementsNode": false
	};
	
	var Product = {
	  "name": "Product",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "availableForSale": "Boolean",
	    "createdAt": "DateTime",
	    "description": "String",
	    "descriptionHtml": "HTML",
	    "handle": "String",
	    "id": "ID",
	    "images": "ImageConnection",
	    "onlineStoreUrl": "URL",
	    "options": "ProductOption",
	    "productType": "String",
	    "publishedAt": "DateTime",
	    "title": "String",
	    "updatedAt": "DateTime",
	    "variants": "ProductVariantConnection",
	    "vendor": "String"
	  },
	  "implementsNode": true
	};
	
	var CollectionConnection = {
	  "name": "CollectionConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "CollectionEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var CollectionEdge = {
	  "name": "CollectionEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "Collection"
	  },
	  "implementsNode": false
	};
	
	var Collection = {
	  "name": "Collection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "description": "String",
	    "descriptionHtml": "HTML",
	    "handle": "String",
	    "id": "ID",
	    "image": "Image",
	    "products": "ProductConnection",
	    "title": "String",
	    "updatedAt": "DateTime"
	  },
	  "implementsNode": true
	};
	
	var HTML = {
	  "name": "HTML",
	  "kind": "SCALAR"
	};
	
	var ProductConnection = {
	  "name": "ProductConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "ProductEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var ProductEdge = {
	  "name": "ProductEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "Product"
	  },
	  "implementsNode": false
	};
	
	var ImageConnection = {
	  "name": "ImageConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "ImageEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var ImageEdge = {
	  "name": "ImageEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "Image"
	  },
	  "implementsNode": false
	};
	
	var ProductOption = {
	  "name": "ProductOption",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "name": "String",
	    "values": "String"
	  },
	  "implementsNode": true
	};
	
	var ProductVariantConnection = {
	  "name": "ProductVariantConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "ProductVariantEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var ProductVariantEdge = {
	  "name": "ProductVariantEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "ProductVariant"
	  },
	  "implementsNode": false
	};
	
	var Attribute = {
	  "name": "Attribute",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "key": "String",
	    "value": "String"
	  },
	  "implementsNode": false
	};
	
	var DiscountApplicationConnection = {
	  "name": "DiscountApplicationConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "DiscountApplicationEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var DiscountApplicationEdge = {
	  "name": "DiscountApplicationEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "node": "DiscountApplication"
	  },
	  "implementsNode": false
	};
	
	var Checkout = {
	  "name": "Checkout",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "completedAt": "DateTime",
	    "createdAt": "DateTime",
	    "currencyCode": "CurrencyCode",
	    "customAttributes": "Attribute",
	    "discountApplications": "DiscountApplicationConnection",
	    "email": "String",
	    "id": "ID",
	    "lineItems": "CheckoutLineItemConnection",
	    "note": "String",
	    "order": "Order",
	    "orderStatusUrl": "URL",
	    "paymentDue": "Money",
	    "ready": "Boolean",
	    "requiresShipping": "Boolean",
	    "shippingAddress": "MailingAddress",
	    "shippingLine": "ShippingRate",
	    "subtotalPrice": "Money",
	    "taxExempt": "Boolean",
	    "taxesIncluded": "Boolean",
	    "totalPrice": "Money",
	    "totalTax": "Money",
	    "updatedAt": "DateTime",
	    "webUrl": "URL"
	  },
	  "implementsNode": true
	};
	
	var CheckoutLineItemConnection = {
	  "name": "CheckoutLineItemConnection",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "edges": "CheckoutLineItemEdge",
	    "pageInfo": "PageInfo"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemEdge = {
	  "name": "CheckoutLineItemEdge",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "cursor": "String",
	    "node": "CheckoutLineItem"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItem = {
	  "name": "CheckoutLineItem",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "customAttributes": "Attribute",
	    "discountAllocations": "DiscountAllocation",
	    "id": "ID",
	    "quantity": "Int",
	    "title": "String",
	    "variant": "ProductVariant"
	  },
	  "implementsNode": true
	};
	
	var ShippingRate = {
	  "name": "ShippingRate",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "handle": "String",
	    "price": "Money",
	    "title": "String"
	  },
	  "implementsNode": false
	};
	
	var Shop = {
	  "name": "Shop",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "collectionByHandle": "Collection",
	    "collections": "CollectionConnection",
	    "currencyCode": "CurrencyCode",
	    "description": "String",
	    "moneyFormat": "String",
	    "name": "String",
	    "primaryDomain": "Domain",
	    "privacyPolicy": "ShopPolicy",
	    "productByHandle": "Product",
	    "products": "ProductConnection",
	    "refundPolicy": "ShopPolicy",
	    "termsOfService": "ShopPolicy"
	  },
	  "implementsNode": false
	};
	
	var Domain = {
	  "name": "Domain",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "host": "String",
	    "sslEnabled": "Boolean",
	    "url": "URL"
	  },
	  "implementsNode": false
	};
	
	var ShopPolicy = {
	  "name": "ShopPolicy",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "body": "String",
	    "id": "ID",
	    "title": "String",
	    "url": "URL"
	  },
	  "implementsNode": true
	};
	
	var Mutation$1 = {
	  "name": "Mutation",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkoutAttributesUpdateV2": "CheckoutAttributesUpdateV2Payload",
	    "checkoutCreate": "CheckoutCreatePayload",
	    "checkoutDiscountCodeApplyV2": "CheckoutDiscountCodeApplyV2Payload",
	    "checkoutDiscountCodeRemove": "CheckoutDiscountCodeRemovePayload",
	    "checkoutEmailUpdateV2": "CheckoutEmailUpdateV2Payload",
	    "checkoutLineItemsAdd": "CheckoutLineItemsAddPayload",
	    "checkoutLineItemsRemove": "CheckoutLineItemsRemovePayload",
	    "checkoutLineItemsUpdate": "CheckoutLineItemsUpdatePayload"
	  },
	  "implementsNode": false,
	  "relayInputObjectBaseTypes": {
	    "checkoutAttributesUpdate": "CheckoutAttributesUpdateInput",
	    "checkoutAttributesUpdateV2": "CheckoutAttributesUpdateV2Input",
	    "checkoutCreate": "CheckoutCreateInput",
	    "customerAccessTokenCreate": "CustomerAccessTokenCreateInput",
	    "customerActivate": "CustomerActivateInput",
	    "customerCreate": "CustomerCreateInput",
	    "customerReset": "CustomerResetInput"
	  }
	};
	
	var UserError = {
	  "name": "UserError",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "field": "String",
	    "message": "String"
	  },
	  "implementsNode": false
	};
	
	var CheckoutAttributesUpdateV2Payload = {
	  "name": "CheckoutAttributesUpdateV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutDiscountCodeApplyV2Payload = {
	  "name": "CheckoutDiscountCodeApplyV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutCreatePayload = {
	  "name": "CheckoutCreatePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutEmailUpdateV2Payload = {
	  "name": "CheckoutEmailUpdateV2Payload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutDiscountCodeRemovePayload = {
	  "name": "CheckoutDiscountCodeRemovePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemsAddPayload = {
	  "name": "CheckoutLineItemsAddPayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemsRemovePayload = {
	  "name": "CheckoutLineItemsRemovePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var CheckoutLineItemsUpdatePayload = {
	  "name": "CheckoutLineItemsUpdatePayload",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "checkout": "Checkout",
	    "userErrors": "UserError"
	  },
	  "implementsNode": false
	};
	
	var DiscountCodeApplication = {
	  "name": "DiscountCodeApplication",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "applicable": "Boolean",
	    "code": "String"
	  },
	  "implementsNode": false
	};
	
	var ManualDiscountApplication = {
	  "name": "ManualDiscountApplication",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "description": "String",
	    "title": "String"
	  },
	  "implementsNode": false
	};
	
	var ScriptDiscountApplication = {
	  "name": "ScriptDiscountApplication",
	  "kind": "OBJECT",
	  "fieldBaseTypes": {
	    "description": "String"
	  },
	  "implementsNode": false
	};
	
	var Types = {
	  types: {}
	};
	Types.types["Boolean"] = Boolean$1;
	Types.types["String"] = String$1;
	Types.types["QueryRoot"] = QueryRoot;
	Types.types["Node"] = Node;
	Types.types["ID"] = ID;
	Types.types["DateTime"] = DateTime;
	Types.types["MailingAddress"] = MailingAddress;
	Types.types["Float"] = Float;
	Types.types["CountryCode"] = CountryCode;
	Types.types["PageInfo"] = PageInfo;
	Types.types["Int"] = Int;
	Types.types["Order"] = Order;
	Types.types["Money"] = Money;
	Types.types["CurrencyCode"] = CurrencyCode;
	Types.types["URL"] = URL;
	Types.types["DiscountAllocation"] = DiscountAllocation;
	Types.types["MoneyV2"] = MoneyV2;
	Types.types["Decimal"] = Decimal;
	Types.types["DiscountApplication"] = DiscountApplication;
	Types.types["DiscountApplicationAllocationMethod"] = DiscountApplicationAllocationMethod;
	Types.types["DiscountApplicationTargetSelection"] = DiscountApplicationTargetSelection;
	Types.types["DiscountApplicationTargetType"] = DiscountApplicationTargetType;
	Types.types["OrderLineItemConnection"] = OrderLineItemConnection;
	Types.types["OrderLineItemEdge"] = OrderLineItemEdge;
	Types.types["OrderLineItem"] = OrderLineItem;
	Types.types["ProductVariant"] = ProductVariant;
	Types.types["Image"] = Image;
	Types.types["SelectedOption"] = SelectedOption;
	Types.types["Product"] = Product;
	Types.types["CollectionConnection"] = CollectionConnection;
	Types.types["CollectionEdge"] = CollectionEdge;
	Types.types["Collection"] = Collection;
	Types.types["HTML"] = HTML;
	Types.types["ProductConnection"] = ProductConnection;
	Types.types["ProductEdge"] = ProductEdge;
	Types.types["ImageConnection"] = ImageConnection;
	Types.types["ImageEdge"] = ImageEdge;
	Types.types["ProductOption"] = ProductOption;
	Types.types["ProductVariantConnection"] = ProductVariantConnection;
	Types.types["ProductVariantEdge"] = ProductVariantEdge;
	Types.types["Attribute"] = Attribute;
	Types.types["DiscountApplicationConnection"] = DiscountApplicationConnection;
	Types.types["DiscountApplicationEdge"] = DiscountApplicationEdge;
	Types.types["Checkout"] = Checkout;
	Types.types["CheckoutLineItemConnection"] = CheckoutLineItemConnection;
	Types.types["CheckoutLineItemEdge"] = CheckoutLineItemEdge;
	Types.types["CheckoutLineItem"] = CheckoutLineItem;
	Types.types["ShippingRate"] = ShippingRate;
	Types.types["Shop"] = Shop;
	Types.types["Domain"] = Domain;
	Types.types["ShopPolicy"] = ShopPolicy;
	Types.types["Mutation"] = Mutation$1;
	Types.types["UserError"] = UserError;
	Types.types["CheckoutAttributesUpdateV2Payload"] = CheckoutAttributesUpdateV2Payload;
	Types.types["CheckoutDiscountCodeApplyV2Payload"] = CheckoutDiscountCodeApplyV2Payload;
	Types.types["CheckoutCreatePayload"] = CheckoutCreatePayload;
	Types.types["CheckoutEmailUpdateV2Payload"] = CheckoutEmailUpdateV2Payload;
	Types.types["CheckoutDiscountCodeRemovePayload"] = CheckoutDiscountCodeRemovePayload;
	Types.types["CheckoutLineItemsAddPayload"] = CheckoutLineItemsAddPayload;
	Types.types["CheckoutLineItemsRemovePayload"] = CheckoutLineItemsRemovePayload;
	Types.types["CheckoutLineItemsUpdatePayload"] = CheckoutLineItemsUpdatePayload;
	Types.types["DiscountCodeApplication"] = DiscountCodeApplication;
	Types.types["ManualDiscountApplication"] = ManualDiscountApplication;
	Types.types["ScriptDiscountApplication"] = ScriptDiscountApplication;
	Types.queryType = "QueryRoot";
	Types.mutationType = "Mutation";
	Types.subscriptionType = null;
	
	function recursivelyFreezeObject(structure) {
	  Object.getOwnPropertyNames(structure).forEach(function (key) {
	    var value = structure[key];
	    if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
	      recursivelyFreezeObject(value);
	    }
	  });
	  Object.freeze(structure);
	  return structure;
	}
	
	var types = recursivelyFreezeObject(Types);
	
	// GraphQL
	/**
	 * The JS Buy SDK Client.
	 * @class
	 *
	 * @property {ProductResource} product The property under which product fetching methods live.
	 * @property {CollectionResource} collection The property under which collection fetching methods live.
	 * @property {ShopResource} shop The property under which shop fetching methods live.
	 * @property {CheckoutResource} checkout The property under which shop fetching and mutating methods live.
	 * @property {ImageResource} image The property under which image helper methods live.
	 */
	
	var Client = function () {
	  createClass$1(Client, null, [{
	    key: 'buildClient',
	
	
	    /**
	     * Primary entry point for building a new Client.
	     */
	    value: function buildClient(config, fetchFunction) {
	      var newConfig = new Config(config);
	      var client = new Client(newConfig, Client$2, fetchFunction);
	
	      client.config = newConfig;
	
	      return client;
	    }
	
	    /**
	     * @constructs Client
	     * @param {Config} config An instance of {@link Config} used to configure the Client.
	     */
	
	  }]);
	
	  function Client(config) {
	    var GraphQLClientClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Client$2;
	    var fetchFunction = arguments[2];
	    classCallCheck$1(this, Client);
	
	    var url = 'https://' + config.domain + '/api/graphql';
	
	    var headers = {
	      'X-SDK-Variant': 'javascript',
	      'X-SDK-Version': version,
	      'X-Shopify-Storefront-Access-Token': config.storefrontAccessToken
	    };
	
	    if (fetchFunction) {
	      headers['Content-Type'] = 'application/json';
	      headers.Accept = 'application/json';
	
	      this.graphQLClient = new GraphQLClientClass(types, {
	        fetcher: function fetcher(graphQLParams) {
	          return fetchFunction(url, {
	            body: JSON.stringify(graphQLParams),
	            method: 'POST',
	            mode: 'cors',
	            headers: headers
	          }).then(function (response) {
	            return response.json();
	          });
	        }
	      });
	    } else {
	      this.graphQLClient = new GraphQLClientClass(types, {
	        url: url,
	        fetcherOptions: { headers: headers }
	      });
	    }
	
	    this.product = new ProductResource(this.graphQLClient);
	    this.collection = new CollectionResource(this.graphQLClient);
	    this.shop = new ShopResource(this.graphQLClient);
	    this.checkout = new CheckoutResource(this.graphQLClient);
	    this.image = new ImageResource(this.graphQLClient);
	  }
	
	  /**
	   * Fetches the next page of models
	   *
	   * @example
	   * client.fetchNextPage(products).then((nextProducts) => {
	   *   // Do something with the products
	   * });
	   *
	   * @param {models} [Array] The paginated set to fetch the next page of
	   * @return {Promise|GraphModel[]} A promise resolving with an array of `GraphModel`s of the type provided.
	   */
	
	
	  createClass$1(Client, [{
	    key: 'fetchNextPage',
	    value: function fetchNextPage(models) {
	      return this.graphQLClient.fetchNextPage(models);
	    }
	  }]);
	  return Client;
	}();
	
	module.exports = Client;
	//# sourceMappingURL=index.js.map


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  'after': __webpack_require__(47),
	  'ary': __webpack_require__(62),
	  'before': __webpack_require__(119),
	  'bind': __webpack_require__(120),
	  'bindKey': __webpack_require__(123),
	  'curry': __webpack_require__(124),
	  'curryRight': __webpack_require__(125),
	  'debounce': __webpack_require__(126),
	  'defer': __webpack_require__(128),
	  'delay': __webpack_require__(130),
	  'flip': __webpack_require__(131),
	  'memoize': __webpack_require__(132),
	  'negate': __webpack_require__(157),
	  'once': __webpack_require__(158),
	  'overArgs': __webpack_require__(159),
	  'partial': __webpack_require__(233),
	  'partialRight': __webpack_require__(234),
	  'rearg': __webpack_require__(235),
	  'rest': __webpack_require__(238),
	  'spread': __webpack_require__(239),
	  'throttle': __webpack_require__(242),
	  'unary': __webpack_require__(243),
	  'wrap': __webpack_require__(244)
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(48);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * The opposite of `_.before`; this method creates a function that invokes
	 * `func` once it's called `n` or more times.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {number} n The number of calls before `func` is invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var saves = ['profile', 'settings'];
	 *
	 * var done = _.after(saves.length, function() {
	 *   console.log('done saving!');
	 * });
	 *
	 * _.forEach(saves, function(type) {
	 *   asyncSave({ 'type': type, 'complete': done });
	 * });
	 * // => Logs 'done saving!' after the two async saves have completed.
	 */
	function after(n, func) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n < 1) {
	      return func.apply(this, arguments);
	    }
	  };
	}
	
	module.exports = after;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(49);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(50);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(51),
	    isObject = __webpack_require__(53),
	    isSymbol = __webpack_require__(54);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(52);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(55),
	    isObjectLike = __webpack_require__(61);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(56),
	    getRawTag = __webpack_require__(59),
	    objectToString = __webpack_require__(60);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(57);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(58);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(56);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(63);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_ARY_FLAG = 128;
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments,
	 * ignoring any additional arguments.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} [n=func.length] The arity cap.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new capped function.
	 * @example
	 *
	 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	 * // => [6, 8, 10]
	 */
	function ary(func, n, guard) {
	  n = guard ? undefined : n;
	  n = (func && n == null) ? func.length : n;
	  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	}
	
	module.exports = ary;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(64),
	    createBind = __webpack_require__(75),
	    createCurry = __webpack_require__(78),
	    createHybrid = __webpack_require__(80),
	    createPartial = __webpack_require__(117),
	    getData = __webpack_require__(88),
	    mergeData = __webpack_require__(118),
	    setData = __webpack_require__(97),
	    setWrapToString = __webpack_require__(99),
	    toInteger = __webpack_require__(48);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *    1 - `_.bind`
	 *    2 - `_.bindKey`
	 *    4 - `_.curry` or `_.curryRight` of a bound function
	 *    8 - `_.curry`
	 *   16 - `_.curryRight`
	 *   32 - `_.partial`
	 *   64 - `_.partialRight`
	 *  128 - `_.rearg`
	 *  256 - `_.ary`
	 *  512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] === undefined
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setWrapToString(setter(result, newData), func, bitmask);
	}
	
	module.exports = createWrap;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(65),
	    metaMap = __webpack_require__(66);
	
	/**
	 * The base implementation of `setData` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(67);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68),
	    root = __webpack_require__(57);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(69),
	    getValue = __webpack_require__(74);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(70),
	    isMasked = __webpack_require__(71),
	    isObject = __webpack_require__(53),
	    toSource = __webpack_require__(73);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(55),
	    isObject = __webpack_require__(53);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(72);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(57);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var createCtor = __webpack_require__(76),
	    root = __webpack_require__(57);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBind;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(77),
	    isObject = __webpack_require__(53);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtor;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(53);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(79),
	    createCtor = __webpack_require__(76),
	    createHybrid = __webpack_require__(80),
	    createRecurry = __webpack_require__(84),
	    getHolder = __webpack_require__(113),
	    replaceHolders = __webpack_require__(116),
	    root = __webpack_require__(57);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurry;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(81),
	    composeArgsRight = __webpack_require__(82),
	    countHolders = __webpack_require__(83),
	    createCtor = __webpack_require__(76),
	    createRecurry = __webpack_require__(84),
	    getHolder = __webpack_require__(113),
	    reorder = __webpack_require__(114),
	    replaceHolders = __webpack_require__(116),
	    root = __webpack_require__(57);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_ARY_FLAG = 128,
	    WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & WRAP_ARY_FLAG,
	      isBind = bitmask & WRAP_BIND_FLAG,
	      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	      isFlip = bitmask & WRAP_FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybrid;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      ++result;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var isLaziable = __webpack_require__(85),
	    setData = __webpack_require__(97),
	    setWrapToString = __webpack_require__(99);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & WRAP_CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, argPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	module.exports = createRecurry;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(86),
	    getData = __webpack_require__(88),
	    getFuncName = __webpack_require__(90),
	    lodash = __webpack_require__(92);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(77),
	    baseLodash = __webpack_require__(87);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(66),
	    noop = __webpack_require__(89);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(91);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(86),
	    LodashWrapper = __webpack_require__(93),
	    baseLodash = __webpack_require__(87),
	    isArray = __webpack_require__(94),
	    isObjectLike = __webpack_require__(61),
	    wrapperClone = __webpack_require__(95);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(77),
	    baseLodash = __webpack_require__(87);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(86),
	    LodashWrapper = __webpack_require__(93),
	    copyArray = __webpack_require__(96);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(64),
	    shortOut = __webpack_require__(98);
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity
	 * function to avoid garbage collection pauses in V8. See
	 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = shortOut(baseSetData);
	
	module.exports = setData;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var getWrapDetails = __webpack_require__(100),
	    insertWrapDetails = __webpack_require__(101),
	    setToString = __webpack_require__(102),
	    updateWrapDetails = __webpack_require__(106);
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	function setWrapToString(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	}
	
	module.exports = setWrapToString;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	module.exports = getWrapDetails;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length;
	  if (!length) {
	    return source;
	  }
	  var lastIndex = length - 1;
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	module.exports = insertWrapDetails;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(103),
	    shortOut = __webpack_require__(98);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(104),
	    defineProperty = __webpack_require__(105),
	    identity = __webpack_require__(65);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(107),
	    arrayIncludes = __webpack_require__(108);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_CURRY_RIGHT_FLAG = 16,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_PARTIAL_RIGHT_FLAG = 64,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256,
	    WRAP_FLIP_FLAG = 512;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', WRAP_ARY_FLAG],
	  ['bind', WRAP_BIND_FLAG],
	  ['bindKey', WRAP_BIND_KEY_FLAG],
	  ['curry', WRAP_CURRY_FLAG],
	  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	  ['flip', WRAP_FLIP_FLAG],
	  ['partial', WRAP_PARTIAL_FLAG],
	  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	  ['rearg', WRAP_REARG_FLAG]
	];
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	module.exports = updateWrapDetails;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(109);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(110),
	    baseIsNaN = __webpack_require__(111),
	    strictIndexOf = __webpack_require__(112);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 111 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getHolder;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(96),
	    isIndex = __webpack_require__(115);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(79),
	    createCtor = __webpack_require__(76),
	    root = __webpack_require__(57);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & WRAP_BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartial;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(81),
	    composeArgsRight = __webpack_require__(82),
	    replaceHolders = __webpack_require__(116);
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_CURRY_BOUND_FLAG = 4,
	    WRAP_CURRY_FLAG = 8,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and
	 * `_.rearg` modify function arguments, making the order in which they are
	 * executed important, preventing the merging of metadata. However, we make
	 * an exception for a safe combined case where curried functions have `_.ary`
	 * and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & WRAP_BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = value;
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & WRAP_ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(48);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that invokes `func`, with the `this` binding and arguments
	 * of the created function, while it's called less than `n` times. Subsequent
	 * calls to the created function return the result of the last `func` invocation.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {number} n The number of calls at which `func` is no longer invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * jQuery(element).on('click', _.before(5, addContactToList));
	 * // => Allows adding up to 4 contacts to the list.
	 */
	function before(n, func) {
	  var result;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n > 0) {
	      result = func.apply(this, arguments);
	    }
	    if (n <= 1) {
	      func = undefined;
	    }
	    return result;
	  };
	}
	
	module.exports = before;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(121),
	    createWrap = __webpack_require__(63),
	    getHolder = __webpack_require__(113),
	    replaceHolders = __webpack_require__(116);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of `thisArg`
	 * and `partials` prepended to the arguments it receives.
	 *
	 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	 * property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * function greet(greeting, punctuation) {
	 *   return greeting + ' ' + this.user + punctuation;
	 * }
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * var bound = _.bind(greet, object, 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * // Bound with placeholders.
	 * var bound = _.bind(greet, object, _, '!');
	 * bound('hi');
	 * // => 'hi fred!'
	 */
	var bind = baseRest(function(func, thisArg, partials) {
	  var bitmask = WRAP_BIND_FLAG;
	  if (partials.length) {
	    var holders = replaceHolders(partials, getHolder(bind));
	    bitmask |= WRAP_PARTIAL_FLAG;
	  }
	  return createWrap(func, bitmask, thisArg, partials, holders);
	});
	
	// Assign default placeholders.
	bind.placeholder = {};
	
	module.exports = bind;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(65),
	    overRest = __webpack_require__(122),
	    setToString = __webpack_require__(102);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(79);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(121),
	    createWrap = __webpack_require__(63),
	    getHolder = __webpack_require__(113),
	    replaceHolders = __webpack_require__(116);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_BIND_FLAG = 1,
	    WRAP_BIND_KEY_FLAG = 2,
	    WRAP_PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes the method at `object[key]` with `partials`
	 * prepended to the arguments it receives.
	 *
	 * This method differs from `_.bind` by allowing bound functions to reference
	 * methods that may be redefined or don't yet exist. See
	 * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	 * for more details.
	 *
	 * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Function
	 * @param {Object} object The object to invoke the method on.
	 * @param {string} key The key of the method.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * var object = {
	 *   'user': 'fred',
	 *   'greet': function(greeting, punctuation) {
	 *     return greeting + ' ' + this.user + punctuation;
	 *   }
	 * };
	 *
	 * var bound = _.bindKey(object, 'greet', 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * object.greet = function(greeting, punctuation) {
	 *   return greeting + 'ya ' + this.user + punctuation;
	 * };
	 *
	 * bound('!');
	 * // => 'hiya fred!'
	 *
	 * // Bound with placeholders.
	 * var bound = _.bindKey(object, 'greet', _, '!');
	 * bound('hi');
	 * // => 'hiya fred!'
	 */
	var bindKey = baseRest(function(object, key, partials) {
	  var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	  if (partials.length) {
	    var holders = replaceHolders(partials, getHolder(bindKey));
	    bitmask |= WRAP_PARTIAL_FLAG;
	  }
	  return createWrap(key, bitmask, object, partials, holders);
	});
	
	// Assign default placeholders.
	bindKey.placeholder = {};
	
	module.exports = bindKey;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(63);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8;
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(63);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_RIGHT_FLAG = 16;
	
	/**
	 * This method is like `_.curry` except that arguments are applied to `func`
	 * in the manner of `_.partialRight` instead of `_.partial`.
	 *
	 * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curryRight(abc);
	 *
	 * curried(3)(2)(1);
	 * // => [1, 2, 3]
	 *
	 * curried(2, 3)(1);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(3)(1, _)(2);
	 * // => [1, 2, 3]
	 */
	function curryRight(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curryRight.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curryRight.placeholder = {};
	
	module.exports = curryRight;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(53),
	    now = __webpack_require__(127),
	    toNumber = __webpack_require__(50);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(57);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDelay = __webpack_require__(129),
	    baseRest = __webpack_require__(121);
	
	/**
	 * Defers invoking the `func` until the current call stack has cleared. Any
	 * additional arguments are provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to defer.
	 * @param {...*} [args] The arguments to invoke `func` with.
	 * @returns {number} Returns the timer id.
	 * @example
	 *
	 * _.defer(function(text) {
	 *   console.log(text);
	 * }, 'deferred');
	 * // => Logs 'deferred' after one millisecond.
	 */
	var defer = baseRest(function(func, args) {
	  return baseDelay(func, 1, args);
	});
	
	module.exports = defer;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * The base implementation of `_.delay` and `_.defer` which accepts `args`
	 * to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {Array} args The arguments to provide to `func`.
	 * @returns {number|Object} Returns the timer id or timeout object.
	 */
	function baseDelay(func, wait, args) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return setTimeout(function() { func.apply(undefined, args); }, wait);
	}
	
	module.exports = baseDelay;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDelay = __webpack_require__(129),
	    baseRest = __webpack_require__(121),
	    toNumber = __webpack_require__(50);
	
	/**
	 * Invokes `func` after `wait` milliseconds. Any additional arguments are
	 * provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {...*} [args] The arguments to invoke `func` with.
	 * @returns {number} Returns the timer id.
	 * @example
	 *
	 * _.delay(function(text) {
	 *   console.log(text);
	 * }, 1000, 'later');
	 * // => Logs 'later' after one second.
	 */
	var delay = baseRest(function(func, wait, args) {
	  return baseDelay(func, toNumber(wait) || 0, args);
	});
	
	module.exports = delay;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(63);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_FLIP_FLAG = 512;
	
	/**
	 * Creates a function that invokes `func` with arguments reversed.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Function
	 * @param {Function} func The function to flip arguments for.
	 * @returns {Function} Returns the new flipped function.
	 * @example
	 *
	 * var flipped = _.flip(function() {
	 *   return _.toArray(arguments);
	 * });
	 *
	 * flipped('a', 'b', 'c', 'd');
	 * // => ['d', 'c', 'b', 'a']
	 */
	function flip(func) {
	  return createWrap(func, WRAP_FLIP_FLAG);
	}
	
	module.exports = flip;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(133);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(134),
	    mapCacheDelete = __webpack_require__(151),
	    mapCacheGet = __webpack_require__(154),
	    mapCacheHas = __webpack_require__(155),
	    mapCacheSet = __webpack_require__(156);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(135),
	    ListCache = __webpack_require__(142),
	    Map = __webpack_require__(150);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(136),
	    hashDelete = __webpack_require__(138),
	    hashGet = __webpack_require__(139),
	    hashHas = __webpack_require__(140),
	    hashSet = __webpack_require__(141);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(137);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(137);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(137);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(137);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(143),
	    listCacheDelete = __webpack_require__(144),
	    listCacheGet = __webpack_require__(147),
	    listCacheHas = __webpack_require__(148),
	    listCacheSet = __webpack_require__(149);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 143 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(145);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(146);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(145);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(145);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(145);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68),
	    root = __webpack_require__(57);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(152);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(153);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(152);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(152);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(152);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new negated function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    var args = arguments;
	    switch (args.length) {
	      case 0: return !predicate.call(this);
	      case 1: return !predicate.call(this, args[0]);
	      case 2: return !predicate.call(this, args[0], args[1]);
	      case 3: return !predicate.call(this, args[0], args[1], args[2]);
	    }
	    return !predicate.apply(this, args);
	  };
	}
	
	module.exports = negate;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var before = __webpack_require__(119);
	
	/**
	 * Creates a function that is restricted to invoking `func` once. Repeat calls
	 * to the function return the value of the first invocation. The `func` is
	 * invoked with the `this` binding and arguments of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var initialize = _.once(createApplication);
	 * initialize();
	 * initialize();
	 * // => `createApplication` is invoked once
	 */
	function once(func) {
	  return before(2, func);
	}
	
	module.exports = once;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(79),
	    arrayMap = __webpack_require__(160),
	    baseFlatten = __webpack_require__(161),
	    baseIteratee = __webpack_require__(166),
	    baseRest = __webpack_require__(121),
	    baseUnary = __webpack_require__(202),
	    castRest = __webpack_require__(232),
	    isArray = __webpack_require__(94);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Creates a function that invokes `func` with its arguments transformed.
	 *
	 * @static
	 * @since 4.0.0
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to wrap.
	 * @param {...(Function|Function[])} [transforms=[_.identity]]
	 *  The argument transforms.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * function doubled(n) {
	 *   return n * 2;
	 * }
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var func = _.overArgs(function(x, y) {
	 *   return [x, y];
	 * }, [square, doubled]);
	 *
	 * func(9, 3);
	 * // => [81, 6]
	 *
	 * func(10, 5);
	 * // => [100, 10]
	 */
	var overArgs = castRest(function(func, transforms) {
	  transforms = (transforms.length == 1 && isArray(transforms[0]))
	    ? arrayMap(transforms[0], baseUnary(baseIteratee))
	    : arrayMap(baseFlatten(transforms, 1), baseUnary(baseIteratee));
	
	  var funcsLength = transforms.length;
	  return baseRest(function(args) {
	    var index = -1,
	        length = nativeMin(args.length, funcsLength);
	
	    while (++index < length) {
	      args[index] = transforms[index].call(this, args[index]);
	    }
	    return apply(func, this, args);
	  });
	});
	
	module.exports = overArgs;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(162),
	    isFlattenable = __webpack_require__(163);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(56),
	    isArguments = __webpack_require__(164),
	    isArray = __webpack_require__(94);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(165),
	    isObjectLike = __webpack_require__(61);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(55),
	    isObjectLike = __webpack_require__(61);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(167),
	    baseMatchesProperty = __webpack_require__(216),
	    identity = __webpack_require__(65),
	    isArray = __webpack_require__(94),
	    property = __webpack_require__(229);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(168),
	    getMatchData = __webpack_require__(213),
	    matchesStrictComparable = __webpack_require__(215);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(169),
	    baseIsEqual = __webpack_require__(175);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(142),
	    stackClear = __webpack_require__(170),
	    stackDelete = __webpack_require__(171),
	    stackGet = __webpack_require__(172),
	    stackHas = __webpack_require__(173),
	    stackSet = __webpack_require__(174);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(142);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 171 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(142),
	    Map = __webpack_require__(150),
	    MapCache = __webpack_require__(133);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(176),
	    isObjectLike = __webpack_require__(61);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(169),
	    equalArrays = __webpack_require__(177),
	    equalByTag = __webpack_require__(183),
	    equalObjects = __webpack_require__(187),
	    getTag = __webpack_require__(209),
	    isArray = __webpack_require__(94),
	    isBuffer = __webpack_require__(196),
	    isTypedArray = __webpack_require__(199);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(178),
	    arraySome = __webpack_require__(181),
	    cacheHas = __webpack_require__(182);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(133),
	    setCacheAdd = __webpack_require__(179),
	    setCacheHas = __webpack_require__(180);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 179 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 182 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(56),
	    Uint8Array = __webpack_require__(184),
	    eq = __webpack_require__(146),
	    equalArrays = __webpack_require__(177),
	    mapToArray = __webpack_require__(185),
	    setToArray = __webpack_require__(186);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(57);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(188);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(189),
	    getSymbols = __webpack_require__(190),
	    keys = __webpack_require__(193);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(162),
	    isArray = __webpack_require__(94);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(191),
	    stubArray = __webpack_require__(192);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(194),
	    baseKeys = __webpack_require__(204),
	    isArrayLike = __webpack_require__(208);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(195),
	    isArguments = __webpack_require__(164),
	    isArray = __webpack_require__(94),
	    isBuffer = __webpack_require__(196),
	    isIndex = __webpack_require__(115),
	    isTypedArray = __webpack_require__(199);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(57),
	    stubFalse = __webpack_require__(198);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(197)(module)))

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 198 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(200),
	    baseUnary = __webpack_require__(202),
	    nodeUtil = __webpack_require__(203);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(55),
	    isLength = __webpack_require__(201),
	    isObjectLike = __webpack_require__(61);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 202 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(58);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(197)(module)))

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(205),
	    nativeKeys = __webpack_require__(206);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 205 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(207);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(70),
	    isLength = __webpack_require__(201);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(210),
	    Map = __webpack_require__(150),
	    Promise = __webpack_require__(211),
	    Set = __webpack_require__(212),
	    WeakMap = __webpack_require__(67),
	    baseGetTag = __webpack_require__(55),
	    toSource = __webpack_require__(73);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68),
	    root = __webpack_require__(57);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68),
	    root = __webpack_require__(57);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(68),
	    root = __webpack_require__(57);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(214),
	    keys = __webpack_require__(193);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(53);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 215 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(175),
	    get = __webpack_require__(217),
	    hasIn = __webpack_require__(226),
	    isKey = __webpack_require__(220),
	    isStrictComparable = __webpack_require__(214),
	    matchesStrictComparable = __webpack_require__(215),
	    toKey = __webpack_require__(225);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(218);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(219),
	    toKey = __webpack_require__(225);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(94),
	    isKey = __webpack_require__(220),
	    stringToPath = __webpack_require__(221),
	    toString = __webpack_require__(223);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(94),
	    isSymbol = __webpack_require__(54);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(222);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(132);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(224);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(56),
	    arrayMap = __webpack_require__(160),
	    isArray = __webpack_require__(94),
	    isSymbol = __webpack_require__(54);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(54);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(227),
	    hasPath = __webpack_require__(228);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(219),
	    isArguments = __webpack_require__(164),
	    isArray = __webpack_require__(94),
	    isIndex = __webpack_require__(115),
	    isLength = __webpack_require__(201),
	    toKey = __webpack_require__(225);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(230),
	    basePropertyDeep = __webpack_require__(231),
	    isKey = __webpack_require__(220),
	    toKey = __webpack_require__(225);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(218);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(121);
	
	/**
	 * A `baseRest` alias which can be replaced with `identity` by module
	 * replacement plugins.
	 *
	 * @private
	 * @type {Function}
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	var castRest = baseRest;
	
	module.exports = castRest;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(121),
	    createWrap = __webpack_require__(63),
	    getHolder = __webpack_require__(113),
	    replaceHolders = __webpack_require__(116);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with `partials` prepended to the
	 * arguments it receives. This method is like `_.bind` except it does **not**
	 * alter the `this` binding.
	 *
	 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.2.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var sayHelloTo = _.partial(greet, 'hello');
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 *
	 * // Partially applied with placeholders.
	 * var greetFred = _.partial(greet, _, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 */
	var partial = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partial));
	  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partial.placeholder = {};
	
	module.exports = partial;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(121),
	    createWrap = __webpack_require__(63),
	    getHolder = __webpack_require__(113),
	    replaceHolders = __webpack_require__(116);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * This method is like `_.partial` except that partially applied arguments
	 * are appended to the arguments it receives.
	 *
	 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * function greet(greeting, name) {
	 *   return greeting + ' ' + name;
	 * }
	 *
	 * var greetFred = _.partialRight(greet, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 *
	 * // Partially applied with placeholders.
	 * var sayHelloTo = _.partialRight(greet, 'hello', _);
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 */
	var partialRight = baseRest(function(func, partials) {
	  var holders = replaceHolders(partials, getHolder(partialRight));
	  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partialRight.placeholder = {};
	
	module.exports = partialRight;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	var createWrap = __webpack_require__(63),
	    flatRest = __webpack_require__(236);
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a function that invokes `func` with arguments arranged according
	 * to the specified `indexes` where the argument value at the first index is
	 * provided as the first argument, the argument value at the second index is
	 * provided as the second argument, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} func The function to rearrange arguments for.
	 * @param {...(number|number[])} indexes The arranged argument indexes.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var rearged = _.rearg(function(a, b, c) {
	 *   return [a, b, c];
	 * }, [2, 0, 1]);
	 *
	 * rearged('b', 'c', 'a')
	 * // => ['a', 'b', 'c']
	 */
	var rearg = flatRest(function(func, indexes) {
	  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	});
	
	module.exports = rearg;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(237),
	    overRest = __webpack_require__(122),
	    setToString = __webpack_require__(102);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(161);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(121),
	    toInteger = __webpack_require__(48);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as
	 * an array.
	 *
	 * **Note:** This method is based on the
	 * [rest parameter](https://mdn.io/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.rest(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function rest(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = start === undefined ? start : toInteger(start);
	  return baseRest(func, start);
	}
	
	module.exports = rest;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(79),
	    arrayPush = __webpack_require__(162),
	    baseRest = __webpack_require__(121),
	    castSlice = __webpack_require__(240),
	    toInteger = __webpack_require__(48);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * create function and an array of arguments much like
	 * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	 *
	 * **Note:** This method is based on the
	 * [spread operator](https://mdn.io/spread_operator).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.2.0
	 * @category Function
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} [start=0] The start position of the spread.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.spread(function(who, what) {
	 *   return who + ' says ' + what;
	 * });
	 *
	 * say(['fred', 'hello']);
	 * // => 'fred says hello'
	 *
	 * var numbers = Promise.all([
	 *   Promise.resolve(40),
	 *   Promise.resolve(36)
	 * ]);
	 *
	 * numbers.then(_.spread(function(x, y) {
	 *   return x + y;
	 * }));
	 * // => a Promise of 76
	 */
	function spread(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = start == null ? 0 : nativeMax(toInteger(start), 0);
	  return baseRest(function(args) {
	    var array = args[start],
	        otherArgs = castSlice(args, 0, start);
	
	    if (array) {
	      arrayPush(otherArgs, array);
	    }
	    return apply(func, this, otherArgs);
	  });
	}
	
	module.exports = spread;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(241);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),
/* 241 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(126),
	    isObject = __webpack_require__(53);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var ary = __webpack_require__(62);
	
	/**
	 * Creates a function that accepts up to one argument, ignoring any
	 * additional arguments.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Function
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 * @example
	 *
	 * _.map(['6', '8', '10'], _.unary(parseInt));
	 * // => [6, 8, 10]
	 */
	function unary(func) {
	  return ary(func, 1);
	}
	
	module.exports = unary;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var castFunction = __webpack_require__(245),
	    partial = __webpack_require__(233);
	
	/**
	 * Creates a function that provides `value` to `wrapper` as its first
	 * argument. Any additional arguments provided to the function are appended
	 * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	 * binding of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {*} value The value to wrap.
	 * @param {Function} [wrapper=identity] The wrapper function.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var p = _.wrap(_.escape, function(func, text) {
	 *   return '<p>' + func(text) + '</p>';
	 * });
	 *
	 * p('fred, barney, & pebbles');
	 * // => '<p>fred, barney, &amp; pebbles</p>'
	 */
	function wrap(value, wrapper) {
	  return partial(castFunction(wrapper), value);
	}
	
	module.exports = wrap;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(65);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js